// AUTO-GENERATED by typescript-fetch-gen. DO NOT EDIT BY HAND.
/* eslint-disable */
import { z } from "zod";
export class ApiError extends Error {
    kind;
    status;
    statusText;
    headers;
    body;
    issues;
    contentType;
    /** `request-validation` only: the operation and parameter that failed. */
    operation;
    parameter;
    detail;
    cause;
    constructor(detail) {
        super(formatApiError(detail));
        this.name = "ApiError";
        this.detail = detail;
        this.kind = detail.kind;
        logApiError(detail);
        if (detail.kind === "validation") {
            this.status = detail.status;
            this.statusText = detail.statusText;
            this.headers = detail.headers;
            this.issues = detail.issues;
            this.body = detail.body;
        }
        else if (detail.kind === "undeclared-status") {
            this.status = detail.status;
            this.statusText = detail.statusText;
            this.headers = detail.headers;
            this.body = detail.body;
        }
        else if (detail.kind === "parse") {
            this.status = detail.status;
            this.statusText = detail.statusText;
            this.headers = detail.headers;
            this.body = detail.body;
            this.cause = detail.cause;
        }
        else if (detail.kind === "content-type-mismatch") {
            this.status = detail.status;
            this.statusText = detail.statusText;
            this.headers = detail.headers;
            this.contentType = detail.contentType;
        }
        else if (detail.kind === "request-validation") {
            this.operation = detail.operation;
            this.parameter = detail.parameter;
            this.issues = detail.issues;
            this.body = detail.value;
        }
        else {
            this.cause = detail.cause;
        }
    }
}
function safeJson(v) {
    try {
        return JSON.stringify(v);
    }
    catch {
        return String(v);
    }
}
function logApiError(d) {
    switch (d.kind) {
        case "validation": {
            const issues = d.issues.map((i) => ({ path: formatPath(i.path), message: i.message, code: i.code }));
            const summary = issues.map((i) => `${i.path}: ${i.message} [${i.code}]`).join("; ");
            console.error(`[ApiError] validation failed (status ${d.status}): ${summary}`, { issues, body: d.body, bodyJson: safeJson(d.body) });
            return;
        }
        case "undeclared-status":
            console.error("[ApiError] undeclared response status", {
                status: d.status,
                statusText: d.statusText,
                body: d.body,
            });
            return;
        case "parse":
            console.error("[ApiError] failed to parse JSON body", {
                status: d.status,
                statusText: d.statusText,
                cause: d.cause,
                body: d.body,
            });
            return;
        case "content-type-mismatch":
            console.error("[ApiError] content-type mismatch", {
                status: d.status,
                statusText: d.statusText,
                contentType: d.contentType,
            });
            return;
        case "network":
            console.error("[ApiError] network error", { cause: d.cause });
            return;
        case "request-validation": {
            const issues = d.issues.map((i) => ({ path: formatPath(i.path), message: i.message, code: i.code }));
            const summary = issues.map((i) => `${i.path}: ${i.message} [${i.code}]`).join("; ");
            console.error(`[ApiError] request ${d.location} parameter "${d.parameter}" of ${d.operation} is invalid: ${summary}`, { issues, value: d.value, valueJson: safeJson(d.value) });
            return;
        }
    }
}
function formatApiError(d) {
    switch (d.kind) {
        case "validation":
            return `validation failed (status ${d.status}): ${d.issues
                .map((i) => `${formatPath(i.path)}: ${i.message}`)
                .join("; ")}`;
        case "undeclared-status":
            return `undeclared response status: ${d.status}`;
        case "parse":
            return `failed to parse response body as JSON (status ${d.status}): ${String(d.cause)}`;
        case "content-type-mismatch":
            return `expected JSON response but server sent Content-Type: ${d.contentType} (status ${d.status})`;
        case "network":
            return `network error: ${String(d.cause)}`;
        case "request-validation":
            return `request ${d.location} parameter "${d.parameter}" of ${d.operation} is invalid: ${d.issues
                .map((i) => `${formatPath(i.path)}: ${i.message}`)
                .join("; ")}`;
    }
}
function formatPath(p) {
    if (!p || p.length === 0)
        return "<root>";
    return p.map((s) => String(s)).join(".");
}
// ---------- oneOf helper ----------
// OpenAPI's `oneOf` (without a discriminator) requires *exactly one* variant to match.
// Zod's `z.union` is `anyOf`-style (first match wins). We run the exactly-one check
// on the raw input via `z.unknown().superRefine`, then pipe through `z.union(schemas)`
// to produce the typed (and transformed — e.g. ISO-string→Luxon-DateTime) output.
// Counting on the raw input matters: re-parsing a transformed value against the
// original (string-shaped) schema would always fail and report 0 matches.
export function vOneOf(schemas) {
    return z.unknown()
        .superRefine((val, ctx) => {
        let matches = 0;
        for (const s of schemas) {
            const r = s.safeParse(val);
            if (r.success) {
                matches++;
                if (matches > 1)
                    break;
            }
        }
        if (matches !== 1) {
            ctx.addIssue({
                code: "custom",
                message: `oneOf: ${matches} variants matched, expected exactly 1`,
            });
        }
    })
        .pipe(z.union(schemas));
}
export function vDiscriminatedUnion(property, tags, schemas) {
    return z.unknown().transform((val, ctx) => {
        if (typeof val !== "object" || val === null || Array.isArray(val)) {
            ctx.addIssue({
                code: "custom",
                message: `expected an object with discriminator "${property}"`,
            });
            return z.NEVER;
        }
        const record = val;
        const idx = tags.findIndex((t) => t === record[property]);
        const variant = idx >= 0 ? schemas[idx] : undefined;
        if (!variant) {
            ctx.addIssue({
                code: "custom",
                message: `discriminator "${property}" = ${JSON.stringify(record[property])} matched no variant`,
            });
            return z.NEVER;
        }
        // Validate the body against the chosen variant, with the discriminator
        // removed (the variant schemas are strict and don't declare it).
        const { [property]: _discriminator, ...rest } = record;
        const result = variant.safeParse(rest);
        if (!result.success) {
            ctx.addIssue({
                code: "custom",
                message: `discriminated variant "${tags[idx]}" did not validate: ${result.error.message}`,
            });
            return z.NEVER;
        }
        return {
            ...result.data,
            [property]: tags[idx],
        };
    });
}
// ---------- date/time helpers ----------
// `dates = "iso-string"` mode: wire date/time values stay plain `string`s
// (ts_gen_shared::Target::Server lowers the TS type), validated with Zod's own
// ISO checks — the emitted client has NO luxon dependency. For consumers whose
// call sites treat wire dates as strings (render, compare, slice), a Luxon
// transform would infect every property access; this mode keeps the wire shape.
/// Wire-side validator for `format: date-time` (also accepts `format: date` —
/// both lower to the same IR kind): asserts the value is an ISO 8601 date-time
/// (`Z` or `±hh:mm` offset) or a bare calendar date, and returns the string
/// UNCHANGED.
export function vDateTime() {
    return z.union([z.iso.datetime({ offset: true }), z.iso.date()]);
}
/// Wire-side validator for `format: duration` (ISO 8601 duration like
/// `PT5M30S`): asserts the shape and returns the string unchanged.
export function vDuration() {
    return z.iso.duration();
}
// ---------- contentMediaType: application/json ----------
/// Wire-side validator for a `type: string` schema annotated
/// `contentMediaType: application/json` with NO `contentEncoding` — the string
/// IS a JSON document (not a base64/other-encoded blob). The value stays a
/// string: we don't decode it into the parsed object, we only assert it
/// *parses* as JSON, and — when the spec declared a `contentSchema` — that the
/// decoded value satisfies that schema. Rejects with a Zod issue otherwise,
/// which the generated client surfaces as `ApiError({ kind: "validation" })`.
export function vJsonString(inner) {
    return z.string().superRefine((s, ctx) => {
        let parsed;
        try {
            parsed = JSON.parse(s);
        }
        catch (cause) {
            ctx.addIssue({
                code: "custom",
                message: `expected a JSON-encoded string (contentMediaType: application/json): ${String(cause)}`,
            });
            return;
        }
        if (inner) {
            const r = inner.safeParse(parsed);
            if (!r.success) {
                for (const issue of r.error.issues) {
                    // Re-root the decoded-payload issues under a marker segment so the
                    // path makes clear they're inside the JSON string, not siblings of it.
                    ctx.addIssue({ ...issue, path: ["<contentSchema>", ...issue.path] });
                }
            }
        }
    });
}
/// Predicate behind a `uniqueItems: true` array's `.refine`.
///
/// NOT `new Set(items).size === items.length`: a `Set` compares by reference
/// for anything non-primitive, so that form silently passes arrays JSON Schema
/// rejects. Keying on `typeof` + the string form is exact for [`UniqueItem`] —
/// and the `typeof` prefix keeps `1` and `"1"` apart, which a bare `String()`
/// key would collapse.
export function itemsAreUnique(items) {
    const seen = new Set();
    for (const item of items) {
        const key = `${typeof item}:${String(item)}`;
        if (seen.has(key))
            return false;
        seen.add(key);
    }
    return true;
}
// ---------- request helpers ----------
/// Encode one value for a query string, URL-encoded form field, or multipart form
/// field. **Opinionated**: scalars (`string`, `number`, `boolean`) go verbatim;
/// *everything else*
/// — arrays, objects, `null` — is JSON-encoded so the server sees a single,
/// unambiguous token. This avoids bracket-notation gymnastics (`k[0]=1`, `k[]=1`,
/// `k=1,2`) and keeps the encoding coherent as schemas grow: an array of objects
/// encodes the same way as an array of strings, and a nested object doesn't turn
/// into `"[object Object]"`. `undefined` is coerced to the JSON `null` literal —
/// call sites that mean "omit" should guard before calling this.
export function encodeFormValue(value) {
    if (typeof value === "string")
        return value;
    if (typeof value === "number" || typeof value === "boolean")
        return String(value);
    return JSON.stringify(value ?? null);
}
/// Set a query parameter. Undefined and null are skipped entirely (the caller gets
/// no `?k=null` surprise).
///
/// `jsonEncoded` tracks how the spec declared the parameter:
///   - `false` (plain `schema: { type: ... }`) — the value is rendered as a scalar
///     token (`String(value)`). The lowering pass already refused anything non-
///     primitive for this case, so we can trust `value` to stringify cleanly.
///   - `true` (`content: { "application/json": ... }`) — the value is a JSON
///     document, rendered as `JSON.stringify(value)` regardless of shape. This is
///     the OpenAPI-blessed form for complex query values.
export function appendQueryParam(url, name, value, jsonEncoded) {
    if (value === undefined || value === null)
        return;
    url.searchParams.set(name, jsonEncoded ? JSON.stringify(value) : String(value));
}
/**
 * Validate one outgoing path / query / header parameter against its schema,
 * before the request is built.
 *
 * The mirror image of `validateBody`, and gated on the same `strictValidation`
 * switch so the two directions can't drift:
 *
 * `strictValidation: true` (dev / `VITE_STRICT_VALIDATION`) throws an
 * `ApiError({kind:"request-validation"})` **without issuing the request**. The
 * call site is the bug — a `maxItems: 64` array with 65 entries, an id that
 * doesn't match its `pattern` — and failing here names the parameter instead of
 * letting the server answer 400 (or, past a proxy's URL limit, a bare
 * `text/plain` 400 with no diagnosable body at all).
 *
 * `strictValidation: false` (release builds) makes it advisory: a warning with
 * the same structured detail goes to the console **and the request is sent
 * anyway**. A newly-tightened constraint must never turn a working production
 * call into a client-side throw; the server remains the authority on what it
 * will accept, and the warning is how the drift gets noticed.
 *
 * The value is validated in its *wire* form (`JSON.parse(JSON.stringify(v))`),
 * because that is what the schema describes: a `date-time` parameter is a Luxon
 * `DateTime` in TypeScript and an ISO string on the wire, and `vDateTime()`
 * validates the latter. `undefined` / `null` are skipped — `appendQueryParam`
 * omits them, so there is nothing being sent to validate.
 */
export function validateRequestParam(operation, location, parameter, schema, value, strictValidation) {
    if (value === undefined || value === null)
        return;
    let wire;
    try {
        wire = JSON.parse(JSON.stringify(value));
    }
    catch {
        // Not JSON-serializable (a cycle, a BigInt). Serializing it for the wire
        // is about to fail on its own terms with a better message than anything a
        // schema mismatch would report — don't pre-empt it.
        return;
    }
    const r = schema.safeParse(wire);
    if (r.success)
        return;
    if (strictValidation) {
        throw new ApiError({ kind: "request-validation", operation, parameter, location, issues: r.error.issues, value });
    }
    const issues = r.error.issues.map((i) => ({ path: formatPath(i.path), message: i.message, code: i.code }));
    console.warn(`[ApiClient] request ${location} parameter "${parameter}" of ${operation} does not match its schema; sending anyway: ` +
        issues.map((i) => `${i.path}: ${i.message} [${i.code}]`).join("; "), { issues, value, valueJson: safeJson(value) });
}
// ---------- response helpers ----------
// These are called from the per-operation `switch (res.status)` block in each
// generated method. Keeping them tiny + non-generic over the response map means we
// can return cleanly-typed `{ status: 200; body: User; headers }` literals from each
// `case`, with no type laundering.
export function parseJsonBody(raw, res) {
    if (raw.length === 0)
        return null;
    try {
        return JSON.parse(raw);
    }
    catch (cause) {
        throw new ApiError({
            kind: "parse",
            status: res.status,
            statusText: res.statusText,
            headers: res.headers,
            body: raw,
            cause,
        });
    }
}
/**
 * Validate a parsed response body against its Zod schema.
 *
 * `strictValidation: true` (the default) throws an `ApiError({kind:"validation"})`
 * when the body doesn't match — surfacing spec drift early and loudly, so it
 * gets fixed at the source.
 *
 * `strictValidation: false` makes validation advisory: a warning with the same
 * structured detail goes to the console, and the body is salvage-parsed via
 * `lenientParse` so load-bearing transforms (Luxon DateTime/Duration) still
 * fire on fields that match the schema, while drifting fields pass through
 * as their raw value. This is useful when the server response is *almost*
 * right — extra fields, `null` where the schema wanted a value, a renamed
 * variant — and the page would otherwise crash later trying to call
 * `.toFormat()` on a string.
 */
export function validateBody(schema, value, res, strictValidation) {
    const r = schema.safeParse(value);
    if (r.success)
        return r.data;
    if (strictValidation) {
        throw new ApiError({
            kind: "validation",
            status: res.status,
            statusText: res.statusText,
            headers: res.headers,
            issues: r.error.issues,
            body: value,
        });
    }
    try {
        const salvaged = lenientParse(schema, value);
        logLenientValidationWarning({
            status: res.status,
            statusText: res.statusText,
            issues: salvaged.issues,
            body: value,
        });
        return salvaged.data;
    }
    catch (cause) {
        // Defensive: lenientParse reaches into Zod internals (`_def.innerType`),
        // so a future Zod upgrade could break that read. Don't escalate a soft
        // validation failure into a hard runtime crash — fall back to the
        // pre-salvage behavior (raw cast) and log the salvage failure.
        console.warn("[ApiClient] lenientParse threw; falling back to raw cast", { cause, status: res.status, body: value });
        logLenientValidationWarning({
            status: res.status,
            statusText: res.statusText,
            issues: r.error.issues,
            body: value,
        });
        return value;
    }
}
/**
 * Salvage-parse: try the full schema first; on failure, recurse into
 * `ZodObject` and `ZodArray` children and parse each child independently.
 * Children that parse keep their transforms (Luxon DateTime/Duration);
 * children that don't pass through as their raw value. Issues from the
 * outer parse that the per-field recursion can't rediscover — chiefly
 * `unrecognized_keys` from `.strict()` — are preserved so the warning log
 * still names the drift.
 *
 * Discriminated unions (`vOneOf` / `z.union`) are treated as leaves: we
 * keep the raw value rather than guess a variant.
 */
export function lenientParse(schema, value) {
    const r = schema.safeParse(value);
    if (r.success)
        return { data: r.data, issues: [] };
    const inner = unwrapWrappers(schema);
    if (inner instanceof z.ZodObject && isPlainObject(value)) {
        const shape = inner.shape;
        const out = { ...value };
        const issues = [];
        for (const [k, fieldSchema] of Object.entries(shape)) {
            const sub = lenientParse(fieldSchema, value[k]);
            out[k] = sub.data;
            for (const i of sub.issues)
                issues.push({ ...i, path: [k, ...i.path] });
        }
        // Preserve outer issues the per-field recursion can't rediscover:
        // top-level issues (e.g. unrecognized_keys with path = []) and any
        // issue whose path points at a key not in the schema's shape.
        for (const i of r.error.issues) {
            if (i.path.length === 0 || !(String(i.path[0]) in shape)) {
                issues.push(i);
            }
        }
        return { data: out, issues };
    }
    if (inner instanceof z.ZodArray && Array.isArray(value)) {
        const itemSchema = inner.element;
        const items = [];
        const issues = [];
        for (let i = 0; i < value.length; i++) {
            const sub = lenientParse(itemSchema, value[i]);
            items.push(sub.data);
            for (const issue of sub.issues) {
                issues.push({ ...issue, path: [i, ...issue.path] });
            }
        }
        return { data: items, issues };
    }
    return { data: value, issues: r.error.issues };
}
// Peel ZodOptional / ZodNullable / ZodDefault to expose the underlying shape.
// Relies on Zod 4's `_def.innerType` accessor — the line to revisit on upgrade.
function unwrapWrappers(s) {
    let cur = s;
    while (cur._def?.innerType)
        cur = cur._def.innerType;
    return cur;
}
function isPlainObject(v) {
    return typeof v === "object" && v !== null && !Array.isArray(v);
}
function logLenientValidationWarning(d) {
    const issues = d.issues.map((i) => ({
        path: formatPath(i.path),
        message: i.message,
        code: i.code,
    }));
    const summary = issues
        .map((i) => `${i.path}: ${i.message} [${i.code}]`)
        .join("; ");
    console.warn(`[ApiClient] validation failed but strictValidation=false (status ${d.status}): ${summary}`, { issues, body: d.body, bodyJson: safeJson(d.body) });
}
export function mergeHeaders(into, extra) {
    if (!extra)
        return;
    new Headers(extra).forEach((value, key) => {
        into.set(key, value);
    });
}
/// Parse `Content-Disposition: attachment; filename="foo.pdf"` (and the
/// RFC-5987 `filename*=UTF-8''foo%20bar.pdf` variant) out of a response header map.
/// Returns `undefined` if no header or no filename token is present. Used by
/// generated methods for binary downloads so callers can propose a "save as" name.
export function extractContentDispositionFilename(headers) {
    const h = headers.get("content-disposition");
    if (!h)
        return undefined;
    // RFC 5987 form wins — it carries explicit encoding.
    const starMatch = /filename\*\s*=\s*([^;]+)/i.exec(h);
    if (starMatch) {
        const value = starMatch[1].trim();
        // Shape is `<charset>'<lang>'<percent-encoded>`.
        const parts = value.split("'");
        if (parts.length === 3) {
            try {
                return decodeURIComponent(parts[2]);
            }
            catch {
                // Fall through to the plain form.
            }
        }
    }
    const plainMatch = /filename\s*=\s*(?:"([^"]*)"|([^;]+))/i.exec(h);
    if (plainMatch) {
        return (plainMatch[1] ?? plainMatch[2] ?? "").trim() || undefined;
    }
    return undefined;
}
/// Fallback for streaming responses when the underlying fetch returned a null body
/// (some runtimes do this for HEAD / empty responses). Hands back an
/// already-closed `ReadableStream<Uint8Array>` so the caller's consumer code works
/// uniformly.
export function emptyReadableStream() {
    return new ReadableStream({
        start(controller) {
            controller.close();
        },
    });
}
/// Parse a `ReadableStream<Uint8Array>` of Server-Sent Events into an async
/// iterable of `SSEEvent`s. Follows the HTML spec's line-based parser:
/// lines starting with `data:` / `event:` / `id:` / `retry:` are fields, blank
/// lines dispatch the accumulated event, and lines starting with `:` are
/// comments. Callers: `for await (const ev of parseSSE(r.body)) { … }`.
export async function* parseSSE(stream) {
    const reader = stream.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    let data = [];
    let event;
    let id;
    let retry;
    const flush = () => {
        if (data.length === 0 && event === undefined && id === undefined && retry === undefined) {
            return undefined;
        }
        const ev = { data: data.join("\n") };
        if (event !== undefined)
            ev.event = event;
        if (id !== undefined)
            ev.id = id;
        if (retry !== undefined)
            ev.retry = retry;
        data = [];
        event = undefined;
        id = undefined;
        retry = undefined;
        return ev;
    };
    try {
        while (true) {
            const { done, value } = await reader.read();
            if (done)
                break;
            buffer += decoder.decode(value, { stream: true });
            let nlIdx;
            while ((nlIdx = buffer.indexOf("\n")) !== -1) {
                let line = buffer.slice(0, nlIdx);
                buffer = buffer.slice(nlIdx + 1);
                if (line.endsWith("\r"))
                    line = line.slice(0, -1);
                if (line === "") {
                    const ev = flush();
                    if (ev)
                        yield ev;
                    continue;
                }
                if (line.startsWith(":"))
                    continue; // comment
                const colon = line.indexOf(":");
                const field = colon === -1 ? line : line.slice(0, colon);
                let valueStr = colon === -1 ? "" : line.slice(colon + 1);
                if (valueStr.startsWith(" "))
                    valueStr = valueStr.slice(1);
                switch (field) {
                    case "data":
                        data.push(valueStr);
                        break;
                    case "event":
                        event = valueStr;
                        break;
                    case "id":
                        id = valueStr;
                        break;
                    case "retry": {
                        const n = Number(valueStr);
                        if (Number.isFinite(n))
                            retry = n;
                        break;
                    }
                    // Unknown fields are ignored per the SSE spec.
                }
            }
        }
        // End-of-stream: drain any final buffered line and dispatch a trailing event
        // if one was pending.
        if (buffer.length > 0) {
            const ev = flush();
            if (ev)
                yield ev;
        }
        else {
            const ev = flush();
            if (ev)
                yield ev;
        }
    }
    finally {
        reader.releaseLock();
    }
}
/// Decode a `text/event-stream` (SSE) response body into an async iterable of
/// validated payloads. Frames the byte stream via `parseSSE` (heartbeat
/// `: comment` lines and blank separators are handled there), `JSON.parse`s each
/// event's `data`, then validates it against `schema` via `validateBody` — so it
/// honours `strictValidation` exactly like a JSON body: strict throws on drift,
/// lenient warns + salvage-parses and passes the value through. Events whose
/// `data` is empty or not valid JSON are skipped with a warning rather than
/// aborting the stream. An aborted read (caller cancel / timeout) surfaces as a
/// thrown read error — the caller decides whether that's expected.
/// Callers: `for await (const ev of decodeSSE(MySchema, r.body, res, strict)) { … }`.
export async function* decodeSSE(schema, stream, res, strictValidation) {
    for await (const event of parseSSE(stream)) {
        const data = event.data.trim();
        if (data.length === 0)
            continue;
        let parsed;
        try {
            parsed = JSON.parse(data);
        }
        catch (cause) {
            console.warn("[ApiClient] dropping non-JSON SSE event", {
                data,
                cause: cause instanceof Error ? cause.message : cause,
            });
            continue;
        }
        yield validateBody(schema, parsed, res, strictValidation);
    }
}
/// Throw `ApiError { kind: "content-type-mismatch" }` if `res` declares a
/// Content-Type that clearly isn't `application/json` (or `+json`). Tolerates a
/// missing header — some servers omit it and we don't want to regress on them —
/// but rejects a server that loudly says it's returning e.g. `text/html` while the
/// spec promised JSON. Called from the JSON branches of each per-status switch.
export function assertJsonContentType(res) {
    const ct = res.headers.get("content-type");
    if (!ct)
        return;
    const base = ct.split(";")[0].trim().toLowerCase();
    if (base === "application/json" || base.endsWith("+json"))
        return;
    throw new ApiError({
        kind: "content-type-mismatch",
        status: res.status,
        statusText: res.statusText,
        headers: res.headers,
        contentType: ct,
    });
}
export const ActorTypeSchema = z.enum(["user", "agent"]);
export const AgreementImplFeeTiersCreateSchema = z.object({ agreement_term_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), fee_minor: z.number().int().min(0).max(9007199254740991), max_accounts: z.union([z.number().int().min(1).max(9007199254740991), z.null()]).optional(), notes: z.union([z.string(), z.null()]).optional() }).strict();
export const CurrencySchema = z.enum(["CAD", "USD"]);
export const AgreementImplFeeTiersItemSchema = z.object({ agreement_term_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), created_at: vDateTime(), currency: CurrencySchema, fee_minor: z.number().int().min(0).max(9007199254740991), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), max_accounts: z.union([z.number().int().min(1).max(9007199254740991), z.null()]), notes: z.union([z.string(), z.null()]), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const AgreementImplFeeTiersListSchema = z.object({ items: z.array(AgreementImplFeeTiersItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const AgreementImplFeeTiersUpdateSchema = z.object({ fee_minor: z.number().int().min(0).max(9007199254740991).optional(), max_accounts: z.union([z.number().int().min(1).max(9007199254740991), z.null()]).optional(), notes: z.union([z.string(), z.null()]).optional() }).strict();
export const AgreementTermsCreateSchema = z.object({ agreement_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), cost_split_pct: z.union([z.number().min(0).max(100), z.null()]).optional(), effective_date: vDateTime(), impl_fee_currency: z.union([CurrencySchema, z.null()]).optional(), impl_split_pct: z.number().min(0).max(100), recurring_split_pct: z.number().min(0).max(100) }).strict();
export const AgreementTermsItemSchema = z.object({ agreement_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), cost_split_pct: z.union([z.number().min(0).max(100), z.null()]), created_at: vDateTime(), effective_date: vDateTime(), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), impl_fee_currency: z.union([CurrencySchema, z.null()]), impl_split_pct: z.number().min(0).max(100), recurring_split_pct: z.number().min(0).max(100), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const AgreementTermsListSchema = z.object({ items: z.array(AgreementTermsItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const AgreementTermsUpdateSchema = z.object({ cost_split_pct: z.union([z.number().min(0).max(100), z.null()]).optional(), effective_date: vDateTime().optional(), impl_fee_currency: z.union([CurrencySchema, z.null()]).optional(), impl_split_pct: z.number().min(0).max(100).optional(), recurring_split_pct: z.number().min(0).max(100).optional() }).strict();
export const CostBillingModeSchema = z.enum(["bundled", "separate"]);
export const AgreementsCreateSchema = z.object({ cost_billing_mode: CostBillingModeSchema.optional(), is_default: z.boolean().optional(), name: z.string().min(1).max(200), notes: z.union([z.string(), z.null()]).optional(), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")) }).strict();
export const AgreementsDetailCurrentTermImplFeeTiersItemSchema = z.object({ agreement_term_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), created_at: vDateTime(), currency: CurrencySchema, fee_minor: z.number().int().min(0).max(9007199254740991), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), max_accounts: z.union([z.number().int().min(1).max(9007199254740991), z.null()]), notes: z.union([z.string(), z.null()]), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const AgreementsDetailCurrentTermSchema = z.object({ agreement_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), cost_split_pct: z.union([z.number().min(0).max(100), z.null()]), created_at: vDateTime(), effective_date: vDateTime(), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), impl_fee_currency: z.union([CurrencySchema, z.null()]), impl_fee_tiers: z.array(AgreementsDetailCurrentTermImplFeeTiersItemSchema), impl_split_pct: z.number().min(0).max(100), recurring_split_pct: z.number().min(0).max(100), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const AgreementsDetailTermsItemImplFeeTiersItemSchema = z.object({ agreement_term_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), created_at: vDateTime(), currency: CurrencySchema, fee_minor: z.number().int().min(0).max(9007199254740991), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), max_accounts: z.union([z.number().int().min(1).max(9007199254740991), z.null()]), notes: z.union([z.string(), z.null()]), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const AgreementsDetailTermsItemSchema = z.object({ agreement_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), cost_split_pct: z.union([z.number().min(0).max(100), z.null()]), created_at: vDateTime(), effective_date: vDateTime(), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), impl_fee_currency: z.union([CurrencySchema, z.null()]), impl_fee_tiers: z.array(AgreementsDetailTermsItemImplFeeTiersItemSchema), impl_split_pct: z.number().min(0).max(100), recurring_split_pct: z.number().min(0).max(100), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const AgreementsDetailSchema = z.object({ cost_billing_mode: CostBillingModeSchema, created_at: vDateTime(), current_term: z.union([AgreementsDetailCurrentTermSchema, z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), is_default: z.boolean(), name: z.string().min(1).max(200), notes: z.union([z.string(), z.null()]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), terms: z.array(AgreementsDetailTermsItemSchema), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const AgreementsItemSchema = z.object({ cost_billing_mode: CostBillingModeSchema, created_at: vDateTime(), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), is_default: z.boolean(), name: z.string().min(1).max(200), notes: z.union([z.string(), z.null()]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const AgreementsListSchema = z.object({ items: z.array(AgreementsItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const AgreementsUpdateSchema = z.object({ cost_billing_mode: CostBillingModeSchema.optional(), is_default: z.boolean().optional(), name: z.string().min(1).max(200).optional(), notes: z.union([z.string(), z.null()]).optional() }).strict();
export const ApiDescriptionConventionsSchema = z.object({ currency_conversion: z.string(), dates: z.string(), errors: z.string(), filters: z.string(), list_envelope: z.string(), money: z.string(), partner_ownership: z.string(), sort: z.string() }).strict();
export const ApiDescriptionEnumsItemSchema = z.object({ name: z.string(), values: z.array(z.string()) }).strict();
export const ApiDescriptionOperationsItemSchema = z.object({ body_fields: z.array(z.string()), description: z.string(), method: z.enum(["POST"]), name: z.string(), path: z.string(), required_role: z.string(), takes_path_id: z.boolean() }).strict();
export const ApiDescriptionReportsItemSchema = z.object({ description: z.string(), name: z.string(), params: z.array(z.string()), path: z.string() }).strict();
export const ApiDescriptionResourcesItemSchema = z.object({ description: z.string(), filters: z.array(z.string()), name: z.string(), path: z.string(), range_filters: z.array(z.string()), sort_fields: z.array(z.string()), supports_q: z.boolean() }).strict();
export const ApiDescriptionWritesResourcesItemSchema = z.object({ create: z.string(), create_fields: z.array(z.string()), delete: z.string(), immutable_after_create: z.array(z.string()), required_role: z.string(), resource: z.string(), update: z.string(), update_fields: z.array(z.string()) }).strict();
export const ApiDescriptionWritesSchema = z.object({ conventions: z.object({}).catchall(z.string()), resources: z.array(ApiDescriptionWritesResourcesItemSchema) }).strict();
export const ApiDescriptionSchema = z.object({ conventions: ApiDescriptionConventionsSchema, enums: z.array(ApiDescriptionEnumsItemSchema), openapi_url: z.string(), operations: z.array(ApiDescriptionOperationsItemSchema), reports: z.array(ApiDescriptionReportsItemSchema), resources: z.array(ApiDescriptionResourcesItemSchema), service: z.enum(["dialai-crm"]), writes: ApiDescriptionWritesSchema }).strict();
export const ChargeStatusSchema = z.enum(["open", "ready", "invoiced", "paid"]);
export const DealStatementLineUnpricedSchema = z.object({ division_by_zero: z.number().int().min(0), excluded: z.number().int().min(0), null_field: z.number().int().min(0), rate_unavailable: z.number().int().min(0), rule_missing: z.number().int().min(0) }).strict();
export const DerivedFigureIssueSchema = z.enum(["currency_mismatch", "fx_rate_unavailable", "entitlement_unmetered", "entitlement_unit_mismatch", "entitlement_cycle_conflict", "entitlement_overdrawn", "milestone_price_unsupported", "issued_snapshot_ambiguous", "rule_missing"]);
export const FigureSourceSchema = z.enum(["contract", "deal_fact", "provider_cost", "rate_card", "none"]);
export const BillRunReportAttentionItemSchema = z.object({ applied_split_pct: z.union([z.number().min(0).max(100), z.null()]), billable_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), charge_source_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), charge_type: z.string(), currency: CurrencySchema, customer_name: z.union([z.string(), z.null()]), days_overdue: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), derived_issue: z.union([DerivedFigureIssueSchema, z.null()]), due_date: vDateTime(), figure_source: FigureSourceSchema, id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), kind: z.enum(["bill", "cost_recharge"]), label: z.string(), note: z.union([z.string(), z.null()]), our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string(), period_open: z.union([z.boolean(), z.null()]), reason: z.enum(["amount_pending", "unresolved_split", "overdue"]), service_period: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]), status: ChargeStatusSchema, term_line_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), unpriced: DealStatementLineUnpricedSchema }).strict();
export const BillRunReportFxSchema = z.object({ as_of: z.union([vDateTime(), z.null()]), status: z.enum(["display_converted", "not_needed", "unavailable"]), target_currency: CurrencySchema, usd_to_cad: z.union([z.number().gt(0), z.null()]) }).strict();
export const ReportScopeSchema = z.enum(["rolled_up", "direct"]);
export const BillRunReportParamsSchema = z.object({ as_of: vDateTime(), horizon_days: z.number().int().min(-9007199254740991).max(9007199254740991), partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), scope: ReportScopeSchema, to_date: vDateTime() }).strict();
export const BillRunReportRunTotalsSchema = z.object({ bill_billable_minor: z.number().int().min(-9007199254740991).max(9007199254740991), billable_minor: z.number().int().min(-9007199254740991).max(9007199254740991), line_count: z.number().int().min(0).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), pending_count: z.number().int().min(0).max(9007199254740991), recharge_billable_minor: z.number().int().min(-9007199254740991).max(9007199254740991), run_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const BillRunReportRunTotalsItemSchema = z.object({ bill_billable_minor: z.number().int().min(-9007199254740991).max(9007199254740991), billable_minor: z.number().int().min(-9007199254740991).max(9007199254740991), currency: CurrencySchema, line_count: z.number().int().min(0).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), pending_count: z.number().int().min(0).max(9007199254740991), recharge_billable_minor: z.number().int().min(-9007199254740991).max(9007199254740991), run_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const BillRunReportRunsItemSchema = z.object({ bill_billable_minor: z.number().int().min(-9007199254740991).max(9007199254740991), bill_count: z.number().int().min(0).max(9007199254740991), bill_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), billable_minor: z.number().int().min(-9007199254740991).max(9007199254740991), charge_types: z.array(z.string()), customers: z.array(z.string()), due_date: vDateTime(), earliest_service_period: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]), effective_split_pct: z.union([z.number().min(0).max(100), z.null()]), latest_service_period: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string(), pending_count: z.number().int().min(0).max(9007199254740991), recharge_billable_minor: z.number().int().min(-9007199254740991).max(9007199254740991), recharge_count: z.number().int().min(0).max(9007199254740991), source_currency: CurrencySchema, unresolved_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const BillRunReportSchema = z.object({ attention: z.array(BillRunReportAttentionItemSchema), attention_counts: z.object({ amount_pending: z.number().int().min(0).max(9007199254740991), overdue: z.number().int().min(0).max(9007199254740991), unresolved_split: z.number().int().min(0).max(9007199254740991) }).strict(), currency: CurrencySchema, fx: BillRunReportFxSchema, generated_at: vDateTime(), params: BillRunReportParamsSchema, run_totals: z.array(BillRunReportRunTotalsItemSchema), run_totals_converted: z.union([BillRunReportRunTotalsSchema, z.null()]), runs: z.array(BillRunReportRunsItemSchema) }).strict();
export const BillingContactRoleSchema = z.enum(["recipient", "approver"]);
export const BillingContactSourceSchema = z.enum(["deal", "partner"]);
export const BillingContactsCreateSchema = z.object({ deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), email: z.string().max(320).regex(new RegExp("^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$")), name: z.union([z.string().min(1).max(200), z.null()]).optional(), partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), role: BillingContactRoleSchema }).strict();
export const BillingContactsItemSchema = z.object({ created_at: vDateTime(), deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), email: z.string(), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), name: z.union([z.string(), z.null()]), partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), role: BillingContactRoleSchema, updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const BillingContactsListSchema = z.object({ items: z.array(BillingContactsItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const BillingContactsUpdateSchema = z.object({ email: z.string().max(320).regex(new RegExp("^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$")).optional(), name: z.union([z.string().min(1).max(200), z.null()]).optional(), role: BillingContactRoleSchema.optional() }).strict();
export const BillingLineupReportCostRowsItemSchema = z.object({ cost_minor: z.number().int().min(-9007199254740991).max(9007199254740991), currency: CurrencySchema, item_count: z.number().int().min(0).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), partner_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), status: ChargeStatusSchema, week: z.string().regex(new RegExp("^\\d{4}-W(0[1-9]|[1-4][0-9]|5[0-3])$")), week_start: vDateTime() }).strict();
export const BillingLineupReportCostTotalsSchema = z.object({ cost_minor: z.number().int().min(-9007199254740991).max(9007199254740991), item_count: z.number().int().min(0).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), partner_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991) }).strict();
export const BillingLineupReportCostTotalsItemSchema = z.object({ cost_minor: z.number().int().min(-9007199254740991).max(9007199254740991), currency: CurrencySchema, item_count: z.number().int().min(0).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), partner_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991) }).strict();
export const BillingLineupReportFxSchema = z.object({ as_of: z.union([vDateTime(), z.null()]), status: z.enum(["display_converted", "not_needed", "unavailable"]), target_currency: CurrencySchema, usd_to_cad: z.union([z.number().gt(0), z.null()]) }).strict();
export const BillingLineupReportParamsSchema = z.object({ from_date: vDateTime(), include_costs: z.boolean(), partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), scope: ReportScopeSchema, to_date: vDateTime(), weeks: z.number().int().min(-9007199254740991).max(9007199254740991) }).strict();
export const BillingLineupReportRowsItemSchema = z.object({ currency: CurrencySchema, gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), item_count: z.number().int().min(0).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), status: ChargeStatusSchema, unresolved_item_count: z.number().int().min(0).max(9007199254740991), week: z.string().regex(new RegExp("^\\d{4}-W(0[1-9]|[1-4][0-9]|5[0-3])$")), week_start: vDateTime() }).strict();
export const BillingLineupReportTotalsSchema = z.object({ gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), item_count: z.number().int().min(0).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), unresolved_item_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const BillingLineupReportTotalsItemSchema = z.object({ currency: CurrencySchema, gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), item_count: z.number().int().min(0).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), unresolved_item_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const BillingLineupReportSchema = z.object({ cost_rows: z.array(BillingLineupReportCostRowsItemSchema).optional(), cost_totals: z.array(BillingLineupReportCostTotalsItemSchema).optional(), cost_totals_converted: z.union([BillingLineupReportCostTotalsSchema, z.null()]).optional(), currency: CurrencySchema, fx: BillingLineupReportFxSchema, generated_at: vDateTime(), params: BillingLineupReportParamsSchema, rows: z.array(BillingLineupReportRowsItemSchema), totals: z.array(BillingLineupReportTotalsItemSchema), totals_converted: z.union([BillingLineupReportTotalsSchema, z.null()]) }).strict();
export const BillingTimingSchema = z.enum(["arrears", "advance"]);
export const CadenceSchema = z.enum(["one_time", "monthly", "quarterly", "annual", "milestone"]);
export const CalendarEventKindSchema = z.enum(["bill_due", "cost_bill_due", "term_change", "impl_fee_due", "term_line_change", "deal_start", "deal_renewal"]);
export const CalendarReportBillingTotalsSchema = z.object({ gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), item_count: z.number().int().min(0).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), pending_item_count: z.number().int().min(0).max(9007199254740991), unresolved_item_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const CalendarReportBillingTotalsItemSchema = z.object({ currency: CurrencySchema, gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), item_count: z.number().int().min(0).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), pending_item_count: z.number().int().min(0).max(9007199254740991), unresolved_item_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const CalendarReportCostTotalsSchema = z.object({ cost_minor: z.number().int().min(-9007199254740991).max(9007199254740991), item_count: z.number().int().min(0).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), partner_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), pending_item_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const CalendarReportCostTotalsItemSchema = z.object({ cost_minor: z.number().int().min(-9007199254740991).max(9007199254740991), currency: CurrencySchema, item_count: z.number().int().min(0).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), partner_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), pending_item_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const TermLineKindSchema = z.enum(["revenue", "pass_through_cost"]);
export const CalendarReportEventsItemVariant0Schema = z.object({ agreement_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), agreement_name: z.union([z.string(), z.null()]), customer_name: z.string(), date: vDateTime(), deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), id: z.string(), invoice_number: z.union([z.string(), z.null()]), is_estimate: z.boolean(), kind: z.enum(["bill_due"]), native_currency: CurrencySchema, native_gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string(), period: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]), revenue_line_label: z.string(), status: ChargeStatusSchema, term_line_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), term_line_kind: TermLineKindSchema }).strict();
export const CalendarReportEventsItemVariant1Schema = z.object({ agreement_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), agreement_name: z.union([z.string(), z.null()]), cost_label: z.string(), cost_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), customer_name: z.union([z.string(), z.null()]), date: vDateTime(), deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), id: z.string(), invoice_number: z.union([z.string(), z.null()]), kind: z.enum(["cost_bill_due"]), native_currency: CurrencySchema, native_partner_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string(), partner_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), period: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), status: ChargeStatusSchema, term_line_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")) }).strict();
export const CalendarReportEventsItemVariant2Schema = z.object({ affected_deal_count: z.number().int().min(0).max(9007199254740991), agreement_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), agreement_name: z.string(), agreement_term_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), cost_split_pct: z.union([z.number().min(0).max(100), z.null()]), customer_name: z.union([z.string(), z.null()]), date: vDateTime(), deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), id: z.string(), impl_split_pct: z.number().min(0).max(100), is_first_term: z.boolean(), kind: z.enum(["term_change"]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string(), previous_cost_split_pct: z.union([z.number().min(0).max(100), z.null()]), previous_effective_date: z.union([vDateTime(), z.null()]), previous_impl_split_pct: z.union([z.number().min(0).max(100), z.null()]), previous_recurring_split_pct: z.union([z.number().min(0).max(100), z.null()]), recurring_split_pct: z.number().min(0).max(100) }).strict();
export const DealStateSchema = z.enum(["lead", "qualified", "demoed", "proposal", "decision_maker_bought_in", "won", "implementation", "live", "ended", "lost"]);
export const ImplFeeUnresolvedReasonSchema = z.enum(["no_account_count", "no_agreement", "no_term", "no_fee_schedule", "no_tier_match", "currency_mismatch"]);
export const CalendarReportEventsItemVariant3Schema = z.object({ agreement_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), agreement_name: z.union([z.string(), z.null()]), customer_account_count: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), customer_name: z.string(), date: vDateTime(), deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), id: z.string(), kind: z.enum(["impl_fee_due"]), native_currency: z.union([CurrencySchema, z.null()]), native_suggested_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string(), recorded_gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), recorded_line_count: z.number().int().min(0).max(9007199254740991), state: DealStateSchema, suggested_gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), suggested_our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), unresolved_reason: z.union([ImplFeeUnresolvedReasonSchema, z.null()]) }).strict();
export const CalendarReportEventsItemVariant4Schema = z.object({ agreement_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), agreement_name: z.union([z.string(), z.null()]), amount_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), boundary: z.enum(["starts", "ends"]), cadence: CadenceSchema, customer_name: z.string(), date: vDateTime(), deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), effective_date: vDateTime(), end_date: z.union([vDateTime(), z.null()]), id: z.string(), kind: z.enum(["term_line_change"]), label: z.string(), native_amount_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), native_currency: CurrencySchema, native_rate_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string(), rate_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), split_override_pct: z.union([z.number().min(0).max(100), z.null()]), term_line_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), term_line_kind: TermLineKindSchema, unit: z.union([z.string(), z.null()]) }).strict();
export const CalendarReportEventsItemVariant5Schema = z.object({ agreement_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), agreement_name: z.union([z.string(), z.null()]), contracted_gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), customer_name: z.string(), date: vDateTime(), deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), id: z.string(), is_firm: z.boolean(), kind: z.enum(["deal_start"]), native_contracted_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), native_currency: CurrencySchema, partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string(), start_date_earliest: vDateTime(), start_date_latest: vDateTime(), state: DealStateSchema, win_prob: z.number().min(0).max(100) }).strict();
export const CalendarReportEventsItemVariant6Schema = z.object({ agreement_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), agreement_name: z.union([z.string(), z.null()]), contract_term_months: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), contracted_gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), customer_name: z.string(), date: vDateTime(), deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), id: z.string(), kind: z.enum(["deal_renewal"]), native_contracted_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), native_currency: CurrencySchema, partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string(), state: DealStateSchema }).strict();
export const CalendarReportEventsItemSchema = z.union([CalendarReportEventsItemVariant0Schema, CalendarReportEventsItemVariant1Schema, CalendarReportEventsItemVariant2Schema, CalendarReportEventsItemVariant3Schema, CalendarReportEventsItemVariant4Schema, CalendarReportEventsItemVariant5Schema, CalendarReportEventsItemVariant6Schema]);
export const CalendarReportFxSchema = z.object({ as_of: z.union([vDateTime(), z.null()]), status: z.enum(["display_converted", "not_needed", "unavailable"]), target_currency: CurrencySchema, usd_to_cad: z.union([z.number().gt(0), z.null()]) }).strict();
export const CalendarReportParamsSchema = z.object({ deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), from_date: vDateTime(), kinds: z.array(CalendarEventKindSchema), partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), scope: ReportScopeSchema, to_date: vDateTime(), unbilled_only: z.boolean() }).strict();
export const CalendarReportSchema = z.object({ billing_totals: z.array(CalendarReportBillingTotalsItemSchema), billing_totals_converted: z.union([CalendarReportBillingTotalsSchema, z.null()]), cost_totals: z.array(CalendarReportCostTotalsItemSchema), cost_totals_converted: z.union([CalendarReportCostTotalsSchema, z.null()]), currency: CurrencySchema, events: z.array(CalendarReportEventsItemSchema), fx: CalendarReportFxSchema, generated_at: vDateTime(), kind_counts: z.object({ bill_due: z.number().int().min(0).max(9007199254740991), cost_bill_due: z.number().int().min(0).max(9007199254740991), deal_renewal: z.number().int().min(0).max(9007199254740991), deal_start: z.number().int().min(0).max(9007199254740991), impl_fee_due: z.number().int().min(0).max(9007199254740991), term_change: z.number().int().min(0).max(9007199254740991), term_line_change: z.number().int().min(0).max(9007199254740991) }).strict(), params: CalendarReportParamsSchema }).strict();
export const CarryOverSchema = z.enum(["none", "unused_rolls_forward"]);
export const ClosingPaceMonthSchema = z.object({ live_count: z.number().int(), month: z.string().regex(new RegExp("^[0-9]{4}-(0[1-9]|1[0-2])$")), won_count: z.number().int() }).strict();
export const ClosingPaceSchema = z.object({ approximate_left_out: z.number().int(), from: vDateTime(), live_per_month: z.number(), months: z.array(ClosingPaceMonthSchema), suggested_go_lives_per_month: z.union([z.number(), z.null()]), suggested_monthly_growth_pct: z.union([z.number(), z.null()]), to: vDateTime(), won_per_month: z.number() }).strict();
export const CollectionSchema = z.enum(["we_invoice", "partner_reports", "customer_direct"]);
export const CreateInvoiceDraftRequestSchema = z.object({ currency: CurrencySchema, customer_name: z.string().optional(), deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")).optional(), due_date: vDateTime().optional(), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")).optional(), period: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")) }).strict();
export const MeterUnitSchema = z.enum(["minute", "call", "usage", "message", "period", "input_token", "output_token", "cached_input_token", "cache_creation_input_token", "reasoning_token", "audio_input_token", "audio_output_token", "audio_second", "character", "carrier_minute", "currency_minor"]);
export const InvoiceDraftLineSchema = z.object({ applied_split_pct: z.union([z.number().min(0).max(100), z.null()]), charge_type: z.string(), charged_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), currency: CurrencySchema, description: z.union([z.string(), z.null()]), figure_source: FigureSourceSchema, gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), line_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), period: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]), period_open: z.union([z.boolean(), z.null()]), quantity: z.union([z.number(), z.null()]), sort_order: z.number().int().min(1).max(9007199254740991), term_line_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), term_line_revision: z.union([z.number().int().min(1).max(9007199254740991), z.null()]), unit: z.union([MeterUnitSchema, z.null()]), unit_price_minor: z.union([z.string().regex(new RegExp("^-?\\d+(\\.\\d{1,9})?$")), z.null()]), unpriced: DealStatementLineUnpricedSchema }).strict();
export const InvoiceApprovalStatusSchema = z.enum(["not_sent", "awaiting", "approved"]);
export const InvoiceRecipientSchema = z.enum(["partner", "customer"]);
export const InvoiceStatusSchema = z.enum(["draft", "issued", "paid", "void"]);
export const InvoicesItemSchema = z.object({ approval_status: InvoiceApprovalStatusSchema, approved_by: z.union([z.string().min(1).max(320), z.null()]), approved_on: z.union([vDateTime(), z.null()]), bill_charged_minor: z.number().int().min(-9007199254740991).max(9007199254740991), bill_line_count: z.number().int().min(0).max(9007199254740991), charge_types: z.array(z.string()), charged_minor: z.number().int().min(-9007199254740991).max(9007199254740991), created_at: vDateTime(), credit_note_of: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), currency: CurrencySchema, customers: z.array(z.string()), days_outstanding: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), due_date: vDateTime(), effective_split_pct: z.union([z.number().min(0).max(100), z.null()]), gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), invoice_number: z.union([z.string(), z.null()]), is_outstanding: z.boolean(), issue_date: z.union([vDateTime(), z.null()]), line_count: z.number().int().min(0).max(9007199254740991), notes: z.union([z.string(), z.null()]), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), paid_date: z.union([vDateTime(), z.null()]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string(), payer: InvoiceRecipientSchema, pending_line_count: z.number().int().min(0).max(9007199254740991), recharge_charged_minor: z.number().int().min(-9007199254740991).max(9007199254740991), recharge_line_count: z.number().int().min(0).max(9007199254740991), sent_for_approval_on: z.union([vDateTime(), z.null()]), sent_for_approval_to: z.union([z.string().min(1).max(320), z.null()]), service_period: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]), standalone_charged_minor: z.number().int().min(-9007199254740991).max(9007199254740991), standalone_line_count: z.number().int().min(0).max(9007199254740991), status: InvoiceStatusSchema, unresolved_line_count: z.number().int().min(0).max(9007199254740991), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const CreateInvoiceDraftResponseSchema = z.object({ created: z.boolean(), invoice: InvoicesItemSchema, lines: z.array(InvoiceDraftLineSchema), period: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")) }).strict();
export const DealEffectiveBillingContactSchema = z.object({ email: z.string(), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), name: z.union([z.string(), z.null()]), role: BillingContactRoleSchema, source: BillingContactSourceSchema }).strict();
export const DealFactKindSchema = z.enum(["amount", "quantity", "milestone_reached", "entitlement_adjustment"]);
export const DealFactRowSchema = z.object({ amount_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]).optional(), currency: z.union([CurrencySchema, z.null()]).optional(), deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), entitlement_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), external_ref: z.union([z.string(), z.null()]).optional(), kind: DealFactKindSchema, milestone_seq: z.union([z.number().int().min(1).max(9007199254740991), z.null()]).optional(), note: z.union([z.string(), z.null()]).optional(), occurred_on: z.union([vDateTime(), z.null()]).optional(), partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), period: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), quantity: z.union([z.number(), z.null()]).optional(), term_line_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), version: z.number().int().min(1).optional() }).strict();
export const FactSourceSchema = z.enum(["person", "import", "platform_deployment", "deployment_backend", "bank_of_canada", "provider_api", "openai_api", "anthropic_api", "twilio_api", "aws_ce"]);
export const DealFactsItemSchema = z.object({ amount_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), created_at: vDateTime(), currency: z.union([CurrencySchema, z.null()]), deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), entitlement_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), external_ref: z.union([z.string(), z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), kind: DealFactKindSchema, milestone_seq: z.union([z.number().int().min(1).max(9007199254740991), z.null()]), note: z.union([z.string(), z.null()]), occurred_on: z.union([vDateTime(), z.null()]), partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), period: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), quantity: z.union([z.number(), z.null()]), received_at: vDateTime(), recorded_by: z.string(), source: FactSourceSchema, term_line_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const DealFactsListSchema = z.object({ items: z.array(DealFactsItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const DealHistoryActorTypeSchema = z.enum(["user", "agent", "system"]);
export const DealHistoryChangeSchema = z.object({ after: z.union([z.string(), z.null()]), before: z.union([z.string(), z.null()]), field: z.string() }).strict();
export const DealHistoryKindSchema = z.enum(["stage", "change"]);
export const DealStageSourceSchema = z.enum(["recorded", "audit_log", "assumed", "imported"]);
export const DealHistoryEntrySchema = z.object({ actor_subject: z.union([z.string(), z.null()]), actor_type: z.union([DealHistoryActorTypeSchema, z.null()]), approximate: z.boolean(), at: vDateTime(), changes: z.array(DealHistoryChangeSchema), external_ref: z.union([z.string(), z.null()]), from_state: z.union([DealStateSchema, z.null()]), kind: DealHistoryKindSchema, stage_source: z.union([DealStageSourceSchema, z.null()]), to_state: z.union([DealStateSchema, z.null()]) }).strict();
export const DealHistorySchema = z.object({ deal_id: z.string(), entries: z.array(DealHistoryEntrySchema) }).strict();
export const DealStatementLinePrepaidAdjustmentSchema = z.object({ note: z.union([z.string(), z.null()]), quantity: z.number(), recorded_by: z.string(), source: FactSourceSchema }).strict();
export const DealStatementLinePrepaidSchema = z.object({ adjustment_quantity: z.number(), adjustments: z.array(DealStatementLinePrepaidAdjustmentSchema), allocated_quantity: z.number().min(0), carried_in_quantity: z.number(), carry_over: CarryOverSchema, consumed_quantity: z.number().min(0), entitlement_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), entitlement_quantity: z.number().min(0), opening_quantity: z.number(), overage_quantity: z.number().min(0), remaining_quantity: z.number() }).strict();
export const DealStatementLinePriceArmsSchema = z.object({ contract: z.number().int().min(0), provider_cost: z.number().int().min(0), rate_card: z.number().int().min(0) }).strict();
export const MeterSourceSchema = z.enum(["transcripts", "usage", "provider_cost", "deal"]);
export const SplitSourceSchema = z.enum(["override", "frozen", "line", "deal", "agreement", "unresolved"]);
export const StatementLineStatusSchema = z.enum(["open", "issued"]);
export const DealStatementLineSchema = z.object({ basis: z.string(), billing_timing: BillingTimingSchema, cadence: CadenceSchema, charged_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), collection: CollectionSchema, facts_matched: z.number().int().min(0), facts_priced: z.number().int().min(0), facts_scanned: z.number().int().min(0), figure_source: FigureSourceSchema, gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), invoice_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), invoice_number: z.union([z.string(), z.null()]), kind: TermLineKindSchema, label: z.string(), milestone_seq: z.union([z.number().int().min(1).max(9007199254740991), z.null()]), our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), period: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), prepaid: z.union([DealStatementLinePrepaidSchema, z.null()]), price_arms: DealStatementLinePriceArmsSchema, quantity: z.union([z.number(), z.null()]), share_pct: z.union([z.number().min(0).max(100), z.null()]), share_source: SplitSourceSchema, source: MeterSourceSchema, stacked_fact_count: z.number().int().min(0), status: StatementLineStatusSchema, term_line_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), term_line_revision: z.number().int().min(1).max(9007199254740991), unit: MeterUnitSchema, unit_price_minor: z.union([z.string().regex(new RegExp("^-?\\d+(\\.\\d{1,9})?$")), z.null()]), unpriced: DealStatementLineUnpricedSchema }).strict();
export const DealStatementScopeSchema = z.object({ deployment_slug: z.string().regex(new RegExp("^(prod|nonprod)-[a-z0-9]+-[a-z0-9-]+$")), from_day: vDateTime(), tenant_slug: z.string(), to_day: vDateTime() }).strict();
export const DealStatementProvenanceSchema = z.object({ derived_as_of: vDateTime(), engine_version: z.string(), facts_max_received_at: z.union([vDateTime(), z.null()]), period_open: z.boolean(), rate_set_hash: z.union([z.string(), z.null()]), scope: z.array(DealStatementScopeSchema), term_revision_hash: z.string() }).strict();
export const DealStatementTotalSchema = z.object({ charged_minor: z.number().int().min(-9007199254740991).max(9007199254740991), currency: CurrencySchema, gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), skipped_lines: z.number().int().min(0) }).strict();
export const DealStatementSchema = z.object({ currency: CurrencySchema, customer_name: z.string(), deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), generated_at: vDateTime(), lines: z.array(DealStatementLineSchema), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), period: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), provenance: DealStatementProvenanceSchema, totals: z.array(DealStatementTotalSchema) }).strict();
export const DealsCreateSchema = z.object({ agreement_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), closed_on: z.union([vDateTime(), z.null()]).optional(), contract_term_months: z.union([z.number().int().min(1).max(9007199254740991), z.null()]).optional(), currency: CurrencySchema, customer_account_count: z.union([z.number().int().min(1).max(9007199254740991), z.null()]).optional(), customer_city: z.union([z.string().min(1).max(120), z.null()]).optional(), customer_country: z.union([z.string().regex(new RegExp("^[A-Z]{2}$")), z.null()]).optional(), customer_lat: z.union([z.number().min(-90).max(90), z.null()]).optional(), customer_lng: z.union([z.number().min(-180).max(180), z.null()]).optional(), customer_name: z.string().min(1).max(200), customer_region: z.union([z.string().min(1).max(100), z.null()]).optional(), estimated_go_live: z.union([vDateTime(), z.null()]).optional(), estimated_implementation_minor: z.union([z.number().int().min(0).max(9007199254740991), z.null()]).optional(), estimated_recurring_monthly_minor: z.union([z.number().int().min(0).max(9007199254740991), z.null()]).optional(), invoice_recipient: InvoiceRecipientSchema, notes: z.union([z.string(), z.null()]).optional(), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), renewal_date: z.union([vDateTime(), z.null()]).optional(), split_override_pct: z.union([z.number().min(0).max(100), z.null()]).optional(), start_date_earliest: vDateTime(), start_date_latest: vDateTime(), state: DealStateSchema, win_prob: z.number().min(0).max(100) }).strict();
export const ProjectionShareSourceSchema = z.enum(["deal", "agreement", "assumed"]);
export const DealsItemSchema = z.object({ agreement_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), agreement_name: z.union([z.string(), z.null()]), billed_to_date_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), billed_to_date_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), closed_on: z.union([vDateTime(), z.null()]), contract_term_months: z.union([z.number().int().min(1).max(9007199254740991), z.null()]), contracted_gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), contracted_our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), created_at: vDateTime(), currency: CurrencySchema, customer_account_count: z.union([z.number().int().min(1).max(9007199254740991), z.null()]), customer_city: z.union([z.string(), z.null()]), customer_country: z.union([z.string().regex(new RegExp("^[A-Z]{2}$")), z.null()]), customer_lat: z.union([z.number().min(-90).max(90), z.null()]), customer_lng: z.union([z.number().min(-180).max(180), z.null()]), customer_name: z.string().min(1).max(200), customer_region: z.union([z.string(), z.null()]), effective_agreement_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), effective_agreement_name: z.union([z.string(), z.null()]), effective_agreement_partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), effective_agreement_partner_name: z.union([z.string(), z.null()]), effective_billing_contacts: z.array(DealEffectiveBillingContactSchema), estimated_first_year_our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), estimated_go_live: z.union([vDateTime(), z.null()]), estimated_implementation_minor: z.union([z.number().int().min(0).max(9007199254740991), z.null()]), estimated_implementation_share_pct: z.union([z.number().min(0).max(100), z.null()]), estimated_recurring_monthly_minor: z.union([z.number().int().min(0).max(9007199254740991), z.null()]), estimated_recurring_share_pct: z.union([z.number().min(0).max(100), z.null()]), estimated_share_source: z.union([ProjectionShareSourceSchema, z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), invoice_recipient: InvoiceRecipientSchema, notes: z.union([z.string(), z.null()]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string(), partner_parent_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), renewal_date: z.union([vDateTime(), z.null()]), split_override_pct: z.union([z.number().min(0).max(100), z.null()]), start_date_earliest: vDateTime(), start_date_is_firm: z.boolean(), start_date_latest: vDateTime(), state: DealStateSchema, updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991), win_prob: z.number().min(0).max(100) }).strict();
export const DealsListSchema = z.object({ items: z.array(DealsItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const DealsUpdateSchema = z.object({ agreement_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), closed_on: z.union([vDateTime(), z.null()]).optional(), contract_term_months: z.union([z.number().int().min(1).max(9007199254740991), z.null()]).optional(), customer_account_count: z.union([z.number().int().min(1).max(9007199254740991), z.null()]).optional(), customer_city: z.union([z.string().min(1).max(120), z.null()]).optional(), customer_country: z.union([z.string().regex(new RegExp("^[A-Z]{2}$")), z.null()]).optional(), customer_lat: z.union([z.number().min(-90).max(90), z.null()]).optional(), customer_lng: z.union([z.number().min(-180).max(180), z.null()]).optional(), customer_name: z.string().min(1).max(200).optional(), customer_region: z.union([z.string().min(1).max(100), z.null()]).optional(), estimated_go_live: z.union([vDateTime(), z.null()]).optional(), estimated_implementation_minor: z.union([z.number().int().min(0).max(9007199254740991), z.null()]).optional(), estimated_recurring_monthly_minor: z.union([z.number().int().min(0).max(9007199254740991), z.null()]).optional(), invoice_recipient: InvoiceRecipientSchema.optional(), notes: z.union([z.string(), z.null()]).optional(), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")).optional(), renewal_date: z.union([vDateTime(), z.null()]).optional(), split_override_pct: z.union([z.number().min(0).max(100), z.null()]).optional(), start_date_earliest: vDateTime().optional(), start_date_latest: vDateTime().optional(), state: DealStateSchema.optional(), win_prob: z.number().min(0).max(100).optional() }).strict();
export const DialAiErrorCodeSchema = z.enum(["unauthorized", "insufficient-scope", "internal-server-error", "crm-validation-failed", "crm-unsupported-filter", "crm-unsupported-sort-field", "crm-not-found", "crm-conflict", "crm-reference-not-found", "crm-idempotency-key-reuse", "crm-fx-rate-unavailable", "crm-split-unresolvable", "crm-cost-split-unresolvable", "crm-invoice-state-invalid", "crm-precondition-required"]);
export const DriftReportFxSchema = z.object({ as_of: vDateTime(), target_currency: CurrencySchema, usd_to_cad: z.number().gt(0) }).strict();
export const DriftReportParamsSchema = z.object({ deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), due_date_gte: z.union([vDateTime(), z.null()]), due_date_lte: z.union([vDateTime(), z.null()]), limit: z.number().int().min(-9007199254740991).max(9007199254740991), min_abs_variance_pct: z.union([z.number(), z.null()]), offset: z.number().int().min(-9007199254740991).max(9007199254740991), partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), scope: ReportScopeSchema }).strict();
export const DriftReportRowsItemSchema = z.object({ customer_name: z.string(), deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), due_date: vDateTime(), gross_variance_minor: z.number().int().min(-9007199254740991).max(9007199254740991), gross_variance_pct: z.union([z.number(), z.null()]), invoiced_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), invoiced_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), our_share_variance_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), our_share_variance_pct: z.union([z.number(), z.null()]), partner_name: z.string(), period: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), revenue_line_label: z.string(), statement_gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), statement_our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), status: ChargeStatusSchema, term_line_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")) }).strict();
export const DriftReportTotalsSchema = z.object({ gross_variance_minor: z.number().int().min(-9007199254740991).max(9007199254740991), invoiced_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), our_share_variance_minor: z.number().int().min(-9007199254740991).max(9007199254740991), statement_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991) }).strict();
export const DriftReportSchema = z.object({ currency: CurrencySchema, fx: z.union([DriftReportFxSchema, z.null()]), generated_at: vDateTime(), params: DriftReportParamsSchema, rows: z.array(DriftReportRowsItemSchema), total: z.number().int().min(0).max(9007199254740991), totals: DriftReportTotalsSchema }).strict();
export const ErrorResponseV2Schema = z.object({ code: DialAiErrorCodeSchema, details: z.union([z.object({}).loose(), z.null()]), message: z.string(), traceId: z.union([z.string(), z.null()]) }).strict();
export const ErrorResponseSchema = vDiscriminatedUnion("version", ["v2"], [ErrorResponseV2Schema]);
export const FxRatesCreateSchema = z.object({ effective_date: vDateTime(), external_ref: z.union([z.string(), z.null()]).optional(), source: FactSourceSchema.optional(), usd_to_cad: z.number().gt(0) }).strict();
export const FxRatesItemSchema = z.object({ created_at: vDateTime(), effective_date: vDateTime(), external_ref: z.union([z.string(), z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), received_at: vDateTime(), source: FactSourceSchema, updated_at: vDateTime(), usd_to_cad: z.number().gt(0), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const FxRatesListSchema = z.object({ items: z.array(FxRatesItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const FxRatesUpdateSchema = z.object({ usd_to_cad: z.number().gt(0).optional() }).strict();
export const ImplementationFeeReportFxSchema = z.object({ as_of: vDateTime(), target_currency: CurrencySchema, usd_to_cad: z.number().gt(0) }).strict();
export const ImplementationFeeReportParamsSchema = z.object({ deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), scope: ReportScopeSchema, states: z.array(DealStateSchema), unresolved_only: z.boolean() }).strict();
export const ImplementationFeeReportRowsItemSchema = z.object({ agreement_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), agreement_name: z.union([z.string(), z.null()]), agreement_term_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), as_of: vDateTime(), customer_account_count: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), customer_name: z.string(), deal_currency: CurrencySchema, deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), impl_split_pct: z.union([z.number().min(0).max(100), z.null()]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string(), recorded_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), recorded_line_count: z.number().int().min(0).max(9007199254740991), state: DealStateSchema, suggested_gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), suggested_our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), term_effective_date: z.union([vDateTime(), z.null()]), tier_currency: z.union([CurrencySchema, z.null()]), tier_fee_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), tier_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), tier_max_accounts: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), unresolved_reason: z.union([ImplFeeUnresolvedReasonSchema, z.null()]), variance_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]) }).strict();
export const ImplementationFeeReportTotalsSchema = z.object({ deal_count: z.number().int().min(0).max(9007199254740991), recorded_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), resolved_deal_count: z.number().int().min(0).max(9007199254740991), suggested_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), suggested_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), variance_minor: z.number().int().min(-9007199254740991).max(9007199254740991) }).strict();
export const ImplementationFeeReportSchema = z.object({ currency: CurrencySchema, fx: z.union([ImplementationFeeReportFxSchema, z.null()]), generated_at: vDateTime(), params: ImplementationFeeReportParamsSchema, rows: z.array(ImplementationFeeReportRowsItemSchema), totals: ImplementationFeeReportTotalsSchema, unresolved_counts: z.object({ no_account_count: z.number().int().min(0).max(9007199254740991), no_agreement: z.number().int().min(0).max(9007199254740991), no_fee_schedule: z.number().int().min(0).max(9007199254740991), no_term: z.number().int().min(0).max(9007199254740991), no_tier_match: z.number().int().min(0).max(9007199254740991) }).strict() }).strict();
export const ImportedStageEntrySchema = z.object({ approximate: z.boolean().optional(), entered_at: vDateTime(), state: DealStateSchema }).strict();
export const ImportDealStageHistoryRequestSchema = z.object({ entries: z.array(ImportedStageEntrySchema).max(100), external_ref: z.string().min(1).max(200) }).strict();
export const ImportDealStageHistoryResponseSchema = z.object({ changed: z.boolean(), history: DealHistorySchema, imported_rows: z.number().int() }).strict();
export const IngestBatchResultSchema = z.object({ accepted: z.number().int().min(0), batch_id: z.string(), duplicates: z.number().int().min(0) }).strict();
export const IngestDealFactsRequestSchema = z.object({ batch_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), rows: z.array(DealFactRowSchema).max(1000), source: FactSourceSchema }).strict();
export const IngestEscalationSchema = z.object({ at: z.union([vDateTime(), z.null()]), kind: z.enum(["none", "instant", "after_ai"]) }).strict();
export const IngestFunctionCallFactSchema = z.object({ at: vDateTime(), name: z.union([z.string(), z.null()]), outcome: z.enum(["success", "not_found", "invalid_output", "api_error", "invalid_call", "timeout", "unknown"]), success_event: z.boolean() }).strict();
export const ProviderCostFactRowSchema = z.object({ amount_minor: z.number().int().min(-9007199254740991).max(9007199254740991), currency: CurrencySchema, day: vDateTime(), deployment_slug: z.union([z.string().regex(new RegExp("^(prod|nonprod)-[a-z0-9]+-[a-z0-9-]+$")), z.null()]).optional(), external_ref: z.union([z.string(), z.null()]).optional(), model: z.union([z.string(), z.null()]).optional(), operation: z.string(), provider: z.string().min(1), unit: z.string().min(1), units: z.union([z.number().min(0), z.null()]).optional(), version: z.number().int().min(1).optional() }).strict();
export const IngestProviderCostFactsRequestSchema = z.object({ batch_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), rows: z.array(ProviderCostFactRowSchema).max(1000), source: FactSourceSchema }).strict();
export const IngestTranscriptOutcomeSchema = z.object({ ai_handled: z.union([z.boolean(), z.null()]), kind: z.enum(["completed", "closed", "in_progress", "abandoned", "line_busy", "no_answer", "failed", "restarted", "human_handoff", "human_handoff_with_redial", "instant_human_handoff", "fallback_instant_human_handoff", "do_not_interact_handoff", "routed_to_csr", "unsubscribed", "answering_machine_message_left", "answering_machine_no_message_left", "reported", "skipped", "voicemail_left"]) }).strict();
export const IngestUtteranceCountsSchema = z.object({ agent: z.number().int().min(0), csr: z.number().int().min(0), customer: z.number().int().min(0) }).strict();
export const IngestTranscriptFactSchema = z.object({ direction: z.enum(["INBOUND", "OUTBOUND"]), emitted_at: vDateTime(), ended_at: z.union([vDateTime(), z.null()]), environment: z.enum(["PROD", "TEST"]), escalation: IngestEscalationSchema, flow_id: z.union([z.string(), z.null()]), function_calls: z.array(IngestFunctionCallFactSchema), outcome: IngestTranscriptOutcomeSchema, platform: z.enum(["HUMAN_PHONE", "SMS", "VOICE", "WEB", "EMAIL", "SLACK"]), started_at: vDateTime(), tenant: z.string(), transcript_id: z.string(), utterances: IngestUtteranceCountsSchema, version: z.number().int().min(0) }).strict();
export const IngestTranscriptFactsRequestSchema = z.object({ batch_id: z.string(), deployment: z.string().regex(new RegExp("^(prod|nonprod)-[a-z0-9]+-[a-z0-9-]+$")), rows: z.array(IngestTranscriptFactSchema).max(100) }).strict();
export const IngestUsageFactSchema = z.object({ audio_input_tokens: z.union([z.number().int(), z.null()]), audio_output_tokens: z.union([z.number().int(), z.null()]), audio_seconds: z.union([z.number(), z.null()]), cache_creation_input_tokens: z.union([z.number().int(), z.null()]), cached_input_tokens: z.union([z.number().int(), z.null()]), characters: z.union([z.number().int(), z.null()]), duration_ms: z.union([z.number().int(), z.null()]), feature: z.string(), hedge_role: z.union([z.string(), z.null()]), id: z.string(), input_tokens: z.union([z.number().int(), z.null()]), model: z.union([z.string(), z.null()]), occurred_at: vDateTime(), operation: z.string(), output_tokens: z.union([z.number().int(), z.null()]), product: z.string().optional(), provider: z.string(), reasoning_tokens: z.union([z.number().int(), z.null()]), region: z.union([z.string(), z.null()]).optional(), request_id: z.union([z.string(), z.null()]), status: z.string(), tenant: z.string(), transcript_id: z.union([z.string(), z.null()]), units: z.union([z.number().int(), z.null()]), usage_source: z.string(), voice: z.union([z.string(), z.null()]) }).strict();
export const IngestUsageFactsRequestSchema = z.object({ batch_id: z.string(), deployment: z.string().regex(new RegExp("^(prod|nonprod)-[a-z0-9]+-[a-z0-9-]+$")), rows: z.array(IngestUsageFactSchema).max(500) }).strict();
export const IngestUsageLossFactSchema = z.object({ dropped_overflow: z.number().int().min(0), dropped_write_failure: z.number().int().min(0), tenant: z.string(), window_end: vDateTime(), window_start: vDateTime() }).strict();
export const IngestUsageLossRequestSchema = z.object({ batch_id: z.string(), deployment: z.string().regex(new RegExp("^(prod|nonprod)-[a-z0-9]+-[a-z0-9-]+$")), rows: z.array(IngestUsageLossFactSchema).max(500) }).strict();
export const InvoiceFreezeActionSchema = z.enum(["frozen", "unchanged"]);
export const InvoiceLineCategorySchema = z.enum(["expense", "discount", "credit_note", "goodwill", "sla_credit", "true_up", "late_fee", "rounding", "other"]);
export const InvoiceLineOrphanReasonSchema = z.enum(["source_deleted", "not_on_close", "not_billable"]);
export const InvoiceLineOrphanSchema = z.object({ description: z.union([z.string(), z.null()]), detail: z.string(), line_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), period: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]), reason: InvoiceLineOrphanReasonSchema, sort_order: z.number().int().min(1).max(9007199254740991), term_line_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]) }).strict();
export const InvoiceLineSourceKindSchema = z.enum(["term_line", "standalone"]);
export const InvoiceLinesCreateSchema = z.object({ applied_split_pct: z.union([z.number().min(0).max(100), z.null()]).optional(), category: z.union([InvoiceLineCategorySchema, z.null()]).optional(), charged_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]).optional(), description: z.union([z.string().min(1).max(500), z.null()]).optional(), gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]).optional(), invoice_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), notes: z.union([z.string().min(1).max(2000), z.null()]).optional(), our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]).optional(), period: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]).optional(), sort_order: z.number().int().min(1).max(9007199254740991).optional(), term_line_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional() }).strict();
export const InvoiceLinesItemSchema = z.object({ applied_split_pct: z.union([z.number().min(0).max(100), z.null()]), breakdown: z.union([z.object({}).loose(), z.null()]), category: z.union([InvoiceLineCategorySchema, z.null()]), charge_type: z.union([z.string(), z.null()]), charged_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), created_at: vDateTime(), currency: CurrencySchema, customer_name: z.union([z.string(), z.null()]), deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), description: z.union([z.string(), z.null()]), gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), inputs_hash: z.union([z.string(), z.null()]), invoice_due_date: vDateTime(), invoice_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), invoice_number: z.union([z.string(), z.null()]), invoice_status: InvoiceStatusSchema, notes: z.union([z.string(), z.null()]), our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), period: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]), prepaid_remaining: z.union([z.string().regex(new RegExp("^-?\\d+(\\.\\d{1,9})?$")), z.null()]), quantity: z.union([z.number(), z.null()]), resolved_description: z.string(), service_period: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]), sort_order: z.number().int().min(1).max(9007199254740991), source_due_date: z.union([vDateTime(), z.null()]), source_kind: InvoiceLineSourceKindSchema, term_line_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), term_line_revision: z.union([z.number().int().min(1).max(9007199254740991), z.null()]), unit: z.union([MeterUnitSchema, z.null()]), unit_price_minor: z.union([z.string().regex(new RegExp("^-?\\d+(\\.\\d{1,9})?$")), z.null()]), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const InvoiceLinesListSchema = z.object({ items: z.array(InvoiceLinesItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const InvoiceLinesUpdateSchema = z.object({ applied_split_pct: z.union([z.number().min(0).max(100), z.null()]).optional(), category: z.union([InvoiceLineCategorySchema, z.null()]).optional(), charged_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]).optional(), description: z.union([z.string().min(1).max(500), z.null()]).optional(), gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]).optional(), notes: z.union([z.string().min(1).max(2000), z.null()]).optional(), our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]).optional(), sort_order: z.number().int().min(1).max(9007199254740991).optional() }).strict();
export const InvoiceVerificationCheckSchema = z.enum(["line_figures", "rate_gaps", "unbound_tenants", "facts_freshness", "split_source", "close_coverage", "period_delta", "currency_agreement"]);
export const InvoiceVerificationStatusSchema = z.enum(["pass", "warn", "fail"]);
export const InvoiceVerificationCheckResultSchema = z.object({ check: InvoiceVerificationCheckSchema, detail: z.string(), fix: z.union([z.string(), z.null()]), status: InvoiceVerificationStatusSchema }).strict();
export const InvoiceVerificationCountsSchema = z.object({ fail: z.number().int().min(0).max(9007199254740991), pass: z.number().int().min(0).max(9007199254740991), warn: z.number().int().min(0).max(9007199254740991) }).strict();
export const InvoiceVerificationReportSchema = z.object({ checks: z.array(InvoiceVerificationCheckResultSchema), counts: InvoiceVerificationCountsSchema, generated_at: vDateTime(), invoice_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), period: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]) }).strict();
export const InvoicesCreateSchema = z.object({ credit_note_of: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), currency: CurrencySchema, due_date: vDateTime(), notes: z.union([z.string().min(1).max(2000), z.null()]).optional(), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), payer: z.enum(["partner", "customer"]).optional(), service_period: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]).optional() }).strict();
export const InvoicesListSchema = z.object({ items: z.array(InvoicesItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const InvoicesUpdateSchema = z.object({ approved_by: z.union([z.string().min(1).max(320), z.null()]).optional(), approved_on: z.union([vDateTime(), z.null()]).optional(), credit_note_of: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), due_date: vDateTime().optional(), notes: z.union([z.string().min(1).max(2000), z.null()]).optional(), paid_date: vDateTime().optional(), payer: z.enum(["partner", "customer"]).optional(), sent_for_approval_on: z.union([vDateTime(), z.null()]).optional(), sent_for_approval_to: z.union([z.string().min(1).max(320), z.null()]).optional(), service_period: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]).optional(), status: InvoiceStatusSchema.optional() }).strict();
export const IssueInvoiceRequestSchema = z.object({ allow_open_period: z.boolean().optional(), allow_unpriced: z.boolean().optional(), invoice_number: z.string().min(1).max(64), issue_date: vDateTime().optional() }).strict();
export const IssueInvoiceResponseInvoiceSchema = z.object({ bill_charged_minor: z.number().int().min(-9007199254740991).max(9007199254740991), bill_line_count: z.number().int().min(0).max(9007199254740991), charge_types: z.array(z.string()), charged_minor: z.number().int().min(-9007199254740991).max(9007199254740991), created_at: vDateTime(), credit_note_of: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), currency: CurrencySchema, customers: z.array(z.string()), days_outstanding: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), due_date: vDateTime(), effective_split_pct: z.union([z.number().min(0).max(100), z.null()]), gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), invoice_number: z.union([z.string(), z.null()]), is_outstanding: z.boolean(), issue_date: z.union([vDateTime(), z.null()]), line_count: z.number().int().min(0).max(9007199254740991), notes: z.union([z.string(), z.null()]), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), paid_date: z.union([vDateTime(), z.null()]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string(), payer: InvoiceRecipientSchema, pending_line_count: z.number().int().min(0).max(9007199254740991), recharge_charged_minor: z.number().int().min(-9007199254740991).max(9007199254740991), recharge_line_count: z.number().int().min(0).max(9007199254740991), service_period: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]), standalone_charged_minor: z.number().int().min(-9007199254740991).max(9007199254740991), standalone_line_count: z.number().int().min(0).max(9007199254740991), status: InvoiceStatusSchema, unresolved_line_count: z.number().int().min(0).max(9007199254740991), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const IssueInvoiceResponseSchema = z.object({ allow_open_period: z.boolean(), cost_recharges_stamped: z.number().int().min(0).max(9007199254740991), invoice: IssueInvoiceResponseInvoiceSchema, schedule_items_stamped: z.number().int().min(0).max(9007199254740991) }).strict();
export const LedgerReportDocumentSchema = z.object({ currency: CurrencySchema, text: z.string(), transactions: z.number().int().min(0) }).strict();
export const LedgerReportParamsSchema = z.object({ from: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), to: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")) }).strict();
export const LedgerReportSchema = z.object({ documents: z.array(LedgerReportDocumentSchema), generated_at: vDateTime(), params: LedgerReportParamsSchema }).strict();
export const MarginCostBasisSchema = z.enum(["recharged", "metered", "none"]);
export const MarginCostLineSchema = z.object({ cost_minor: z.number().int(), key: z.string(), label: z.string(), our_cost_minor: z.number().int() }).strict();
export const MarginPrepaidBlockSchema = z.object({ drawn_quantity: z.number(), quantity: z.number(), unit: MeterUnitSchema, unit_price_minor: z.union([z.string(), z.null()]) }).strict();
export const MarginPrepaidDrawSchema = z.object({ available_quantity: z.number(), consumed_quantity: z.number(), unit: MeterUnitSchema }).strict();
export const MarginRevenueLineSchema = z.object({ from_pool: z.boolean(), gross_minor: z.number().int(), key: z.string(), label: z.string(), our_share_minor: z.number().int(), prepaid_block: z.union([MarginPrepaidBlockSchema, z.null()]), prepaid_draw: z.union([MarginPrepaidDrawSchema, z.null()]), quantity: z.union([z.number(), z.null()]), recurring: z.boolean(), unit: MeterUnitSchema, unit_price_minor: z.union([z.string(), z.null()]) }).strict();
export const MarginVolumeSchema = z.object({ conversations: z.number().int(), minutes: z.number(), whole_minutes: z.number().int() }).strict();
export const MarginReportCustomerSchema = z.object({ contribution_minor: z.union([z.number().int(), z.null()]), cost_basis: MarginCostBasisSchema, cost_lines: z.array(MarginCostLineSchema), cost_minor: z.union([z.number().int(), z.null()]), customer_name: z.string(), deal_currency: CurrencySchema, deal_id: z.string(), margin_pct: z.union([z.number(), z.null()]), one_time_gross_minor: z.number().int(), one_time_our_share_minor: z.number().int(), our_cost_minor: z.union([z.number().int(), z.null()]), partner_id: z.string(), partner_name: z.string(), pool_allocated_minor: z.number().int(), recurring_gross_minor: z.number().int(), recurring_our_share_minor: z.number().int(), revenue_lines: z.array(MarginRevenueLineSchema), revenue_share_pct: z.union([z.number(), z.null()]), unpriced_cost_line_count: z.number().int(), unpriced_revenue_line_count: z.number().int(), volume: z.union([MarginVolumeSchema, z.null()]) }).strict();
export const MarginReportFxSchema = z.object({ as_of: vDateTime(), target_currency: CurrencySchema, usd_to_cad: z.number() }).strict();
export const MarginReportParamsSchema = z.object({ currency: CurrencySchema, partner_id: z.union([z.string(), z.null()]), period: z.string(), scope: ReportScopeSchema }).strict();
export const MarginReportTotalsSchema = z.object({ contribution_minor: z.number().int(), cost_minor: z.number().int(), customers_without_cost: z.number().int(), margin_pct: z.union([z.number(), z.null()]), one_time_gross_minor: z.number().int(), one_time_our_share_minor: z.number().int(), our_cost_minor: z.number().int(), recurring_gross_minor: z.number().int(), recurring_our_share_minor: z.number().int() }).strict();
export const MarginReportSchema = z.object({ currency: CurrencySchema, customers: z.array(MarginReportCustomerSchema), fx: z.union([MarginReportFxSchema, z.null()]), generated_at: vDateTime(), metered_computed_at: z.union([vDateTime(), z.null()]), params: MarginReportParamsSchema, totals: MarginReportTotalsSchema }).strict();
export const MarginTrendPointSchema = z.object({ contribution_minor: z.union([z.number().int(), z.null()]), margin_pct: z.union([z.number(), z.null()]), our_cost_minor: z.union([z.number().int(), z.null()]), period: z.string(), recurring_our_share_minor: z.number().int() }).strict();
export const MarginTrendCustomerSchema = z.object({ customer_name: z.string(), deal_id: z.string(), points: z.array(MarginTrendPointSchema) }).strict();
export const MarginTrendParamsSchema = z.object({ currency: CurrencySchema, from_month: z.string(), partner_id: z.union([z.string(), z.null()]), scope: ReportScopeSchema, to_month: z.string() }).strict();
export const MarginTrendReportSchema = z.object({ book: z.array(MarginTrendPointSchema), currency: CurrencySchema, customers: z.array(MarginTrendCustomerSchema), generated_at: vDateTime(), params: MarginTrendParamsSchema }).strict();
export const MeterFieldNameSchema = z.enum(["tenant_slug", "flow_id", "platform", "environment", "direction", "outcome_kind", "ai_handled", "escalation_kind", "agent_utterances", "customer_utterances", "csr_utterances", "duration_seconds", "provider", "operation", "feature", "product", "model", "voice", "status", "usage_source", "hedge_role", "duration_ms", "input_tokens", "output_tokens", "cached_input_tokens", "cache_creation_input_tokens", "uncached_input_tokens", "reasoning_tokens", "audio_input_tokens", "audio_output_tokens", "units", "audio_seconds", "characters", "sku", "cost_unit", "amount_minor", "fact_source"]);
export const MeterExprFieldSchema = z.object({ name: MeterFieldNameSchema }).strict();
export const MeterExprHasFunctionSchema = z.object({ names: z.array(z.string().min(1).max(200)).min(1).max(64) }).strict();
export const MeterExprNumSchema = z.object({ value: z.number() }).strict();
export const MeterExprStrSchema = z.object({ value: z.string().max(256) }).strict();
export const MeterExprOrSchema = z.lazy(() => z.object({ operands: z.array(MeterExprSchema).min(2).max(8) }).strict());
export const MeterExprNotSchema = z.lazy(() => z.object({ operand: MeterExprSchema }).strict());
export const MeterExprNeSchema = z.lazy(() => z.object({ left: MeterExprSchema, right: MeterExprSchema }).strict());
export const MeterExprMulSchema = z.lazy(() => z.object({ left: MeterExprSchema, right: MeterExprSchema }).strict());
export const MeterExprLteSchema = z.lazy(() => z.object({ left: MeterExprSchema, right: MeterExprSchema }).strict());
export const MeterExprLtSchema = z.lazy(() => z.object({ left: MeterExprSchema, right: MeterExprSchema }).strict());
export const MeterExprInSchema = z.lazy(() => z.object({ options: z.array(z.string().max(256)).min(1).max(64), value: MeterExprSchema }).strict());
export const MeterExprGteSchema = z.lazy(() => z.object({ left: MeterExprSchema, right: MeterExprSchema }).strict());
export const MeterExprGtSchema = z.lazy(() => z.object({ left: MeterExprSchema, right: MeterExprSchema }).strict());
export const MeterExprEqSchema = z.lazy(() => z.object({ left: MeterExprSchema, right: MeterExprSchema }).strict());
export const MeterExprDivSchema = z.lazy(() => z.object({ left: MeterExprSchema, right: MeterExprSchema }).strict());
export const MeterExprAndSchema = z.lazy(() => z.object({ operands: z.array(MeterExprSchema).min(2).max(8) }).strict());
export const MeterExprSchema = z.lazy(() => vDiscriminatedUnion("kind", ["num", "str", "field", "mul", "div", "eq", "ne", "lt", "lte", "gt", "gte", "and", "or", "not", "in", "has_function"], [MeterExprNumSchema, MeterExprStrSchema, MeterExprFieldSchema, MeterExprMulSchema, MeterExprDivSchema, MeterExprEqSchema, MeterExprNeSchema, MeterExprLtSchema, MeterExprLteSchema, MeterExprGtSchema, MeterExprGteSchema, MeterExprAndSchema, MeterExprOrSchema, MeterExprNotSchema, MeterExprInSchema, MeterExprHasFunctionSchema]));
export const MeterUndefinedCountsSchema = z.object({ division_by_zero: z.number().int().min(0).max(9007199254740991), null_field: z.number().int().min(0).max(9007199254740991), rate_unavailable: z.number().int().min(0).max(9007199254740991) }).strict();
export const MilestoneStateSchema = z.enum(["billed", "reached", "planned"]);
export const MonthCloseNeedSchema = z.enum(["not_invoiced", "nothing_to_bill", "figure", "unreached", "unresolved", "ready", "invoiced"]);
export const MonthCloseReportCountsSchema = z.object({ customer_count: z.number().int().min(0).max(9007199254740991), line_count: z.number().int().min(0).max(9007199254740991), need_counts: z.object({ figure: z.number().int().min(0).max(9007199254740991), invoiced: z.number().int().min(0).max(9007199254740991), not_invoiced: z.number().int().min(0).max(9007199254740991), nothing_to_bill: z.number().int().min(0).max(9007199254740991), ready: z.number().int().min(0).max(9007199254740991), unreached: z.number().int().min(0).max(9007199254740991), unresolved: z.number().int().min(0).max(9007199254740991) }).strict(), ready_document_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const MonthCloseReportCustomersItemLinesItemSchema = z.object({ applied_split_pct: z.union([z.number().min(0).max(100), z.null()]), basis: z.string(), charge_source_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), charge_type: z.string(), collection: CollectionSchema, currency: CurrencySchema, derived_issue: z.union([DerivedFigureIssueSchema, z.null()]), due_date: vDateTime(), figure_source: FigureSourceSchema, gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), invoice_number: z.union([z.string(), z.null()]), kind: z.enum(["bill", "cost_recharge"]), label: z.string(), milestone_label: z.union([z.string(), z.null()]), need: MonthCloseNeedSchema, note: z.union([z.string(), z.null()]), our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), period_open: z.union([z.boolean(), z.null()]), quantity: z.union([z.number(), z.null()]), rate_minor: z.union([z.string().regex(new RegExp("^-?\\d+(\\.\\d{1,9})?$")), z.null()]), status: ChargeStatusSchema, term_line_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), term_line_revision: z.union([z.number().int().min(1).max(9007199254740991), z.null()]), unit: z.union([MeterUnitSchema, z.null()]), unpriced: DealStatementLineUnpricedSchema }).strict();
export const MonthCloseReportCustomersItemSchema = z.object({ charge_types: z.array(z.string()), currency: CurrencySchema, customer_name: z.union([z.string(), z.null()]), deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), due_date: vDateTime(), known_minor: z.number().int().min(-9007199254740991).max(9007199254740991), lines: z.array(MonthCloseReportCustomersItemLinesItemSchema), need_counts: z.object({ figure: z.number().int().min(0).max(9007199254740991), invoiced: z.number().int().min(0).max(9007199254740991), not_invoiced: z.number().int().min(0).max(9007199254740991), nothing_to_bill: z.number().int().min(0).max(9007199254740991), ready: z.number().int().min(0).max(9007199254740991), unreached: z.number().int().min(0).max(9007199254740991), unresolved: z.number().int().min(0).max(9007199254740991) }).strict(), not_invoiced_count: z.number().int().min(0).max(9007199254740991), not_invoiced_minor: z.number().int().min(-9007199254740991).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string(), pending_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const MonthCloseReportFxSchema = z.object({ as_of: z.union([vDateTime(), z.null()]), status: z.enum(["display_converted", "not_needed", "unavailable"]), target_currency: CurrencySchema, usd_to_cad: z.union([z.number().gt(0), z.null()]) }).strict();
export const MonthCloseReportParamsSchema = z.object({ partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), period: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), scope: ReportScopeSchema }).strict();
export const MonthCloseReportTotalsConvertedSchema = z.object({ known_minor: z.number().int().min(-9007199254740991).max(9007199254740991), not_invoiced_minor: z.number().int().min(-9007199254740991).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), pending_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const MonthCloseReportTotalsItemSchema = z.object({ currency: CurrencySchema, known_minor: z.number().int().min(-9007199254740991).max(9007199254740991), not_invoiced_minor: z.number().int().min(-9007199254740991).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), pending_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const MonthCloseReportSchema = z.object({ counts: MonthCloseReportCountsSchema, currency: CurrencySchema, customers: z.array(MonthCloseReportCustomersItemSchema), fx: MonthCloseReportFxSchema, generated_at: vDateTime(), params: MonthCloseReportParamsSchema, totals: z.array(MonthCloseReportTotalsItemSchema), totals_converted: z.union([MonthCloseReportTotalsConvertedSchema, z.null()]) }).strict();
export const NoteEmbeddingStateSchema = z.enum(["pending", "ready", "failed"]);
export const NoteKindSchema = z.enum(["meeting", "call", "email", "manual", "other"]);
export const NoteReembedScopeSchema = z.enum(["failed", "deal", "all"]);
export const NoteSearchResultsItemSchema = z.object({ chunk_ordinal: z.number().int().min(0), customer_name: z.union([z.string(), z.null()]), deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), keyword_rank: z.union([z.number().int().min(1), z.null()]), kind: NoteKindSchema, note_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), occurred_at: z.union([vDateTime(), z.null()]), score: z.number(), semantic_rank: z.union([z.number().int().min(1), z.null()]), snippet: z.string(), title: z.union([z.string(), z.null()]) }).strict();
export const NoteSearchResultsSchema = z.object({ failed_notes: z.number().int().min(0), items: z.array(NoteSearchResultsItemSchema), pending_notes: z.number().int().min(0), query: z.string(), semantic: z.boolean() }).strict();
export const NoteSourceSchema = z.enum(["person", "import", "notetaker"]);
export const NotesCreateSchema = z.object({ author: z.union([z.string(), z.null()]).optional(), body: z.string().min(1), deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), external_ref: z.union([z.string(), z.null()]).optional(), kind: NoteKindSchema, occurred_at: z.union([vDateTime(), z.null()]).optional(), participants: z.array(z.string().min(1)).optional(), source: NoteSourceSchema, summary: z.union([z.string(), z.null()]).optional(), title: z.union([z.string(), z.null()]).optional() }).strict();
export const NotesDetailSchema = z.object({ author: z.union([z.string(), z.null()]), body: z.string(), created_at: vDateTime(), deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), embedding_error: z.union([z.string(), z.null()]), embedding_state: NoteEmbeddingStateSchema, external_ref: z.union([z.string(), z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), kind: NoteKindSchema, occurred_at: z.union([vDateTime(), z.null()]), participants: z.array(z.string().min(1)), received_at: vDateTime(), source: NoteSourceSchema, summary: z.union([z.string(), z.null()]), title: z.union([z.string(), z.null()]), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const NotesItemSchema = z.object({ author: z.union([z.string(), z.null()]), created_at: vDateTime(), deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), embedding_error: z.union([z.string(), z.null()]), embedding_state: NoteEmbeddingStateSchema, external_ref: z.union([z.string(), z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), kind: NoteKindSchema, occurred_at: z.union([vDateTime(), z.null()]), participants: z.array(z.string().min(1)), received_at: vDateTime(), source: NoteSourceSchema, summary: z.union([z.string(), z.null()]), title: z.union([z.string(), z.null()]), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const NotesListSchema = z.object({ items: z.array(NotesItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const NotesReembedRequestSchema = z.object({ deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")).optional(), scope: NoteReembedScopeSchema }).strict();
export const NotesReembedResultSchema = z.object({ already_pending: z.number().int().min(0), queued: z.number().int().min(0), scope: NoteReembedScopeSchema }).strict();
export const NotesUpdateSchema = z.object({ author: z.union([z.string(), z.null()]).optional(), body: z.string().min(1).optional(), deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), embedding_state: z.enum(["pending"]).optional(), kind: NoteKindSchema.optional(), occurred_at: z.union([vDateTime(), z.null()]).optional(), participants: z.array(z.string().min(1)).optional(), summary: z.union([z.string(), z.null()]).optional(), title: z.union([z.string(), z.null()]).optional() }).strict();
export const PartnerRollupReportFxSchema = z.object({ as_of: vDateTime(), target_currency: CurrencySchema, usd_to_cad: z.number().gt(0) }).strict();
export const PartnerRollupReportParamsSchema = z.object({ partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), scope: ReportScopeSchema }).strict();
export const PartnerRollupReportRowsItemSchema = z.object({ billed_to_date_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), billed_to_date_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), child_partner_count: z.number().int().min(0).max(9007199254740991), contracted_recurring_annual_minor: z.number().int().min(-9007199254740991).max(9007199254740991), cost_absorbed_to_date_minor: z.number().int().min(-9007199254740991).max(9007199254740991), cost_pending_recharge_minor: z.number().int().min(-9007199254740991).max(9007199254740991), cost_recharged_to_date_minor: z.number().int().min(-9007199254740991).max(9007199254740991), depth: z.number().int().min(0).max(9007199254740991), effective_blended_split_pct: z.union([z.number().min(0).max(100), z.null()]), member_partner_count: z.number().int().min(1).max(9007199254740991), open_deal_count: z.number().int().min(0).max(9007199254740991), open_pipeline_weighted_minor: z.number().int().min(-9007199254740991).max(9007199254740991), parent_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), parent_name: z.union([z.string(), z.null()]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string() }).strict();
export const PartnerRollupReportTotalsSchema = z.object({ billed_to_date_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), billed_to_date_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), contracted_recurring_annual_minor: z.number().int().min(-9007199254740991).max(9007199254740991), cost_absorbed_to_date_minor: z.number().int().min(-9007199254740991).max(9007199254740991), cost_pending_recharge_minor: z.number().int().min(-9007199254740991).max(9007199254740991), cost_recharged_to_date_minor: z.number().int().min(-9007199254740991).max(9007199254740991), open_pipeline_weighted_minor: z.number().int().min(-9007199254740991).max(9007199254740991) }).strict();
export const PartnerRollupReportSchema = z.object({ currency: CurrencySchema, fx: z.union([PartnerRollupReportFxSchema, z.null()]), generated_at: vDateTime(), params: PartnerRollupReportParamsSchema, rows: z.array(PartnerRollupReportRowsItemSchema), totals: PartnerRollupReportTotalsSchema }).strict();
export const PartnersCreateSchema = z.object({ color: z.union([z.string().regex(new RegExp("^#[0-9a-f]{6}$")), z.null()]).optional(), name: z.string().min(1).max(200), notes: z.union([z.string(), z.null()]).optional(), parent_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional() }).strict();
export const PartnersItemSchema = z.object({ child_count: z.number().int().min(0).max(9007199254740991), color: z.union([z.string().regex(new RegExp("^#[0-9a-f]{6}$")), z.null()]), created_at: vDateTime(), depth: z.number().int().min(0).max(9007199254740991), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), name: z.string().min(1).max(200), notes: z.union([z.string(), z.null()]), parent_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), parent_name: z.union([z.string(), z.null()]), root_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const PartnersListSchema = z.object({ items: z.array(PartnersItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const PartnersUpdateSchema = z.object({ color: z.union([z.string().regex(new RegExp("^#[0-9a-f]{6}$")), z.null()]).optional(), name: z.string().min(1).max(200).optional(), notes: z.union([z.string(), z.null()]).optional(), parent_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional() }).strict();
export const PipelineReportFxSchema = z.object({ as_of: vDateTime(), target_currency: CurrencySchema, usd_to_cad: z.number().gt(0) }).strict();
export const PipelineReportParamsSchema = z.object({ from_month: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), scope: ReportScopeSchema, states: z.array(DealStateSchema), to_month: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")) }).strict();
export const PipelineReportRowsItemSchema = z.object({ deal_count: z.number().int().min(0).max(9007199254740991), month: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), unweighted_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), weighted_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), weighted_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991) }).strict();
export const PipelineReportTotalsSchema = z.object({ unweighted_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), weighted_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), weighted_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991) }).strict();
export const PipelineReportSchema = z.object({ currency: CurrencySchema, fx: z.union([PipelineReportFxSchema, z.null()]), generated_at: vDateTime(), params: PipelineReportParamsSchema, rows: z.array(PipelineReportRowsItemSchema), totals: PipelineReportTotalsSchema }).strict();
export const PrepaidEntitlementsCreateSchema = z.object({ carry_over: CarryOverSchema.optional(), covered_term_line_ids: z.array(z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$"))), deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), note: z.union([z.string(), z.null()]).optional(), partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), period_end: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), period_start: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), quantity: z.number().min(0), source_term_line_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), unit: MeterUnitSchema }).strict();
export const PrepaidEntitlementsItemSchema = z.object({ carry_over: CarryOverSchema, covered_term_line_ids: z.array(z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$"))), created_at: vDateTime(), deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), note: z.union([z.string(), z.null()]), partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), period_end: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), period_start: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), quantity: z.number().min(0), source_term_line_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), unit: MeterUnitSchema, updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const PrepaidEntitlementsListSchema = z.object({ items: z.array(PrepaidEntitlementsItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const PrepaidEntitlementsUpdateSchema = z.object({ carry_over: CarryOverSchema.optional(), covered_term_line_ids: z.array(z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$"))).optional(), note: z.union([z.string(), z.null()]).optional(), period_end: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")).optional(), period_start: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")).optional(), quantity: z.number().min(0).optional(), unit: MeterUnitSchema.optional() }).strict();
export const PriceSourceSchema = z.enum(["contract_rate", "flat_per_period", "fact_amount"]);
export const ShareKindSchema = z.enum(["implementation", "recurring", "cost"]);
export const TermLineMilestoneSchema = z.object({ label: z.string().min(1), pct: z.number().min(0).max(100), planned_on: z.union([vDateTime(), z.null()]), seq: z.number().int().min(1).max(9007199254740991) }).strict();
export const TermLinePreviewSchema = z.object({ amount_minor: z.union([z.number().int().min(0).max(9007199254740991), z.null()]).optional(), billing_timing: BillingTimingSchema.optional(), cadence: CadenceSchema, collection: CollectionSchema.optional(), effective_from: vDateTime(), effective_to: z.union([vDateTime(), z.null()]).optional(), kind: TermLineKindSchema, label: z.string().min(1), milestones: z.union([z.array(TermLineMilestoneSchema), z.null()]).optional(), price_source: PriceSourceSchema, quantity: z.union([MeterExprSchema, z.null()]).optional(), rate_minor: z.union([z.number().int().min(0).max(9007199254740991), z.null()]).optional(), share_kind: ShareKindSchema, share_override_pct: z.union([z.number().min(0).max(100), z.null()]).optional(), source: MeterSourceSchema, stacks_with: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), unit: MeterUnitSchema, where: z.union([MeterExprSchema, z.null()]).optional() }).strict();
export const PreviewDealStatementRequestSchema = z.object({ period: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), replaces_term_line_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), term_line: TermLinePreviewSchema }).strict();
export const ProjectionActualSchema = z.object({ gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), our_cost_minor: z.number().int().min(-9007199254740991).max(9007199254740991).optional(), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991) }).strict();
export const ProjectionAssumptionsSchema = z.object({ assumed_split_pct: z.number().min(0).max(100), go_lives_per_month: z.number().max(1000).gt(0), implementation_kickoff_pct: z.number().min(0).max(100), implementation_lead_months: z.number().int().min(0).max(36), margin_pct: z.number().min(-100).max(100), monthly_growth_pct: z.number().min(-50).max(100) }).strict();
export const ProjectionBasisSchema = z.enum(["contracted", "estimate", "missing"]);
export const ProjectionContractedSchema = z.object({ gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), our_cost_minor: z.number().int().min(-9007199254740991).max(9007199254740991).optional(), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), unpriced_line_count: z.number().int().min(0) }).strict();
export const ProjectionEstimateSchema = z.object({ assumed_share_deal_count: z.number().int().min(0), gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), implementation_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), margin_minor: z.number().int().min(-9007199254740991).max(9007199254740991), our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), recurring_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), weighted_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), weighted_margin_minor: z.number().int().min(-9007199254740991).max(9007199254740991), weighted_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991) }).strict();
export const ProjectionGoLiveSourceSchema = z.enum(["set", "scheduled", "live", "unscheduled"]);
export const ProjectionReportDealSchema = z.object({ basis: ProjectionBasisSchema, currency: CurrencySchema, customer_name: z.string(), deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), estimated_implementation_minor: z.union([z.number().int().min(0).max(9007199254740991), z.null()]), estimated_recurring_monthly_minor: z.union([z.number().int().min(0).max(9007199254740991), z.null()]), go_live_month: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]), go_live_source: z.union([ProjectionGoLiveSourceSchema, z.null()]), implementation_share_pct: z.union([z.number().min(0).max(100), z.null()]), kickoff_month: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string(), recurring_share_pct: z.union([z.number().min(0).max(100), z.null()]), share_source: z.union([ProjectionShareSourceSchema, z.null()]), state: DealStateSchema, win_prob: z.number().min(0).max(100), window_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), window_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), window_weighted_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991) }).strict();
export const ProjectionReportFxSchema = z.object({ as_of: vDateTime(), target_currency: CurrencySchema, usd_to_cad: z.number().gt(0) }).strict();
export const ProjectionReportParamsSchema = z.object({ assumptions: ProjectionAssumptionsSchema, from_month: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), include_costs: z.boolean(), partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), scope: ReportScopeSchema, settings_version: z.number().int().min(1), to_month: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")) }).strict();
export const ProjectionReportRowsItemSchema = z.object({ actual: ProjectionActualSchema, contracted: ProjectionContractedSchema, estimate: ProjectionEstimateSchema, expected_go_lives: z.number().min(0), go_live_capacity: z.number().min(0), month: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")) }).strict();
export const ProjectionReportTotalsSchema = z.object({ actual: ProjectionActualSchema, contracted: ProjectionContractedSchema, estimate: ProjectionEstimateSchema, expected_go_lives: z.number().min(0) }).strict();
export const ProjectionReportSchema = z.object({ currency: CurrencySchema, deals: z.array(ProjectionReportDealSchema), fx: z.union([ProjectionReportFxSchema, z.null()]), generated_at: vDateTime(), params: ProjectionReportParamsSchema, rows: z.array(ProjectionReportRowsItemSchema), totals: ProjectionReportTotalsSchema }).strict();
export const ProjectionSettingsSchema = z.object({ assumed_split_pct: z.number().min(0).max(100), created_at: vDateTime(), go_lives_per_month: z.number().max(1000).gt(0), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), implementation_kickoff_pct: z.number().min(0).max(100), implementation_lead_months: z.number().int().min(0).max(36), margin_pct: z.number().min(-100).max(100), monthly_growth_pct: z.number().min(-50).max(100), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const ProjectionSettingsUpdateSchema = z.object({ assumed_split_pct: z.number().min(0).max(100).optional(), go_lives_per_month: z.number().max(1000).gt(0).optional(), implementation_kickoff_pct: z.number().min(0).max(100).optional(), implementation_lead_months: z.number().int().min(0).max(36).optional(), margin_pct: z.number().min(-100).max(100).optional(), monthly_growth_pct: z.number().min(-50).max(100).optional() }).strict();
export const ProviderCostFactsItemSchema = z.object({ amount_minor: z.number().int().min(-9007199254740991).max(9007199254740991), currency: CurrencySchema, day: vDateTime(), deployment_slug: z.union([z.string().regex(new RegExp("^(prod|nonprod)-[a-z0-9]+-[a-z0-9-]+$")), z.null()]), external_ref: z.union([z.string(), z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), model: z.union([z.string(), z.null()]), operation: z.string(), provider: z.string().min(1), received_at: vDateTime(), source: FactSourceSchema, unit: z.string().min(1), units: z.union([z.number().min(0), z.null()]), version: z.number().int().min(1) }).strict();
export const ProviderCostFactsListSchema = z.object({ items: z.array(ProviderCostFactsItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const RateUnitSchema = z.enum(["input_token", "output_token", "cached_input_token", "cache_creation_input_token", "reasoning_token", "audio_input_token", "audio_output_token", "unit", "audio_second", "character", "carrier_minute", "minute"]);
export const ProviderRatesCreateSchema = z.object({ currency: CurrencySchema, effective_from: vDateTime(), effective_to: z.union([vDateTime(), z.null()]).optional(), external_ref: z.union([z.string(), z.null()]).optional(), model: z.union([z.string().min(1), z.null()]).optional(), operation: z.string().min(1), price_per_unit: z.string().max(19).regex(new RegExp("^\\d{1,9}(\\.\\d{1,9})?$")), provider: z.string().min(1), region: z.union([z.string().min(1), z.null()]).optional(), source: FactSourceSchema.optional(), unit: RateUnitSchema }).strict();
export const ProviderRatesItemSchema = z.object({ created_at: vDateTime(), currency: CurrencySchema, effective_from: vDateTime(), effective_to: z.union([vDateTime(), z.null()]), external_ref: z.union([z.string(), z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), model: z.union([z.string().min(1), z.null()]), operation: z.string().min(1), price_per_unit: z.string().max(19).regex(new RegExp("^\\d{1,9}(\\.\\d{1,9})?$")), provider: z.string().min(1), received_at: vDateTime(), region: z.union([z.string().min(1), z.null()]), source: FactSourceSchema, unit: RateUnitSchema, updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const ProviderRatesListSchema = z.object({ items: z.array(ProviderRatesItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const ProviderRatesUpdateSchema = z.object({ currency: CurrencySchema.optional(), price_per_unit: z.string().max(19).regex(new RegExp("^\\d{1,9}(\\.\\d{1,9})?$")).optional() }).strict();
export const RefreshInvoiceLinesResponseSchema = z.object({ added: z.array(InvoiceDraftLineSchema), invoice: InvoicesItemSchema, orphaned: z.array(InvoiceLineOrphanSchema), period: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")) }).strict();
export const RevenueByRegionGroupBySchema = z.enum(["country", "region"]);
export const RevenueByRegionReportFxSchema = z.object({ as_of: vDateTime(), target_currency: CurrencySchema, usd_to_cad: z.number().gt(0) }).strict();
export const RevenueByRegionReportParamsSchema = z.object({ group_by: RevenueByRegionGroupBySchema, partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), scope: ReportScopeSchema }).strict();
export const RevenueByRegionReportRowsItemSchema = z.object({ billed_to_date_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), billed_to_date_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), contracted_gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), contracted_our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), country: z.union([z.string(), z.null()]), customer_count: z.number().int().min(0).max(9007199254740991), deal_count: z.number().int().min(0).max(9007199254740991), is_unlocated: z.boolean(), key: z.string(), label: z.string(), lat: z.union([z.number(), z.null()]), lng: z.union([z.number(), z.null()]), located_deal_count: z.number().int().min(0).max(9007199254740991), region: z.union([z.string(), z.null()]), unresolved_item_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const RevenueByRegionReportTotalsSchema = z.object({ billed_to_date_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), billed_to_date_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), contracted_gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), contracted_our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), customer_count: z.number().int().min(0).max(9007199254740991), deal_count: z.number().int().min(0).max(9007199254740991), unresolved_item_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const RevenueByRegionReportSchema = z.object({ currency: CurrencySchema, fx: z.union([RevenueByRegionReportFxSchema, z.null()]), generated_at: vDateTime(), params: RevenueByRegionReportParamsSchema, rows: z.array(RevenueByRegionReportRowsItemSchema), totals: RevenueByRegionReportTotalsSchema }).strict();
export const RunwayReportCountsSchema = z.object({ confirmed_count: z.number().int().min(0).max(9007199254740991), engagement_count: z.number().int().min(0).max(9007199254740991), forecast_count: z.number().int().min(0).max(9007199254740991), reached_count: z.number().int().min(0).max(9007199254740991), slipped_engagement_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const RunwayReportEngagementsItemMilestonesItemSchema = z.object({ applied_split_pct: z.union([z.number().min(0).max(100), z.null()]), baseline_due_date: vDateTime(), days_shifted: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), due_date: vDateTime(), gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), invoice_number: z.union([z.string(), z.null()]), label: z.string(), our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), pct: z.union([z.number().min(0).max(100), z.null()]), plan_month_from: z.union([z.number().int().min(1).max(9007199254740991), z.null()]), plan_month_to: z.union([z.number().int().min(1).max(9007199254740991), z.null()]), reached_on: z.union([vDateTime(), z.null()]), reached_period: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]), seq: z.number().int().min(1).max(9007199254740991), state: MilestoneStateSchema, status: ChargeStatusSchema }).strict();
export const RunwayReportEngagementsItemSchema = z.object({ billed_count: z.number().int().min(0).max(9007199254740991), billed_minor: z.number().int().min(-9007199254740991).max(9007199254740991), currency: CurrencySchema, customer_name: z.string(), deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), fee_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), forecast_count: z.number().int().min(0).max(9007199254740991), label: z.string(), milestone_count: z.number().int().min(0).max(9007199254740991), milestones: z.array(RunwayReportEngagementsItemMilestonesItemSchema), next_due_date: z.union([vDateTime(), z.null()]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), partner_name: z.string(), pending_count: z.number().int().min(0).max(9007199254740991), reached_count: z.number().int().min(0).max(9007199254740991), remaining_minor: z.number().int().min(-9007199254740991).max(9007199254740991), term_line_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")) }).strict();
export const RunwayReportNextEventsItemSchema = z.object({ currency: CurrencySchema, customer_name: z.string(), days_shifted: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), due_date: vDateTime(), gross_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), label: z.string(), milestone_count: z.number().int().min(0).max(9007199254740991), our_share_minor: z.union([z.number().int().min(-9007199254740991).max(9007199254740991), z.null()]), partner_name: z.string(), plan_month_from: z.union([z.number().int().min(1).max(9007199254740991), z.null()]), plan_month_to: z.union([z.number().int().min(1).max(9007199254740991), z.null()]), reached_on: z.union([vDateTime(), z.null()]), reached_period: z.union([z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), z.null()]), seq: z.number().int().min(1).max(9007199254740991), state: MilestoneStateSchema, term_line_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")) }).strict();
export const RunwayReportParamsSchema = z.object({ as_of: vDateTime(), include_complete: z.boolean(), partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), scope: ReportScopeSchema }).strict();
export const RunwayReportSchema = z.object({ counts: RunwayReportCountsSchema, engagements: z.array(RunwayReportEngagementsItemSchema), generated_at: vDateTime(), next_events: z.array(RunwayReportNextEventsItemSchema), params: RunwayReportParamsSchema }).strict();
export const SalesAmountsSchema = z.object({ gross_minor: z.number().int(), our_share_minor: z.number().int(), weighted_minor: z.number().int(), weighted_our_share_minor: z.number().int() }).strict();
export const SalesBridgeCategorySchema = z.enum(["new", "reopened", "increased", "decreased", "unchanged", "won", "lost", "removed"]);
export const SalesChangeActorSchema = z.enum(["user", "agent", "import"]);
export const SalesBridgeDealSchema = z.object({ category: SalesBridgeCategorySchema, customer_name: z.string(), deal_id: z.string(), delta: SalesAmountsSchema, from: z.union([SalesAmountsSchema, z.null()]), go_live_from: z.union([vDateTime(), z.null()]), go_live_to: z.union([vDateTime(), z.null()]), last_changed_at: z.union([vDateTime(), z.null()]), last_changed_by: z.union([SalesChangeActorSchema, z.null()]), last_changed_by_subject: z.union([z.string(), z.null()]), partner_name: z.string(), state_from: z.union([DealStateSchema, z.null()]), state_to: z.union([DealStateSchema, z.null()]), to: z.union([SalesAmountsSchema, z.null()]) }).strict();
export const SalesBridgeStepSchema = z.object({ category: SalesBridgeCategorySchema, count: z.number().int(), delta: SalesAmountsSchema }).strict();
export const SalesBridgeSchema = z.object({ closing: SalesAmountsSchema, deals: z.array(SalesBridgeDealSchema), from: vDateTime(), opening: SalesAmountsSchema, steps: z.array(SalesBridgeStepSchema), to: vDateTime() }).strict();
export const SalesBucketSchema = z.enum(["week", "month"]);
export const SalesDealBucketSchema = z.object({ arr: SalesAmountsSchema, deal_id: z.string(), new: SalesAmountsSchema, open: SalesAmountsSchema, won: SalesAmountsSchema }).strict();
export const SalesPartnerBucketSchema = z.object({ arr: SalesAmountsSchema, arr_count: z.number().int(), lost: SalesAmountsSchema, lost_count: z.number().int(), new: SalesAmountsSchema, new_count: z.number().int(), open: SalesAmountsSchema, open_count: z.number().int(), partner_id: z.string(), won: SalesAmountsSchema, won_count: z.number().int() }).strict();
export const SalesStageAmountSchema = z.object({ amounts: SalesAmountsSchema, count: z.number().int(), state: DealStateSchema }).strict();
export const SalesBucketRowSchema = z.object({ approximate_moves: z.number().int(), as_of: vDateTime(), deals: z.array(SalesDealBucketSchema), deals_touched: z.number().int(), end: vDateTime(), estimated_from_first_record_count: z.number().int(), forecast_next_12m: SalesAmountsSchema, lost: SalesAmountsSchema, lost_count: z.number().int(), meetings: z.number().int(), moves_backward: z.number().int(), moves_forward: z.number().int(), notes: z.number().int(), open: SalesAmountsSchema, open_count: z.number().int(), partners: z.array(SalesPartnerBucketSchema), stages: z.array(SalesStageAmountSchema), start: vDateTime(), won: SalesAmountsSchema, won_count: z.number().int() }).strict();
export const SalesCloseMonthSchema = z.object({ approximate_count: z.number().int(), lost: SalesAmountsSchema, lost_count: z.number().int(), month: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), won: SalesAmountsSchema, won_count: z.number().int() }).strict();
export const SalesColdDealSchema = z.object({ amounts: SalesAmountsSchema, customer_name: z.string(), deal_id: z.string(), idle_days: z.number().int(), last_change_at: z.union([vDateTime(), z.null()]), last_note_at: z.union([vDateTime(), z.null()]), partner_name: z.string(), state: DealStateSchema }).strict();
export const SalesDealAmountSchema = z.object({ amounts: SalesAmountsSchema, deal_id: z.string() }).strict();
export const SalesDealRefSchema = z.object({ customer_name: z.string(), deal_id: z.string(), partner_id: z.string(), state: DealStateSchema }).strict();
export const SalesPartnerAmountSchema = z.object({ amounts: SalesAmountsSchema, count: z.number().int(), partner_id: z.string() }).strict();
export const SalesForecastMonthSchema = z.object({ amounts: SalesAmountsSchema, deals: z.array(SalesDealAmountSchema), month: z.string().regex(new RegExp("^[0-9]{4}-(0[1-9]|1[0-2])$")), partners: z.array(SalesPartnerAmountSchema), stages: z.array(SalesStageAmountSchema) }).strict();
export const SalesFunnelStageSchema = z.object({ advanced_count: z.number().int(), amounts: SalesAmountsSchema, average_gross_minor: z.union([z.number().int(), z.null()]), count: z.number().int(), entered_count: z.number().int(), lost_count: z.number().int(), median_days_in_stage: z.union([z.number(), z.null()]), state: DealStateSchema, stays_measured: z.number().int() }).strict();
export const SalesHistoryCoverageSchema = z.object({ approximate_moves: z.number().int(), crm_since: z.union([vDateTime(), z.null()]), imported_since: z.union([vDateTime(), z.null()]), unconverted_deal_count: z.number().int() }).strict();
export const SalesMixRowSchema = z.object({ accounts: z.union([z.number().int(), z.null()]), amounts: SalesAmountsSchema, count: z.number().int(), key: z.string(), label: z.string(), per_account_annual_minor: z.union([z.number().int(), z.null()]) }).strict();
export const SalesMixSchema = z.object({ by_partner: z.array(SalesMixRowSchema), by_region: z.array(SalesMixRowSchema), by_size: z.array(SalesMixRowSchema) }).strict();
export const SalesMoveDirectionSchema = z.enum(["forward", "backward", "won", "lost", "reopened", "delivery"]);
export const SalesOpenDealSchema = z.object({ amounts: SalesAmountsSchema, customer_name: z.string(), days_in_stage: z.union([z.number().int(), z.null()]), deal_id: z.string(), idle_days: z.number().int(), partner_id: z.string(), partner_name: z.string(), state: DealStateSchema }).strict();
export const SalesPartnerSchema = z.object({ cycles_measured: z.number().int(), lost: SalesAmountsSchema, lost_count: z.number().int(), median_cycle_days: z.union([z.number(), z.null()]), open: SalesAmountsSchema, open_count: z.number().int(), partner_id: z.string(), partner_name: z.string(), won: SalesAmountsSchema, won_count: z.number().int() }).strict();
export const SalesReportParamsSchema = z.object({ bucket: SalesBucketSchema, cold_days: z.number().int(), from: vDateTime(), partner_id: z.union([z.string(), z.null()]), scope: ReportScopeSchema, to: vDateTime() }).strict();
export const SalesStageMoveSchema = z.object({ customer_name: z.string(), deal_id: z.string(), from: SalesAmountsSchema, go_live_from: z.union([vDateTime(), z.null()]), go_live_to: z.union([vDateTime(), z.null()]), last_changed_at: z.union([vDateTime(), z.null()]), last_changed_by: z.union([SalesChangeActorSchema, z.null()]), last_changed_by_subject: z.union([z.string(), z.null()]), moved_at: vDateTime(), partner_name: z.string(), state_from: DealStateSchema, state_to: DealStateSchema, to: SalesAmountsSchema }).strict();
export const SalesTransitionSchema = z.object({ approximate_count: z.number().int(), count: z.number().int(), direction: SalesMoveDirectionSchema, from_state: DealStateSchema, to_state: DealStateSchema }).strict();
export const SalesReportSchema = z.object({ arr_closing: SalesAmountsSchema, arr_opening: SalesAmountsSchema, bridge: SalesBridgeSchema, buckets: z.array(SalesBucketRowSchema), closes: z.array(SalesCloseMonthSchema), cold_deals: z.array(SalesColdDealSchema), currency: CurrencySchema, cycles_measured: z.number().int(), deals: z.array(SalesDealRefSchema), forecast_months: z.array(SalesForecastMonthSchema), funnel: z.array(SalesFunnelStageSchema), fx: BillingLineupReportFxSchema, generated_at: vDateTime(), history: SalesHistoryCoverageSchema, median_cycle_days: z.union([z.number(), z.null()]), mix: SalesMixSchema, open_deals: z.array(SalesOpenDealSchema), params: SalesReportParamsSchema, partners: z.array(SalesPartnerSchema), stage_moves: z.array(SalesStageMoveSchema), transitions: z.array(SalesTransitionSchema) }).strict();
export const SearchHitKindSchema = z.enum(["deal", "partner", "agreement", "invoice", "term_line", "tenant_binding", "note"]);
export const SearchHitSchema = z.object({ deal_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), kind: SearchHitKindSchema, snippet: z.union([z.string(), z.null()]), subtitle: z.union([z.string(), z.null()]), title: z.string() }).strict();
export const SearchResultsGroupSchema = z.object({ hits: z.array(SearchHitSchema), kind: SearchHitKindSchema, total: z.number().int().min(0) }).strict();
export const SearchResultsSchema = z.object({ groups: z.array(SearchResultsGroupSchema), pending_notes: z.number().int().min(0), query: z.string(), semantic: z.boolean() }).strict();
export const SessionInfoSchema = z.object({ actor_type: ActorTypeSchema, display_name: z.string(), expires_at: z.union([vDateTime(), z.null()]), roles: z.array(z.string()), subject: z.string() }).strict();
export const SetProviderRateRequestSchema = z.object({ currency: CurrencySchema, effective_from: vDateTime(), effective_to: z.union([vDateTime(), z.null()]).optional(), model: z.union([z.string().min(1), z.null()]).optional(), operation: z.string().min(1), price_per_unit: z.string().max(19).regex(new RegExp("^\\d{1,9}(\\.\\d{1,9})?$")), provider: z.string().min(1), region: z.union([z.string().min(1), z.null()]).optional(), unit: RateUnitSchema }).strict();
export const SetProviderRateResponseSchema = z.object({ rate: ProviderRatesItemSchema, superseded: z.union([ProviderRatesItemSchema, z.null()]) }).strict();
export const UsageJobKindSchema = z.enum(["rollup_refresh"]);
export const StartUsageJobRequestSchema = z.object({ deployment_slug: z.array(z.string().regex(new RegExp("^(prod|nonprod)-[a-z0-9]+-[a-z0-9-]+$"))).optional(), force: z.boolean().optional(), kind: UsageJobKindSchema, period: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), tenant_slug: z.array(z.string().min(1)).optional() }).strict();
export const TenantBindingsCreateSchema = z.object({ deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), deployment_slug: z.string().regex(new RegExp("^(prod|nonprod)-[a-z0-9]+-[a-z0-9-]+$")), effective_from: vDateTime(), effective_to: z.union([vDateTime(), z.null()]).optional(), tenant_slug: z.string().min(1) }).strict();
export const TenantBindingsItemSchema = z.object({ created_at: vDateTime(), deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), deployment_slug: z.string().regex(new RegExp("^(prod|nonprod)-[a-z0-9]+-[a-z0-9-]+$")), effective_from: vDateTime(), effective_to: z.union([vDateTime(), z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), tenant_slug: z.string().min(1), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991) }).strict();
export const TenantBindingsListSchema = z.object({ items: z.array(TenantBindingsItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const TenantBindingsUpdateSchema = z.object({ deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")).optional(), effective_to: z.union([vDateTime(), z.null()]).optional() }).strict();
export const TermLineRevisionsItemSchema = z.object({ actor_subject: z.string(), body: z.object({}).loose(), body_hash: z.string(), created_at: vDateTime(), revision: z.number().int().min(1).max(9007199254740991), term_line_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")) }).strict();
export const TermLineRevisionsListSchema = z.object({ items: z.array(TermLineRevisionsItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const TermLineUnreadableSchema = z.object({ field: z.string(), message: z.string() }).strict();
export const TermLinesCreateSchema = z.object({ active: z.boolean().optional(), amount_minor: z.union([z.number().int().min(0).max(9007199254740991), z.null()]).optional(), billing_timing: BillingTimingSchema.optional(), cadence: CadenceSchema, collection: CollectionSchema.optional(), deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), effective_from: vDateTime(), effective_to: z.union([vDateTime(), z.null()]).optional(), kind: TermLineKindSchema, label: z.string().min(1), milestones: z.union([z.array(TermLineMilestoneSchema), z.null()]).optional(), note: z.union([z.string(), z.null()]).optional(), price_source: PriceSourceSchema, quantity: z.union([MeterExprSchema, z.null()]).optional(), rate_minor: z.union([z.number().int().min(0).max(9007199254740991), z.null()]).optional(), share_kind: ShareKindSchema, share_override_pct: z.union([z.number().min(0).max(100), z.null()]).optional(), source: MeterSourceSchema, stacks_with: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), unit: MeterUnitSchema, where: z.union([MeterExprSchema, z.null()]).optional() }).strict();
export const TermLinesItemSchema = z.object({ active: z.boolean(), amount_minor: z.union([z.number().int().min(0).max(9007199254740991), z.null()]), billing_timing: BillingTimingSchema, cadence: CadenceSchema, collection: CollectionSchema, created_at: vDateTime(), currency: CurrencySchema, customer_name: z.string(), deal_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), effective_from: vDateTime(), effective_to: z.union([vDateTime(), z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), kind: TermLineKindSchema, label: z.string().min(1), milestones: z.union([z.array(TermLineMilestoneSchema), z.null()]), note: z.union([z.string(), z.null()]), partner_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), price_source: PriceSourceSchema, quantity: z.union([MeterExprSchema, z.null()]), rate_minor: z.union([z.number().int().min(0).max(9007199254740991), z.null()]), revision: z.number().int().min(1).max(9007199254740991), share_kind: ShareKindSchema, share_override_pct: z.union([z.number().min(0).max(100), z.null()]), source: MeterSourceSchema, stacks_with: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), unit: MeterUnitSchema, unreadable: z.union([TermLineUnreadableSchema, z.null()]), updated_at: vDateTime(), version: z.number().int().min(1).max(9007199254740991), where: z.union([MeterExprSchema, z.null()]) }).strict();
export const TermLinesListSchema = z.object({ items: z.array(TermLinesItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const TermLinesUpdateSchema = z.object({ active: z.boolean().optional(), amount_minor: z.union([z.number().int().min(0).max(9007199254740991), z.null()]).optional(), billing_timing: BillingTimingSchema.optional(), cadence: CadenceSchema.optional(), collection: CollectionSchema.optional(), effective_from: vDateTime().optional(), effective_to: z.union([vDateTime(), z.null()]).optional(), kind: TermLineKindSchema.optional(), label: z.string().min(1).optional(), milestones: z.union([z.array(TermLineMilestoneSchema), z.null()]).optional(), note: z.union([z.string(), z.null()]).optional(), price_source: PriceSourceSchema.optional(), quantity: z.union([MeterExprSchema, z.null()]).optional(), rate_minor: z.union([z.number().int().min(0).max(9007199254740991), z.null()]).optional(), share_kind: ShareKindSchema.optional(), share_override_pct: z.union([z.number().min(0).max(100), z.null()]).optional(), source: MeterSourceSchema.optional(), stacks_with: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]).optional(), unit: MeterUnitSchema.optional(), where: z.union([MeterExprSchema, z.null()]).optional() }).strict();
export const TranscriptFactsItemSchema = z.object({ agent_utterances: z.number().int(), ai_handled: z.union([z.boolean(), z.null()]), csr_utterances: z.number().int(), customer_utterances: z.number().int(), deployment_slug: z.string(), direction: z.string(), emitted_at: vDateTime(), ended_at: z.union([vDateTime(), z.null()]), environment: z.string(), escalated_at: z.union([vDateTime(), z.null()]), escalation_kind: z.string(), external_ref: z.union([z.string(), z.null()]), flow_id: z.union([z.string(), z.null()]), function_calls: z.array(z.object({}).loose()), outcome_kind: z.string(), platform: z.string(), received_at: vDateTime(), source: FactSourceSchema, started_at: vDateTime(), tenant_slug: z.string(), transcript_id: z.string(), version: z.number().int() }).strict();
export const TranscriptFactsListSchema = z.object({ items: z.array(TranscriptFactsItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const TrendsReportFxSchema = z.object({ as_of: vDateTime(), target_currency: CurrencySchema, usd_to_cad: z.number().gt(0) }).strict();
export const TrendsReportParamsSchema = z.object({ from_month: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), partner_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), scope: ReportScopeSchema, to_month: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")) }).strict();
export const TrendsReportRowsItemSchema = z.object({ billed_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), billed_item_count: z.number().int().min(0).max(9007199254740991), billed_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), billed_unresolved_item_count: z.number().int().min(0).max(9007199254740991), collected_invoice_count: z.number().int().min(0).max(9007199254740991), collected_minor: z.number().int().min(-9007199254740991).max(9007199254740991), cost_absorbed_minor: z.number().int().min(-9007199254740991).max(9007199254740991), cost_item_count: z.number().int().min(0).max(9007199254740991), cost_recharged_minor: z.number().int().min(-9007199254740991).max(9007199254740991), cost_unpriced_item_count: z.number().int().min(0).max(9007199254740991), invoiced_invoice_count: z.number().int().min(0).max(9007199254740991), invoiced_minor: z.number().int().min(-9007199254740991).max(9007199254740991), lost_deal_count: z.number().int().min(0).max(9007199254740991), month: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), recurring_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), recurring_line_count: z.number().int().min(0).max(9007199254740991), recurring_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), recurring_unresolved_line_count: z.number().int().min(0).max(9007199254740991), to_bill_line_count: z.number().int().min(0).max(9007199254740991), to_bill_minor: z.number().int().min(-9007199254740991).max(9007199254740991), to_bill_pending_count: z.number().int().min(0).max(9007199254740991), won_deal_count: z.number().int().min(0).max(9007199254740991), won_first_year_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), won_first_year_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), won_unresolved_deal_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const TrendsReportTotalsSchema = z.object({ billed_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), billed_item_count: z.number().int().min(0).max(9007199254740991), billed_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), billed_unresolved_item_count: z.number().int().min(0).max(9007199254740991), collected_invoice_count: z.number().int().min(0).max(9007199254740991), collected_minor: z.number().int().min(-9007199254740991).max(9007199254740991), cost_absorbed_minor: z.number().int().min(-9007199254740991).max(9007199254740991), cost_item_count: z.number().int().min(0).max(9007199254740991), cost_recharged_minor: z.number().int().min(-9007199254740991).max(9007199254740991), cost_unpriced_item_count: z.number().int().min(0).max(9007199254740991), invoiced_invoice_count: z.number().int().min(0).max(9007199254740991), invoiced_minor: z.number().int().min(-9007199254740991).max(9007199254740991), lost_deal_count: z.number().int().min(0).max(9007199254740991), to_bill_line_count: z.number().int().min(0).max(9007199254740991), to_bill_minor: z.number().int().min(-9007199254740991).max(9007199254740991), to_bill_pending_count: z.number().int().min(0).max(9007199254740991), won_deal_count: z.number().int().min(0).max(9007199254740991), won_first_year_gross_minor: z.number().int().min(-9007199254740991).max(9007199254740991), won_first_year_our_share_minor: z.number().int().min(-9007199254740991).max(9007199254740991), won_unresolved_deal_count: z.number().int().min(0).max(9007199254740991) }).strict();
export const TrendsReportSchema = z.object({ currency: CurrencySchema, fx: z.union([TrendsReportFxSchema, z.null()]), generated_at: vDateTime(), params: TrendsReportParamsSchema, rows: z.array(TrendsReportRowsItemSchema), totals: TrendsReportTotalsSchema }).strict();
export const UnpricedReasonSchema = z.enum(["null_field", "rate_unavailable", "division_by_zero", "excluded", "rule_missing"]);
export const UsageCostGroupSchema = z.object({ audio_seconds: z.union([z.number(), z.null()]), characters: z.union([z.number().int(), z.null()]), cost_minor: z.number().int(), facts_matched: z.number().int(), facts_priced: z.number().int(), facts_scanned: z.number().int(), input_tokens: z.union([z.number().int(), z.null()]), key: z.string(), output_tokens: z.union([z.number().int(), z.null()]), units: z.union([z.number().int(), z.null()]), unpriced_by_reason: MeterUndefinedCountsSchema }).strict();
export const UsageCostGroupBySchema = z.enum(["category", "provider", "operation", "feature", "product", "model", "day", "deployment_slug", "tenant_slug"]);
export const UsageCostGroupsOmittedSchema = z.object({ cost_minor: z.number().int(), count: z.number().int() }).strict();
export const UsageCostSourceSchema = z.enum(["rollup", "closed"]);
export const UsageCostProvenanceSchema = z.object({ closed_run_id: z.union([z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), z.null()]), computed_at: z.union([vDateTime(), z.null()]), source: UsageCostSourceSchema, stale_days: z.number().int() }).strict();
export const UsageCostTelephonyPhasesSchema = z.object({ ai_leg_cost_minor: z.number().int(), ai_leg_seconds: z.number(), post_transfer_cost_minor: z.number().int(), post_transfer_seconds: z.number(), unsegmented_legs: z.number().int() }).strict();
export const UsageFxSchema = z.object({ as_of: vDateTime(), target_currency: CurrencySchema, usd_to_cad: z.number() }).strict();
export const UsageRateGapSchema = z.object({ deployment_slug: z.string().regex(new RegExp("^(prod|nonprod)-[a-z0-9]+-[a-z0-9-]+$")), facts: z.number().int(), first_seen_at: vDateTime(), last_period: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), last_seen_at: vDateTime(), model: z.union([z.string(), z.null()]), operation: z.string().min(1), period_open: z.boolean(), provider: z.string().min(1), resolved_at: z.union([vDateTime(), z.null()]) }).strict();
export const UsageCostResponseSchema = z.object({ calls: z.number().int(), cost_minor: z.number().int(), cost_per_call_minor: z.union([z.number(), z.null()]), currency: CurrencySchema, fx: z.union([UsageFxSchema, z.null()]), groups: z.array(UsageCostGroupSchema), groups_omitted: UsageCostGroupsOmittedSchema, groups_total: z.number().int(), meters: z.array(z.string()), period: z.string(), provenance: UsageCostProvenanceSchema, rate_gaps: z.array(UsageRateGapSchema), telephony_phases: UsageCostTelephonyPhasesSchema }).strict();
export const UsageJobStatusSchema = z.enum(["queued", "running", "succeeded", "failed"]);
export const UsageCostPendingSchema = z.object({ job_id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), stale_result: z.union([UsageCostResponseSchema, z.null()]), status: UsageJobStatusSchema, submitted_at: vDateTime() }).strict();
export const UsageCostSortSchema = z.enum(["cost_desc", "cost_asc", "key_asc"]);
export const UsageFactsItemSchema = z.object({ audio_input_tokens: z.union([z.number().int(), z.null()]), audio_output_tokens: z.union([z.number().int(), z.null()]), audio_seconds: z.union([z.number(), z.null()]), cache_creation_input_tokens: z.union([z.number().int(), z.null()]), cached_input_tokens: z.union([z.number().int(), z.null()]), characters: z.union([z.number().int(), z.null()]), deployment_slug: z.string(), duration_ms: z.union([z.number().int(), z.null()]), external_ref: z.union([z.string(), z.null()]), feature: z.string(), hedge_role: z.union([z.string(), z.null()]), id: z.string(), input_tokens: z.union([z.number().int(), z.null()]), model: z.union([z.string(), z.null()]), occurred_at: vDateTime(), operation: z.string(), output_tokens: z.union([z.number().int(), z.null()]), product: z.string(), provider: z.string(), reasoning_tokens: z.union([z.number().int(), z.null()]), received_at: vDateTime(), region: z.union([z.string(), z.null()]), request_id: z.union([z.string(), z.null()]), source: FactSourceSchema, status: z.string(), tenant_slug: z.string(), transcript_id: z.union([z.string(), z.null()]), units: z.union([z.number().int(), z.null()]), usage_source: z.string(), voice: z.union([z.string(), z.null()]) }).strict();
export const UsageFactsListSchema = z.object({ items: z.array(UsageFactsItemSchema), limit: z.number().int(), offset: z.number().int(), total: z.number().int() }).strict();
export const UsageJobSchema = z.object({ created_at: vDateTime(), days_done: z.number().int(), days_total: z.union([z.number().int(), z.null()]), deployment_slugs: z.array(z.string().regex(new RegExp("^(prod|nonprod)-[a-z0-9]+-[a-z0-9-]+$"))), error: z.union([z.string(), z.null()]), facts_scanned: z.number().int(), finished_at: z.union([vDateTime(), z.null()]), id: z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$")), kind: UsageJobKindSchema, period: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), requested_by: z.string().min(1), started_at: z.union([vDateTime(), z.null()]), status: UsageJobStatusSchema, tenant_slugs: z.array(z.string().min(1)) }).strict();
export const UsageTrendGroupBySchema = z.enum(["category", "provider", "model", "product", "tenant_slug", "deployment_slug"]);
export const UsageTrendPointSchema = z.object({ calls: z.union([z.number().int(), z.null()]), cost_minor: z.number().int(), facts_unpriced: z.number().int(), period: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")) }).strict();
export const UsageTrendSeriesSchema = z.object({ cost_minor: z.number().int(), delta_vs_previous_minor: z.union([z.number().int(), z.null()]), key: z.string().min(1), points: z.array(UsageTrendPointSchema) }).strict();
export const UsageTrendResponseSchema = z.object({ closed_periods: z.array(z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$"))), computed_at: z.union([vDateTime(), z.null()]), currency: CurrencySchema, fx: z.union([UsageFxSchema, z.null()]), group_by: UsageTrendGroupBySchema, period_from: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), period_to: z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$")), periods: z.array(z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$"))), series: z.array(UsageTrendSeriesSchema), series_omitted: UsageCostGroupsOmittedSchema, series_total: z.number().int() }).strict();
// Request-parameter validators, deduplicated by shape. Referenced from
// the operations below so no validator is constructed per call.
const RequestParamSchema0 = z.string().max(255);
const RequestParamSchema1 = z.string();
const RequestParamSchema2 = z.string().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])$"));
const RequestParamSchema3 = z.string().regex(new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$"));
const RequestParamSchema4 = z.string().min(1).max(2000);
const RequestParamSchema5 = z.number().int().min(1).max(50);
const RequestParamSchema6 = z.array(z.string());
const RequestParamSchema7 = z.array(z.enum(["max_accounts:asc", "max_accounts:desc", "fee_minor:asc", "fee_minor:desc", "created_at:asc", "created_at:desc"]));
const RequestParamSchema8 = z.number().int().min(1).max(500);
const RequestParamSchema9 = z.number().int().min(0);
const RequestParamSchema10 = z.array(z.enum(["effective_date:asc", "effective_date:desc", "created_at:asc", "created_at:desc"]));
const RequestParamSchema11 = z.array(z.enum(["name:asc", "name:desc", "created_at:asc", "created_at:desc", "updated_at:asc", "updated_at:desc"]));
const RequestParamSchema12 = z.array(z.enum(["role:asc", "role:desc", "name:asc", "name:desc", "email:asc", "email:desc", "created_at:asc", "created_at:desc", "updated_at:asc", "updated_at:desc"]));
const RequestParamSchema13 = z.array(BillingContactRoleSchema);
const RequestParamSchema14 = z.array(z.enum(["period:asc", "period:desc", "kind:asc", "kind:desc", "received_at:asc", "received_at:desc", "created_at:asc", "created_at:desc"]));
const RequestParamSchema15 = z.array(z.enum(["customer_name:asc", "customer_name:desc", "state:asc", "state:desc", "win_prob:asc", "win_prob:desc", "start_date_earliest:asc", "start_date_earliest:desc", "start_date_latest:asc", "start_date_latest:desc", "renewal_date:asc", "renewal_date:desc", "closed_on:asc", "closed_on:desc", "customer_country:asc", "customer_country:desc", "customer_region:asc", "customer_region:desc", "customer_city:asc", "customer_city:desc", "customer_account_count:asc", "customer_account_count:desc", "created_at:asc", "created_at:desc", "updated_at:asc", "updated_at:desc"]));
const RequestParamSchema16 = z.array(DealStateSchema);
const RequestParamSchema17 = z.array(CurrencySchema);
const RequestParamSchema18 = z.array(InvoiceRecipientSchema);
const RequestParamSchema19 = z.array(z.enum(["effective_date:asc", "effective_date:desc", "usd_to_cad:asc", "usd_to_cad:desc", "created_at:asc", "created_at:desc"]));
const RequestParamSchema20 = z.array(z.enum(["sort_order:asc", "sort_order:desc", "charged_minor:asc", "charged_minor:desc", "gross_minor:asc", "gross_minor:desc", "our_share_minor:asc", "our_share_minor:desc", "created_at:asc", "created_at:desc"]));
const RequestParamSchema21 = z.array(InvoiceLineCategorySchema);
const RequestParamSchema22 = z.array(InvoiceLineSourceKindSchema);
const RequestParamSchema23 = z.array(InvoiceStatusSchema);
const RequestParamSchema24 = z.array(z.enum(["due_date:asc", "due_date:desc", "issue_date:asc", "issue_date:desc", "status:asc", "status:desc", "invoice_number:asc", "invoice_number:desc", "charged_minor:asc", "charged_minor:desc", "gross_minor:asc", "gross_minor:desc", "our_share_minor:asc", "our_share_minor:desc", "service_period:asc", "service_period:desc", "days_outstanding:asc", "days_outstanding:desc", "paid_date:asc", "paid_date:desc", "created_at:asc", "created_at:desc"]));
const RequestParamSchema25 = z.array(InvoiceApprovalStatusSchema);
const RequestParamSchema26 = z.array(z.enum(["occurred_at:asc", "occurred_at:desc", "created_at:asc", "created_at:desc", "updated_at:asc", "updated_at:desc", "received_at:asc", "received_at:desc"]));
const RequestParamSchema27 = z.boolean();
const RequestParamSchema28 = z.array(z.enum(["name:asc", "name:desc", "depth:asc", "depth:desc", "created_at:asc", "created_at:desc", "updated_at:asc", "updated_at:desc"]));
const RequestParamSchema29 = z.array(z.enum(["period_start:asc", "period_start:desc", "period_end:asc", "period_end:desc", "quantity:asc", "quantity:desc", "created_at:asc", "created_at:desc"]));
const RequestParamSchema30 = z.array(z.enum(["day:asc", "day:desc", "provider:asc", "provider:desc", "amount_minor:asc", "amount_minor:desc", "received_at:asc", "received_at:desc"]));
const RequestParamSchema31 = vDateTime();
const RequestParamSchema32 = z.array(z.enum(["provider:asc", "provider:desc", "operation:asc", "operation:desc", "model:asc", "model:desc", "unit:asc", "unit:desc", "effective_from:asc", "effective_from:desc", "effective_to:asc", "effective_to:desc", "price_per_unit:asc", "price_per_unit:desc", "created_at:asc", "created_at:desc"]));
const RequestParamSchema33 = z.array(RateUnitSchema);
const RequestParamSchema34 = z.array(z.enum(["deployment_slug:asc", "deployment_slug:desc", "tenant_slug:asc", "tenant_slug:desc", "effective_from:asc", "effective_from:desc", "effective_to:asc", "effective_to:desc", "created_at:asc", "created_at:desc"]));
const RequestParamSchema35 = z.array(z.enum(["revision:asc", "revision:desc", "created_at:asc", "created_at:desc"]));
const RequestParamSchema36 = z.array(z.enum(["label:asc", "label:desc", "kind:asc", "kind:desc", "effective_from:asc", "effective_from:desc", "cadence:asc", "cadence:desc", "created_at:asc", "created_at:desc"]));
const RequestParamSchema37 = z.number().int();
const RequestParamSchema38 = z.number().int().min(1).max(366);
const RequestParamSchema39 = z.number().int().min(1).max(52);
const RequestParamSchema40 = z.array(CalendarEventKindSchema);
const RequestParamSchema41 = z.number().int().min(6).max(36);
const RequestParamSchema42 = z.number().min(0);
const RequestParamSchema43 = z.number().max(1000).gt(0);
const RequestParamSchema44 = z.number().min(-50).max(100);
const RequestParamSchema45 = z.number().min(-100).max(100);
const RequestParamSchema46 = z.number().min(0).max(100);
const RequestParamSchema47 = z.number().int().min(0).max(36);
const RequestParamSchema48 = z.number().int().min(1).max(365);
const RequestParamSchema49 = z.array(z.string().min(1)).max(6);
const RequestParamSchema50 = z.number().int().min(1).max(12);
export class ApiClient {
    opts;
    constructor(opts) { this.opts = opts; }
    get _fetch() {
        return this.opts.fetch ?? globalThis.fetch;
    }
    get _strictValidation() {
        return this.opts.strictValidation ?? true;
    }
    /** Create a agreement-impl-fee-tiers record */
    async createAgreementImplFeeTiers(params, options) {
        validateRequestParam("createAgreementImplFeeTiers", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/agreement-impl-fee-tiers`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 201: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(AgreementImplFeeTiersItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 201, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Create a agreement-terms record */
    async createAgreementTerms(params, options) {
        validateRequestParam("createAgreementTerms", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/agreement-terms`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 201: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(AgreementTermsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 201, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Create a agreements record */
    async createAgreements(params, options) {
        validateRequestParam("createAgreements", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/agreements`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 201: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(AgreementsDetailSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 201, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Create a billing-contacts record */
    async createBillingContacts(params, options) {
        validateRequestParam("createBillingContacts", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/billing-contacts`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 201: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(BillingContactsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 201, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Create a deals record */
    async createDeals(params, options) {
        validateRequestParam("createDeals", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/deals`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 201: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(DealsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 201, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Create a fx-rates record */
    async createFxRates(params, options) {
        validateRequestParam("createFxRates", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/fx-rates`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 201: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(FxRatesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 201, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** create invoice draft */
    async createInvoiceDraft(params, options) {
        validateRequestParam("createInvoiceDraft", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/invoices/draft`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(CreateInvoiceDraftResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Create a invoice-lines record */
    async createInvoiceLines(params, options) {
        validateRequestParam("createInvoiceLines", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/invoice-lines`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 201: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(InvoiceLinesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 201, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Create a invoices record */
    async createInvoices(params, options) {
        validateRequestParam("createInvoices", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/invoices`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 201: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(InvoicesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 201, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Create a note */
    async createNotes(params, options) {
        validateRequestParam("createNotes", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/notes`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 201: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(NotesDetailSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 201, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Create a partners record */
    async createPartners(params, options) {
        validateRequestParam("createPartners", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/partners`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 201: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(PartnersItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 201, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Create a prepaid-entitlement record */
    async createPrepaidEntitlements(params, options) {
        validateRequestParam("createPrepaidEntitlements", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/prepaid-entitlements`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 201: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(PrepaidEntitlementsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 201, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Create a provider-rates record */
    async createProviderRates(params, options) {
        validateRequestParam("createProviderRates", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/provider-rates`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 201: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ProviderRatesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 201, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Create a tenant-bindings record */
    async createTenantBindings(params, options) {
        validateRequestParam("createTenantBindings", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/tenant-bindings`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 201: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(TenantBindingsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 201, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Create a term-line record */
    async createTermLines(params, options) {
        validateRequestParam("createTermLines", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/term-lines`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 201: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(TermLinesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 201, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Delete a agreement-impl-fee-tiers record */
    async deleteAgreementImplFeeTiers(params, options) {
        validateRequestParam("deleteAgreementImplFeeTiers", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("deleteAgreementImplFeeTiers", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/agreement-impl-fee-tiers/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        const init = { method: "DELETE", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(AgreementImplFeeTiersItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Delete a agreement-terms record */
    async deleteAgreementTerms(params, options) {
        validateRequestParam("deleteAgreementTerms", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("deleteAgreementTerms", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/agreement-terms/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        const init = { method: "DELETE", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(AgreementTermsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Delete a agreements record */
    async deleteAgreements(params, options) {
        validateRequestParam("deleteAgreements", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("deleteAgreements", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/agreements/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        const init = { method: "DELETE", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(AgreementsDetailSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Delete a billing-contacts record */
    async deleteBillingContacts(params, options) {
        validateRequestParam("deleteBillingContacts", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("deleteBillingContacts", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/billing-contacts/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        const init = { method: "DELETE", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(BillingContactsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Delete a deal-fact record */
    async deleteDealFacts(params, options) {
        validateRequestParam("deleteDealFacts", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("deleteDealFacts", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/deal-facts/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        const init = { method: "DELETE", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(DealFactsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Delete a deals record */
    async deleteDeals(params, options) {
        validateRequestParam("deleteDeals", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("deleteDeals", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/deals/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        const init = { method: "DELETE", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(DealsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Delete a fx-rates record */
    async deleteFxRates(params, options) {
        validateRequestParam("deleteFxRates", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("deleteFxRates", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/fx-rates/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        const init = { method: "DELETE", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(FxRatesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Delete a invoice-lines record */
    async deleteInvoiceLines(params, options) {
        validateRequestParam("deleteInvoiceLines", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("deleteInvoiceLines", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/invoice-lines/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        const init = { method: "DELETE", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(InvoiceLinesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Delete a invoices record */
    async deleteInvoices(params, options) {
        validateRequestParam("deleteInvoices", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("deleteInvoices", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/invoices/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        const init = { method: "DELETE", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(InvoicesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Delete a note */
    async deleteNotes(params, options) {
        validateRequestParam("deleteNotes", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("deleteNotes", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/notes/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        const init = { method: "DELETE", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(NotesDetailSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Delete a partners record */
    async deletePartners(params, options) {
        validateRequestParam("deletePartners", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("deletePartners", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/partners/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        const init = { method: "DELETE", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(PartnersItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Delete a prepaid-entitlement record */
    async deletePrepaidEntitlements(params, options) {
        validateRequestParam("deletePrepaidEntitlements", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("deletePrepaidEntitlements", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/prepaid-entitlements/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        const init = { method: "DELETE", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(PrepaidEntitlementsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Delete a provider-rates record */
    async deleteProviderRates(params, options) {
        validateRequestParam("deleteProviderRates", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("deleteProviderRates", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/provider-rates/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        const init = { method: "DELETE", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ProviderRatesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Delete a tenant-bindings record */
    async deleteTenantBindings(params, options) {
        validateRequestParam("deleteTenantBindings", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("deleteTenantBindings", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/tenant-bindings/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        const init = { method: "DELETE", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(TenantBindingsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Delete a term-line record */
    async deleteTermLines(params, options) {
        validateRequestParam("deleteTermLines", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("deleteTermLines", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/term-lines/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        const init = { method: "DELETE", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(TermLinesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Compact machine-readable summary of this API */
    async describeApi(params = {}, options) {
        const path = `/api/describe`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ApiDescriptionSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Fetch one agreement-impl-fee-tiers by id */
    async getAgreementImplFeeTiers(params, options) {
        validateRequestParam("getAgreementImplFeeTiers", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/agreement-impl-fee-tiers/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(AgreementImplFeeTiersItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Fetch one agreement-terms by id */
    async getAgreementTerms(params, options) {
        validateRequestParam("getAgreementTerms", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/agreement-terms/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(AgreementTermsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Fetch one agreements by id */
    async getAgreements(params, options) {
        validateRequestParam("getAgreements", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/agreements/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(AgreementsDetailSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** The authenticated caller's session info */
    async getAuthSession(params = {}, options) {
        const path = `/api/auth/session`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(SessionInfoSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Fetch one billing-contacts by id */
    async getBillingContacts(params, options) {
        validateRequestParam("getBillingContacts", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/billing-contacts/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(BillingContactsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Fetch one deal-fact by id */
    async getDealFacts(params, options) {
        validateRequestParam("getDealFacts", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/deal-facts/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(DealFactsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Everything recorded about a deal over time */
    async getDealHistory(params, options) {
        validateRequestParam("getDealHistory", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/deals/${encodeURIComponent(String(params.id))}/history`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(DealHistorySchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Interpret a deal's terms over one period */
    async getDealStatement(params, options) {
        validateRequestParam("getDealStatement", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("getDealStatement", "query", "period", RequestParamSchema2, params.period, this._strictValidation);
        const path = `/api/deals/${encodeURIComponent(String(params.id))}/statement`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "period", params.period, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(DealStatementSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Fetch one deals by id */
    async getDeals(params, options) {
        validateRequestParam("getDeals", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/deals/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(DealsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Fetch one fx-rates by id */
    async getFxRates(params, options) {
        validateRequestParam("getFxRates", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/fx-rates/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(FxRatesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Fetch one invoice-lines by id */
    async getInvoiceLines(params, options) {
        validateRequestParam("getInvoiceLines", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/invoice-lines/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(InvoiceLinesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** get invoice verification */
    async getInvoiceVerification(params, options) {
        validateRequestParam("getInvoiceVerification", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/invoices/${encodeURIComponent(String(params.id))}/verification`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(InvoiceVerificationReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Fetch one invoices by id */
    async getInvoices(params, options) {
        validateRequestParam("getInvoices", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/invoices/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(InvoicesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Get a note */
    async getNotes(params, options) {
        validateRequestParam("getNotes", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/notes/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(NotesDetailSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Fetch one partners by id */
    async getPartners(params, options) {
        validateRequestParam("getPartners", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/partners/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(PartnersItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Fetch one prepaid-entitlement by id */
    async getPrepaidEntitlements(params, options) {
        validateRequestParam("getPrepaidEntitlements", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/prepaid-entitlements/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(PrepaidEntitlementsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** The projection assumptions */
    async getProjectionSettings(params = {}, options) {
        const path = `/api/projection-settings`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ProjectionSettingsSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Fetch one provider-rates by id */
    async getProviderRates(params, options) {
        validateRequestParam("getProviderRates", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/provider-rates/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ProviderRatesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Fetch one tenant-bindings by id */
    async getTenantBindings(params, options) {
        validateRequestParam("getTenantBindings", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/tenant-bindings/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(TenantBindingsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Fetch one term-line by id */
    async getTermLines(params, options) {
        validateRequestParam("getTermLines", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/term-lines/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(TermLinesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** One usage rollup refresh */
    async getUsageJob(params, options) {
        validateRequestParam("getUsageJob", "path", "id", RequestParamSchema3, params.id, this._strictValidation);
        const path = `/api/reports/usage-jobs/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(UsageJobSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Search everything */
    async globalSearch(params, options) {
        validateRequestParam("globalSearch", "query", "q", RequestParamSchema4, params.q, this._strictValidation);
        validateRequestParam("globalSearch", "query", "limit", RequestParamSchema5, params.limit, this._strictValidation);
        validateRequestParam("globalSearch", "query", "kind", RequestParamSchema6, params.kind, this._strictValidation);
        const path = `/api/search`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "q", params.q, false);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "kind", params.kind, true);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(SearchResultsSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Set the stages another system recorded for a deal before this CRM knew it */
    async importDealStageHistory(params, options) {
        validateRequestParam("importDealStageHistory", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("importDealStageHistory", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/deals/${encodeURIComponent(String(params.id))}/stage-history/imported`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "PUT", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ImportDealStageHistoryResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Ingest deal facts */
    async ingestDealFacts(params, options) {
        const path = `/api/ingest/v1/deal-facts`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(IngestBatchResultSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Ingest provider cost facts */
    async ingestProviderCostFacts(params, options) {
        const path = `/api/ingest/v1/provider-cost-facts`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(IngestBatchResultSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Ingest transcript facts */
    async ingestTranscriptFacts(params, options) {
        const path = `/api/ingest/v1/transcript-facts`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(IngestBatchResultSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Ingest usage facts */
    async ingestUsageFacts(params, options) {
        const path = `/api/ingest/v1/usage-facts`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(IngestBatchResultSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Ingest usage-loss windows */
    async ingestUsageLoss(params, options) {
        const path = `/api/ingest/v1/usage-loss`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(IngestBatchResultSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** issue invoice */
    async issueInvoice(params, options) {
        validateRequestParam("issueInvoice", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("issueInvoice", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/invoices/${encodeURIComponent(String(params.id))}/issue`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(IssueInvoiceResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List agreement-impl-fee-tiers */
    async listAgreementImplFeeTiers(params = {}, options) {
        validateRequestParam("listAgreementImplFeeTiers", "query", "q", RequestParamSchema1, params.q, this._strictValidation);
        validateRequestParam("listAgreementImplFeeTiers", "query", "sort", RequestParamSchema7, params.sort, this._strictValidation);
        validateRequestParam("listAgreementImplFeeTiers", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listAgreementImplFeeTiers", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listAgreementImplFeeTiers", "query", "agreement_term_id", RequestParamSchema6, params.agreement_term_id, this._strictValidation);
        validateRequestParam("listAgreementImplFeeTiers", "query", "agreement_id", RequestParamSchema6, params.agreement_id, this._strictValidation);
        validateRequestParam("listAgreementImplFeeTiers", "query", "max_accounts", RequestParamSchema6, params.max_accounts, this._strictValidation);
        validateRequestParam("listAgreementImplFeeTiers", "query", "fee_minor", RequestParamSchema6, params.fee_minor, this._strictValidation);
        validateRequestParam("listAgreementImplFeeTiers", "query", "max_accounts_gte", RequestParamSchema1, params.max_accounts_gte, this._strictValidation);
        validateRequestParam("listAgreementImplFeeTiers", "query", "max_accounts_lte", RequestParamSchema1, params.max_accounts_lte, this._strictValidation);
        validateRequestParam("listAgreementImplFeeTiers", "query", "fee_minor_gte", RequestParamSchema1, params.fee_minor_gte, this._strictValidation);
        validateRequestParam("listAgreementImplFeeTiers", "query", "fee_minor_lte", RequestParamSchema1, params.fee_minor_lte, this._strictValidation);
        const path = `/api/agreement-impl-fee-tiers`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "q", params.q, false);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "agreement_term_id", params.agreement_term_id, true);
        appendQueryParam(url, "agreement_id", params.agreement_id, true);
        appendQueryParam(url, "max_accounts", params.max_accounts, true);
        appendQueryParam(url, "fee_minor", params.fee_minor, true);
        appendQueryParam(url, "max_accounts_gte", params.max_accounts_gte, false);
        appendQueryParam(url, "max_accounts_lte", params.max_accounts_lte, false);
        appendQueryParam(url, "fee_minor_gte", params.fee_minor_gte, false);
        appendQueryParam(url, "fee_minor_lte", params.fee_minor_lte, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(AgreementImplFeeTiersListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List agreement-terms */
    async listAgreementTerms(params = {}, options) {
        validateRequestParam("listAgreementTerms", "query", "sort", RequestParamSchema10, params.sort, this._strictValidation);
        validateRequestParam("listAgreementTerms", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listAgreementTerms", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listAgreementTerms", "query", "agreement_id", RequestParamSchema6, params.agreement_id, this._strictValidation);
        validateRequestParam("listAgreementTerms", "query", "effective_date", RequestParamSchema6, params.effective_date, this._strictValidation);
        validateRequestParam("listAgreementTerms", "query", "effective_date_gte", RequestParamSchema1, params.effective_date_gte, this._strictValidation);
        validateRequestParam("listAgreementTerms", "query", "effective_date_lte", RequestParamSchema1, params.effective_date_lte, this._strictValidation);
        const path = `/api/agreement-terms`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "agreement_id", params.agreement_id, true);
        appendQueryParam(url, "effective_date", params.effective_date, true);
        appendQueryParam(url, "effective_date_gte", params.effective_date_gte, false);
        appendQueryParam(url, "effective_date_lte", params.effective_date_lte, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(AgreementTermsListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List agreements */
    async listAgreements(params = {}, options) {
        validateRequestParam("listAgreements", "query", "q", RequestParamSchema1, params.q, this._strictValidation);
        validateRequestParam("listAgreements", "query", "sort", RequestParamSchema11, params.sort, this._strictValidation);
        validateRequestParam("listAgreements", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listAgreements", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listAgreements", "query", "partner_id", RequestParamSchema6, params.partner_id, this._strictValidation);
        validateRequestParam("listAgreements", "query", "name", RequestParamSchema6, params.name, this._strictValidation);
        validateRequestParam("listAgreements", "query", "is_default", RequestParamSchema6, params.is_default, this._strictValidation);
        validateRequestParam("listAgreements", "query", "available_to_partner_id", RequestParamSchema6, params.available_to_partner_id, this._strictValidation);
        const path = `/api/agreements`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "q", params.q, false);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "partner_id", params.partner_id, true);
        appendQueryParam(url, "name", params.name, true);
        appendQueryParam(url, "is_default", params.is_default, true);
        appendQueryParam(url, "available_to_partner_id", params.available_to_partner_id, true);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(AgreementsListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List billing-contacts */
    async listBillingContacts(params = {}, options) {
        validateRequestParam("listBillingContacts", "query", "sort", RequestParamSchema12, params.sort, this._strictValidation);
        validateRequestParam("listBillingContacts", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listBillingContacts", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listBillingContacts", "query", "q", RequestParamSchema1, params.q, this._strictValidation);
        validateRequestParam("listBillingContacts", "query", "partner_id", RequestParamSchema6, params.partner_id, this._strictValidation);
        validateRequestParam("listBillingContacts", "query", "deal_id", RequestParamSchema6, params.deal_id, this._strictValidation);
        validateRequestParam("listBillingContacts", "query", "role", RequestParamSchema13, params.role, this._strictValidation);
        validateRequestParam("listBillingContacts", "query", "email", RequestParamSchema6, params.email, this._strictValidation);
        const path = `/api/billing-contacts`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "q", params.q, false);
        appendQueryParam(url, "partner_id", params.partner_id, true);
        appendQueryParam(url, "deal_id", params.deal_id, true);
        appendQueryParam(url, "role", params.role, true);
        appendQueryParam(url, "email", params.email, true);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(BillingContactsListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List deal-facts */
    async listDealFacts(params = {}, options) {
        validateRequestParam("listDealFacts", "query", "sort", RequestParamSchema14, params.sort, this._strictValidation);
        validateRequestParam("listDealFacts", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listDealFacts", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listDealFacts", "query", "deal_id", RequestParamSchema6, params.deal_id, this._strictValidation);
        validateRequestParam("listDealFacts", "query", "partner_id", RequestParamSchema6, params.partner_id, this._strictValidation);
        validateRequestParam("listDealFacts", "query", "term_line_id", RequestParamSchema6, params.term_line_id, this._strictValidation);
        validateRequestParam("listDealFacts", "query", "period", RequestParamSchema6, params.period, this._strictValidation);
        validateRequestParam("listDealFacts", "query", "kind", RequestParamSchema6, params.kind, this._strictValidation);
        validateRequestParam("listDealFacts", "query", "source", RequestParamSchema6, params.source, this._strictValidation);
        validateRequestParam("listDealFacts", "query", "period_gte", RequestParamSchema1, params.period_gte, this._strictValidation);
        validateRequestParam("listDealFacts", "query", "period_lte", RequestParamSchema1, params.period_lte, this._strictValidation);
        const path = `/api/deal-facts`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "deal_id", params.deal_id, true);
        appendQueryParam(url, "partner_id", params.partner_id, true);
        appendQueryParam(url, "term_line_id", params.term_line_id, true);
        appendQueryParam(url, "period", params.period, true);
        appendQueryParam(url, "kind", params.kind, true);
        appendQueryParam(url, "source", params.source, true);
        appendQueryParam(url, "period_gte", params.period_gte, false);
        appendQueryParam(url, "period_lte", params.period_lte, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(DealFactsListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List deals */
    async listDeals(params = {}, options) {
        validateRequestParam("listDeals", "query", "q", RequestParamSchema1, params.q, this._strictValidation);
        validateRequestParam("listDeals", "query", "sort", RequestParamSchema15, params.sort, this._strictValidation);
        validateRequestParam("listDeals", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listDeals", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listDeals", "query", "partner_id", RequestParamSchema6, params.partner_id, this._strictValidation);
        validateRequestParam("listDeals", "query", "under_partner_id", RequestParamSchema6, params.under_partner_id, this._strictValidation);
        validateRequestParam("listDeals", "query", "agreement_id", RequestParamSchema6, params.agreement_id, this._strictValidation);
        validateRequestParam("listDeals", "query", "state", RequestParamSchema16, params.state, this._strictValidation);
        validateRequestParam("listDeals", "query", "currency", RequestParamSchema17, params.currency, this._strictValidation);
        validateRequestParam("listDeals", "query", "invoice_recipient", RequestParamSchema18, params.invoice_recipient, this._strictValidation);
        validateRequestParam("listDeals", "query", "win_prob", RequestParamSchema6, params.win_prob, this._strictValidation);
        validateRequestParam("listDeals", "query", "start_date_earliest", RequestParamSchema6, params.start_date_earliest, this._strictValidation);
        validateRequestParam("listDeals", "query", "start_date_latest", RequestParamSchema6, params.start_date_latest, this._strictValidation);
        validateRequestParam("listDeals", "query", "renewal_date", RequestParamSchema6, params.renewal_date, this._strictValidation);
        validateRequestParam("listDeals", "query", "closed_on", RequestParamSchema6, params.closed_on, this._strictValidation);
        validateRequestParam("listDeals", "query", "customer_country", RequestParamSchema6, params.customer_country, this._strictValidation);
        validateRequestParam("listDeals", "query", "customer_region", RequestParamSchema6, params.customer_region, this._strictValidation);
        validateRequestParam("listDeals", "query", "customer_city", RequestParamSchema6, params.customer_city, this._strictValidation);
        validateRequestParam("listDeals", "query", "has_location", RequestParamSchema6, params.has_location, this._strictValidation);
        validateRequestParam("listDeals", "query", "has_coordinates", RequestParamSchema6, params.has_coordinates, this._strictValidation);
        validateRequestParam("listDeals", "query", "customer_account_count", RequestParamSchema6, params.customer_account_count, this._strictValidation);
        validateRequestParam("listDeals", "query", "has_account_count", RequestParamSchema6, params.has_account_count, this._strictValidation);
        validateRequestParam("listDeals", "query", "has_split_override", RequestParamSchema6, params.has_split_override, this._strictValidation);
        validateRequestParam("listDeals", "query", "win_prob_gte", RequestParamSchema1, params.win_prob_gte, this._strictValidation);
        validateRequestParam("listDeals", "query", "win_prob_lte", RequestParamSchema1, params.win_prob_lte, this._strictValidation);
        validateRequestParam("listDeals", "query", "start_date_earliest_gte", RequestParamSchema1, params.start_date_earliest_gte, this._strictValidation);
        validateRequestParam("listDeals", "query", "start_date_earliest_lte", RequestParamSchema1, params.start_date_earliest_lte, this._strictValidation);
        validateRequestParam("listDeals", "query", "start_date_latest_gte", RequestParamSchema1, params.start_date_latest_gte, this._strictValidation);
        validateRequestParam("listDeals", "query", "start_date_latest_lte", RequestParamSchema1, params.start_date_latest_lte, this._strictValidation);
        validateRequestParam("listDeals", "query", "renewal_date_gte", RequestParamSchema1, params.renewal_date_gte, this._strictValidation);
        validateRequestParam("listDeals", "query", "renewal_date_lte", RequestParamSchema1, params.renewal_date_lte, this._strictValidation);
        validateRequestParam("listDeals", "query", "closed_on_gte", RequestParamSchema1, params.closed_on_gte, this._strictValidation);
        validateRequestParam("listDeals", "query", "closed_on_lte", RequestParamSchema1, params.closed_on_lte, this._strictValidation);
        validateRequestParam("listDeals", "query", "customer_account_count_gte", RequestParamSchema1, params.customer_account_count_gte, this._strictValidation);
        validateRequestParam("listDeals", "query", "customer_account_count_lte", RequestParamSchema1, params.customer_account_count_lte, this._strictValidation);
        const path = `/api/deals`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "q", params.q, false);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "partner_id", params.partner_id, true);
        appendQueryParam(url, "under_partner_id", params.under_partner_id, true);
        appendQueryParam(url, "agreement_id", params.agreement_id, true);
        appendQueryParam(url, "state", params.state, true);
        appendQueryParam(url, "currency", params.currency, true);
        appendQueryParam(url, "invoice_recipient", params.invoice_recipient, true);
        appendQueryParam(url, "win_prob", params.win_prob, true);
        appendQueryParam(url, "start_date_earliest", params.start_date_earliest, true);
        appendQueryParam(url, "start_date_latest", params.start_date_latest, true);
        appendQueryParam(url, "renewal_date", params.renewal_date, true);
        appendQueryParam(url, "closed_on", params.closed_on, true);
        appendQueryParam(url, "customer_country", params.customer_country, true);
        appendQueryParam(url, "customer_region", params.customer_region, true);
        appendQueryParam(url, "customer_city", params.customer_city, true);
        appendQueryParam(url, "has_location", params.has_location, true);
        appendQueryParam(url, "has_coordinates", params.has_coordinates, true);
        appendQueryParam(url, "customer_account_count", params.customer_account_count, true);
        appendQueryParam(url, "has_account_count", params.has_account_count, true);
        appendQueryParam(url, "has_split_override", params.has_split_override, true);
        appendQueryParam(url, "win_prob_gte", params.win_prob_gte, false);
        appendQueryParam(url, "win_prob_lte", params.win_prob_lte, false);
        appendQueryParam(url, "start_date_earliest_gte", params.start_date_earliest_gte, false);
        appendQueryParam(url, "start_date_earliest_lte", params.start_date_earliest_lte, false);
        appendQueryParam(url, "start_date_latest_gte", params.start_date_latest_gte, false);
        appendQueryParam(url, "start_date_latest_lte", params.start_date_latest_lte, false);
        appendQueryParam(url, "renewal_date_gte", params.renewal_date_gte, false);
        appendQueryParam(url, "renewal_date_lte", params.renewal_date_lte, false);
        appendQueryParam(url, "closed_on_gte", params.closed_on_gte, false);
        appendQueryParam(url, "closed_on_lte", params.closed_on_lte, false);
        appendQueryParam(url, "customer_account_count_gte", params.customer_account_count_gte, false);
        appendQueryParam(url, "customer_account_count_lte", params.customer_account_count_lte, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(DealsListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List fx-rates */
    async listFxRates(params = {}, options) {
        validateRequestParam("listFxRates", "query", "sort", RequestParamSchema19, params.sort, this._strictValidation);
        validateRequestParam("listFxRates", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listFxRates", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listFxRates", "query", "effective_date", RequestParamSchema6, params.effective_date, this._strictValidation);
        validateRequestParam("listFxRates", "query", "effective_date_gte", RequestParamSchema1, params.effective_date_gte, this._strictValidation);
        validateRequestParam("listFxRates", "query", "effective_date_lte", RequestParamSchema1, params.effective_date_lte, this._strictValidation);
        const path = `/api/fx-rates`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "effective_date", params.effective_date, true);
        appendQueryParam(url, "effective_date_gte", params.effective_date_gte, false);
        appendQueryParam(url, "effective_date_lte", params.effective_date_lte, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(FxRatesListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List invoice-lines */
    async listInvoiceLines(params = {}, options) {
        validateRequestParam("listInvoiceLines", "query", "q", RequestParamSchema1, params.q, this._strictValidation);
        validateRequestParam("listInvoiceLines", "query", "sort", RequestParamSchema20, params.sort, this._strictValidation);
        validateRequestParam("listInvoiceLines", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listInvoiceLines", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listInvoiceLines", "query", "invoice_id", RequestParamSchema6, params.invoice_id, this._strictValidation);
        validateRequestParam("listInvoiceLines", "query", "partner_id", RequestParamSchema6, params.partner_id, this._strictValidation);
        validateRequestParam("listInvoiceLines", "query", "deal_id", RequestParamSchema6, params.deal_id, this._strictValidation);
        validateRequestParam("listInvoiceLines", "query", "schedule_item_id", RequestParamSchema6, params.schedule_item_id, this._strictValidation);
        validateRequestParam("listInvoiceLines", "query", "cost_recharge_item_id", RequestParamSchema6, params.cost_recharge_item_id, this._strictValidation);
        validateRequestParam("listInvoiceLines", "query", "charged_minor", RequestParamSchema6, params.charged_minor, this._strictValidation);
        validateRequestParam("listInvoiceLines", "query", "category", RequestParamSchema21, params.category, this._strictValidation);
        validateRequestParam("listInvoiceLines", "query", "source_kind", RequestParamSchema22, params.source_kind, this._strictValidation);
        validateRequestParam("listInvoiceLines", "query", "invoice_status", RequestParamSchema23, params.invoice_status, this._strictValidation);
        validateRequestParam("listInvoiceLines", "query", "charged_minor_gte", RequestParamSchema1, params.charged_minor_gte, this._strictValidation);
        validateRequestParam("listInvoiceLines", "query", "charged_minor_lte", RequestParamSchema1, params.charged_minor_lte, this._strictValidation);
        const path = `/api/invoice-lines`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "q", params.q, false);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "invoice_id", params.invoice_id, true);
        appendQueryParam(url, "partner_id", params.partner_id, true);
        appendQueryParam(url, "deal_id", params.deal_id, true);
        appendQueryParam(url, "schedule_item_id", params.schedule_item_id, true);
        appendQueryParam(url, "cost_recharge_item_id", params.cost_recharge_item_id, true);
        appendQueryParam(url, "charged_minor", params.charged_minor, true);
        appendQueryParam(url, "category", params.category, true);
        appendQueryParam(url, "source_kind", params.source_kind, true);
        appendQueryParam(url, "invoice_status", params.invoice_status, true);
        appendQueryParam(url, "charged_minor_gte", params.charged_minor_gte, false);
        appendQueryParam(url, "charged_minor_lte", params.charged_minor_lte, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(InvoiceLinesListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List invoices */
    async listInvoices(params = {}, options) {
        validateRequestParam("listInvoices", "query", "q", RequestParamSchema1, params.q, this._strictValidation);
        validateRequestParam("listInvoices", "query", "sort", RequestParamSchema24, params.sort, this._strictValidation);
        validateRequestParam("listInvoices", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listInvoices", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listInvoices", "query", "partner_id", RequestParamSchema6, params.partner_id, this._strictValidation);
        validateRequestParam("listInvoices", "query", "under_partner_id", RequestParamSchema6, params.under_partner_id, this._strictValidation);
        validateRequestParam("listInvoices", "query", "status", RequestParamSchema23, params.status, this._strictValidation);
        validateRequestParam("listInvoices", "query", "approval_status", RequestParamSchema25, params.approval_status, this._strictValidation);
        validateRequestParam("listInvoices", "query", "currency", RequestParamSchema17, params.currency, this._strictValidation);
        validateRequestParam("listInvoices", "query", "payer", RequestParamSchema18, params.payer, this._strictValidation);
        validateRequestParam("listInvoices", "query", "invoice_number", RequestParamSchema6, params.invoice_number, this._strictValidation);
        validateRequestParam("listInvoices", "query", "service_period", RequestParamSchema6, params.service_period, this._strictValidation);
        validateRequestParam("listInvoices", "query", "due_date", RequestParamSchema6, params.due_date, this._strictValidation);
        validateRequestParam("listInvoices", "query", "issue_date", RequestParamSchema6, params.issue_date, this._strictValidation);
        validateRequestParam("listInvoices", "query", "paid_date", RequestParamSchema6, params.paid_date, this._strictValidation);
        validateRequestParam("listInvoices", "query", "charged_minor", RequestParamSchema6, params.charged_minor, this._strictValidation);
        validateRequestParam("listInvoices", "query", "is_pending", RequestParamSchema6, params.is_pending, this._strictValidation);
        validateRequestParam("listInvoices", "query", "is_outstanding", RequestParamSchema6, params.is_outstanding, this._strictValidation);
        validateRequestParam("listInvoices", "query", "days_outstanding", RequestParamSchema6, params.days_outstanding, this._strictValidation);
        validateRequestParam("listInvoices", "query", "due_date_gte", RequestParamSchema1, params.due_date_gte, this._strictValidation);
        validateRequestParam("listInvoices", "query", "due_date_lte", RequestParamSchema1, params.due_date_lte, this._strictValidation);
        validateRequestParam("listInvoices", "query", "issue_date_gte", RequestParamSchema1, params.issue_date_gte, this._strictValidation);
        validateRequestParam("listInvoices", "query", "issue_date_lte", RequestParamSchema1, params.issue_date_lte, this._strictValidation);
        validateRequestParam("listInvoices", "query", "service_period_gte", RequestParamSchema1, params.service_period_gte, this._strictValidation);
        validateRequestParam("listInvoices", "query", "service_period_lte", RequestParamSchema1, params.service_period_lte, this._strictValidation);
        validateRequestParam("listInvoices", "query", "charged_minor_gte", RequestParamSchema1, params.charged_minor_gte, this._strictValidation);
        validateRequestParam("listInvoices", "query", "charged_minor_lte", RequestParamSchema1, params.charged_minor_lte, this._strictValidation);
        const path = `/api/invoices`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "q", params.q, false);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "partner_id", params.partner_id, true);
        appendQueryParam(url, "under_partner_id", params.under_partner_id, true);
        appendQueryParam(url, "status", params.status, true);
        appendQueryParam(url, "approval_status", params.approval_status, true);
        appendQueryParam(url, "currency", params.currency, true);
        appendQueryParam(url, "payer", params.payer, true);
        appendQueryParam(url, "invoice_number", params.invoice_number, true);
        appendQueryParam(url, "service_period", params.service_period, true);
        appendQueryParam(url, "due_date", params.due_date, true);
        appendQueryParam(url, "issue_date", params.issue_date, true);
        appendQueryParam(url, "paid_date", params.paid_date, true);
        appendQueryParam(url, "charged_minor", params.charged_minor, true);
        appendQueryParam(url, "is_pending", params.is_pending, true);
        appendQueryParam(url, "is_outstanding", params.is_outstanding, true);
        appendQueryParam(url, "days_outstanding", params.days_outstanding, true);
        appendQueryParam(url, "due_date_gte", params.due_date_gte, false);
        appendQueryParam(url, "due_date_lte", params.due_date_lte, false);
        appendQueryParam(url, "issue_date_gte", params.issue_date_gte, false);
        appendQueryParam(url, "issue_date_lte", params.issue_date_lte, false);
        appendQueryParam(url, "service_period_gte", params.service_period_gte, false);
        appendQueryParam(url, "service_period_lte", params.service_period_lte, false);
        appendQueryParam(url, "charged_minor_gte", params.charged_minor_gte, false);
        appendQueryParam(url, "charged_minor_lte", params.charged_minor_lte, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(InvoicesListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List notes */
    async listNotes(params = {}, options) {
        validateRequestParam("listNotes", "query", "sort", RequestParamSchema26, params.sort, this._strictValidation);
        validateRequestParam("listNotes", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listNotes", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listNotes", "query", "deal_id", RequestParamSchema6, params.deal_id, this._strictValidation);
        validateRequestParam("listNotes", "query", "kind", RequestParamSchema6, params.kind, this._strictValidation);
        validateRequestParam("listNotes", "query", "source", RequestParamSchema6, params.source, this._strictValidation);
        validateRequestParam("listNotes", "query", "embedding_state", RequestParamSchema6, params.embedding_state, this._strictValidation);
        validateRequestParam("listNotes", "query", "external_ref", RequestParamSchema6, params.external_ref, this._strictValidation);
        validateRequestParam("listNotes", "query", "unfiled", RequestParamSchema27, params.unfiled, this._strictValidation);
        validateRequestParam("listNotes", "query", "q", RequestParamSchema1, params.q, this._strictValidation);
        validateRequestParam("listNotes", "query", "occurred_at_gte", RequestParamSchema1, params.occurred_at_gte, this._strictValidation);
        validateRequestParam("listNotes", "query", "occurred_at_lte", RequestParamSchema1, params.occurred_at_lte, this._strictValidation);
        const path = `/api/notes`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "deal_id", params.deal_id, true);
        appendQueryParam(url, "kind", params.kind, true);
        appendQueryParam(url, "source", params.source, true);
        appendQueryParam(url, "embedding_state", params.embedding_state, true);
        appendQueryParam(url, "external_ref", params.external_ref, true);
        appendQueryParam(url, "unfiled", params.unfiled, false);
        appendQueryParam(url, "q", params.q, false);
        appendQueryParam(url, "occurred_at_gte", params.occurred_at_gte, false);
        appendQueryParam(url, "occurred_at_lte", params.occurred_at_lte, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(NotesListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List partners */
    async listPartners(params = {}, options) {
        validateRequestParam("listPartners", "query", "q", RequestParamSchema1, params.q, this._strictValidation);
        validateRequestParam("listPartners", "query", "sort", RequestParamSchema28, params.sort, this._strictValidation);
        validateRequestParam("listPartners", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listPartners", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listPartners", "query", "name", RequestParamSchema6, params.name, this._strictValidation);
        validateRequestParam("listPartners", "query", "parent_id", RequestParamSchema6, params.parent_id, this._strictValidation);
        validateRequestParam("listPartners", "query", "root_id", RequestParamSchema6, params.root_id, this._strictValidation);
        validateRequestParam("listPartners", "query", "depth", RequestParamSchema6, params.depth, this._strictValidation);
        validateRequestParam("listPartners", "query", "under_partner_id", RequestParamSchema6, params.under_partner_id, this._strictValidation);
        const path = `/api/partners`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "q", params.q, false);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "name", params.name, true);
        appendQueryParam(url, "parent_id", params.parent_id, true);
        appendQueryParam(url, "root_id", params.root_id, true);
        appendQueryParam(url, "depth", params.depth, true);
        appendQueryParam(url, "under_partner_id", params.under_partner_id, true);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(PartnersListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List prepaid-entitlements */
    async listPrepaidEntitlements(params = {}, options) {
        validateRequestParam("listPrepaidEntitlements", "query", "sort", RequestParamSchema29, params.sort, this._strictValidation);
        validateRequestParam("listPrepaidEntitlements", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listPrepaidEntitlements", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listPrepaidEntitlements", "query", "partner_id", RequestParamSchema6, params.partner_id, this._strictValidation);
        validateRequestParam("listPrepaidEntitlements", "query", "deal_id", RequestParamSchema6, params.deal_id, this._strictValidation);
        validateRequestParam("listPrepaidEntitlements", "query", "unit", RequestParamSchema6, params.unit, this._strictValidation);
        validateRequestParam("listPrepaidEntitlements", "query", "source_term_line_id", RequestParamSchema6, params.source_term_line_id, this._strictValidation);
        validateRequestParam("listPrepaidEntitlements", "query", "covers_period", RequestParamSchema2, params.covers_period, this._strictValidation);
        const path = `/api/prepaid-entitlements`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "partner_id", params.partner_id, true);
        appendQueryParam(url, "deal_id", params.deal_id, true);
        appendQueryParam(url, "unit", params.unit, true);
        appendQueryParam(url, "source_term_line_id", params.source_term_line_id, true);
        appendQueryParam(url, "covers_period", params.covers_period, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(PrepaidEntitlementsListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List provider-cost-facts */
    async listProviderCostFacts(params = {}, options) {
        validateRequestParam("listProviderCostFacts", "query", "sort", RequestParamSchema30, params.sort, this._strictValidation);
        validateRequestParam("listProviderCostFacts", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listProviderCostFacts", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listProviderCostFacts", "query", "provider", RequestParamSchema6, params.provider, this._strictValidation);
        validateRequestParam("listProviderCostFacts", "query", "operation", RequestParamSchema6, params.operation, this._strictValidation);
        validateRequestParam("listProviderCostFacts", "query", "source", RequestParamSchema6, params.source, this._strictValidation);
        validateRequestParam("listProviderCostFacts", "query", "deployment_slug", RequestParamSchema6, params.deployment_slug, this._strictValidation);
        validateRequestParam("listProviderCostFacts", "query", "day_gte", RequestParamSchema31, params.day_gte, this._strictValidation);
        validateRequestParam("listProviderCostFacts", "query", "day_lte", RequestParamSchema31, params.day_lte, this._strictValidation);
        const path = `/api/provider-cost-facts`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "provider", params.provider, true);
        appendQueryParam(url, "operation", params.operation, true);
        appendQueryParam(url, "source", params.source, true);
        appendQueryParam(url, "deployment_slug", params.deployment_slug, true);
        appendQueryParam(url, "day_gte", params.day_gte, false);
        appendQueryParam(url, "day_lte", params.day_lte, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ProviderCostFactsListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List provider-rates */
    async listProviderRates(params = {}, options) {
        validateRequestParam("listProviderRates", "query", "sort", RequestParamSchema32, params.sort, this._strictValidation);
        validateRequestParam("listProviderRates", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listProviderRates", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listProviderRates", "query", "provider", RequestParamSchema6, params.provider, this._strictValidation);
        validateRequestParam("listProviderRates", "query", "operation", RequestParamSchema6, params.operation, this._strictValidation);
        validateRequestParam("listProviderRates", "query", "model", RequestParamSchema6, params.model, this._strictValidation);
        validateRequestParam("listProviderRates", "query", "region", RequestParamSchema6, params.region, this._strictValidation);
        validateRequestParam("listProviderRates", "query", "unit", RequestParamSchema33, params.unit, this._strictValidation);
        validateRequestParam("listProviderRates", "query", "currency", RequestParamSchema17, params.currency, this._strictValidation);
        validateRequestParam("listProviderRates", "query", "effective_from", RequestParamSchema6, params.effective_from, this._strictValidation);
        validateRequestParam("listProviderRates", "query", "effective_to", RequestParamSchema6, params.effective_to, this._strictValidation);
        validateRequestParam("listProviderRates", "query", "effective_from_gte", RequestParamSchema1, params.effective_from_gte, this._strictValidation);
        validateRequestParam("listProviderRates", "query", "effective_from_lte", RequestParamSchema1, params.effective_from_lte, this._strictValidation);
        const path = `/api/provider-rates`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "provider", params.provider, true);
        appendQueryParam(url, "operation", params.operation, true);
        appendQueryParam(url, "model", params.model, true);
        appendQueryParam(url, "region", params.region, true);
        appendQueryParam(url, "unit", params.unit, true);
        appendQueryParam(url, "currency", params.currency, true);
        appendQueryParam(url, "effective_from", params.effective_from, true);
        appendQueryParam(url, "effective_to", params.effective_to, true);
        appendQueryParam(url, "effective_from_gte", params.effective_from_gte, false);
        appendQueryParam(url, "effective_from_lte", params.effective_from_lte, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ProviderRatesListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List tenant-bindings */
    async listTenantBindings(params = {}, options) {
        validateRequestParam("listTenantBindings", "query", "sort", RequestParamSchema34, params.sort, this._strictValidation);
        validateRequestParam("listTenantBindings", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listTenantBindings", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listTenantBindings", "query", "deployment_slug", RequestParamSchema6, params.deployment_slug, this._strictValidation);
        validateRequestParam("listTenantBindings", "query", "tenant_slug", RequestParamSchema6, params.tenant_slug, this._strictValidation);
        validateRequestParam("listTenantBindings", "query", "deal_id", RequestParamSchema6, params.deal_id, this._strictValidation);
        validateRequestParam("listTenantBindings", "query", "effective_from", RequestParamSchema6, params.effective_from, this._strictValidation);
        validateRequestParam("listTenantBindings", "query", "effective_from_gte", RequestParamSchema1, params.effective_from_gte, this._strictValidation);
        validateRequestParam("listTenantBindings", "query", "effective_from_lte", RequestParamSchema1, params.effective_from_lte, this._strictValidation);
        const path = `/api/tenant-bindings`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "deployment_slug", params.deployment_slug, true);
        appendQueryParam(url, "tenant_slug", params.tenant_slug, true);
        appendQueryParam(url, "deal_id", params.deal_id, true);
        appendQueryParam(url, "effective_from", params.effective_from, true);
        appendQueryParam(url, "effective_from_gte", params.effective_from_gte, false);
        appendQueryParam(url, "effective_from_lte", params.effective_from_lte, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(TenantBindingsListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List term-line revisions */
    async listTermLineRevisions(params = {}, options) {
        validateRequestParam("listTermLineRevisions", "query", "sort", RequestParamSchema35, params.sort, this._strictValidation);
        validateRequestParam("listTermLineRevisions", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listTermLineRevisions", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listTermLineRevisions", "query", "term_line_id", RequestParamSchema6, params.term_line_id, this._strictValidation);
        const path = `/api/term-line-revisions`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "term_line_id", params.term_line_id, true);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(TermLineRevisionsListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List term-lines */
    async listTermLines(params = {}, options) {
        validateRequestParam("listTermLines", "query", "sort", RequestParamSchema36, params.sort, this._strictValidation);
        validateRequestParam("listTermLines", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("listTermLines", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        validateRequestParam("listTermLines", "query", "deal_id", RequestParamSchema6, params.deal_id, this._strictValidation);
        validateRequestParam("listTermLines", "query", "kind", RequestParamSchema6, params.kind, this._strictValidation);
        validateRequestParam("listTermLines", "query", "source", RequestParamSchema6, params.source, this._strictValidation);
        validateRequestParam("listTermLines", "query", "price_source", RequestParamSchema6, params.price_source, this._strictValidation);
        validateRequestParam("listTermLines", "query", "active", RequestParamSchema27, params.active, this._strictValidation);
        validateRequestParam("listTermLines", "query", "q", RequestParamSchema1, params.q, this._strictValidation);
        const path = `/api/term-lines`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "deal_id", params.deal_id, true);
        appendQueryParam(url, "kind", params.kind, true);
        appendQueryParam(url, "source", params.source, true);
        appendQueryParam(url, "price_source", params.price_source, true);
        appendQueryParam(url, "active", params.active, false);
        appendQueryParam(url, "q", params.q, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(TermLinesListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List transcript-facts */
    async listTranscriptFacts(params = {}, options) {
        validateRequestParam("listTranscriptFacts", "query", "sort", RequestParamSchema6, params.sort, this._strictValidation);
        validateRequestParam("listTranscriptFacts", "query", "limit", RequestParamSchema37, params.limit, this._strictValidation);
        validateRequestParam("listTranscriptFacts", "query", "offset", RequestParamSchema37, params.offset, this._strictValidation);
        validateRequestParam("listTranscriptFacts", "query", "deployment_slug", RequestParamSchema6, params.deployment_slug, this._strictValidation);
        validateRequestParam("listTranscriptFacts", "query", "tenant_slug", RequestParamSchema6, params.tenant_slug, this._strictValidation);
        validateRequestParam("listTranscriptFacts", "query", "transcript_id", RequestParamSchema6, params.transcript_id, this._strictValidation);
        validateRequestParam("listTranscriptFacts", "query", "flow_id", RequestParamSchema6, params.flow_id, this._strictValidation);
        validateRequestParam("listTranscriptFacts", "query", "platform", RequestParamSchema6, params.platform, this._strictValidation);
        validateRequestParam("listTranscriptFacts", "query", "environment", RequestParamSchema6, params.environment, this._strictValidation);
        validateRequestParam("listTranscriptFacts", "query", "direction", RequestParamSchema6, params.direction, this._strictValidation);
        validateRequestParam("listTranscriptFacts", "query", "outcome_kind", RequestParamSchema6, params.outcome_kind, this._strictValidation);
        validateRequestParam("listTranscriptFacts", "query", "escalation_kind", RequestParamSchema6, params.escalation_kind, this._strictValidation);
        validateRequestParam("listTranscriptFacts", "query", "started_at_gte", RequestParamSchema31, params.started_at_gte, this._strictValidation);
        validateRequestParam("listTranscriptFacts", "query", "started_at_lte", RequestParamSchema31, params.started_at_lte, this._strictValidation);
        validateRequestParam("listTranscriptFacts", "query", "received_at_gte", RequestParamSchema31, params.received_at_gte, this._strictValidation);
        validateRequestParam("listTranscriptFacts", "query", "received_at_lte", RequestParamSchema31, params.received_at_lte, this._strictValidation);
        const path = `/api/transcript-facts`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "deployment_slug", params.deployment_slug, true);
        appendQueryParam(url, "tenant_slug", params.tenant_slug, true);
        appendQueryParam(url, "transcript_id", params.transcript_id, true);
        appendQueryParam(url, "flow_id", params.flow_id, true);
        appendQueryParam(url, "platform", params.platform, true);
        appendQueryParam(url, "environment", params.environment, true);
        appendQueryParam(url, "direction", params.direction, true);
        appendQueryParam(url, "outcome_kind", params.outcome_kind, true);
        appendQueryParam(url, "escalation_kind", params.escalation_kind, true);
        appendQueryParam(url, "started_at_gte", params.started_at_gte, false);
        appendQueryParam(url, "started_at_lte", params.started_at_lte, false);
        appendQueryParam(url, "received_at_gte", params.received_at_gte, false);
        appendQueryParam(url, "received_at_lte", params.received_at_lte, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(TranscriptFactsListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** List usage-facts */
    async listUsageFacts(params = {}, options) {
        validateRequestParam("listUsageFacts", "query", "sort", RequestParamSchema6, params.sort, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "limit", RequestParamSchema37, params.limit, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "offset", RequestParamSchema37, params.offset, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "deployment_slug", RequestParamSchema6, params.deployment_slug, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "tenant_slug", RequestParamSchema6, params.tenant_slug, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "transcript_id", RequestParamSchema6, params.transcript_id, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "provider", RequestParamSchema6, params.provider, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "operation", RequestParamSchema6, params.operation, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "feature", RequestParamSchema6, params.feature, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "product", RequestParamSchema6, params.product, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "model", RequestParamSchema6, params.model, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "status", RequestParamSchema6, params.status, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "usage_source", RequestParamSchema6, params.usage_source, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "hedge_role", RequestParamSchema6, params.hedge_role, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "request_id", RequestParamSchema6, params.request_id, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "occurred_at_gte", RequestParamSchema31, params.occurred_at_gte, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "occurred_at_lte", RequestParamSchema31, params.occurred_at_lte, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "received_at_gte", RequestParamSchema31, params.received_at_gte, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "received_at_lte", RequestParamSchema31, params.received_at_lte, this._strictValidation);
        validateRequestParam("listUsageFacts", "query", "q", RequestParamSchema1, params.q, this._strictValidation);
        const path = `/api/usage-facts`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "sort", params.sort, true);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        appendQueryParam(url, "deployment_slug", params.deployment_slug, true);
        appendQueryParam(url, "tenant_slug", params.tenant_slug, true);
        appendQueryParam(url, "transcript_id", params.transcript_id, true);
        appendQueryParam(url, "provider", params.provider, true);
        appendQueryParam(url, "operation", params.operation, true);
        appendQueryParam(url, "feature", params.feature, true);
        appendQueryParam(url, "product", params.product, true);
        appendQueryParam(url, "model", params.model, true);
        appendQueryParam(url, "status", params.status, true);
        appendQueryParam(url, "usage_source", params.usage_source, true);
        appendQueryParam(url, "hedge_role", params.hedge_role, true);
        appendQueryParam(url, "request_id", params.request_id, true);
        appendQueryParam(url, "occurred_at_gte", params.occurred_at_gte, false);
        appendQueryParam(url, "occurred_at_lte", params.occurred_at_lte, false);
        appendQueryParam(url, "received_at_gte", params.received_at_gte, false);
        appendQueryParam(url, "received_at_lte", params.received_at_lte, false);
        appendQueryParam(url, "q", params.q, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(UsageFactsListSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Try an interpretation before saving it */
    async previewDealStatement(params, options) {
        validateRequestParam("previewDealStatement", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        const path = `/api/deals/${encodeURIComponent(String(params.id))}/statement/preview`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(DealStatementSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Re-derive notes' passages and queue them for embedding */
    async reembedNotes(params, options) {
        validateRequestParam("reembedNotes", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/notes/reembed`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(NotesReembedResultSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** refresh invoice lines */
    async refreshInvoiceLines(params, options) {
        validateRequestParam("refreshInvoiceLines", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("refreshInvoiceLines", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/invoices/${encodeURIComponent(String(params.id))}/refresh`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        const init = { method: "POST", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(RefreshInvoiceLinesResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** bill-run */
    async reportBillRun(params = {}, options) {
        validateRequestParam("reportBillRun", "query", "currency", CurrencySchema, params.currency, this._strictValidation);
        validateRequestParam("reportBillRun", "query", "partner_id", RequestParamSchema1, params.partner_id, this._strictValidation);
        validateRequestParam("reportBillRun", "query", "scope", ReportScopeSchema, params.scope, this._strictValidation);
        validateRequestParam("reportBillRun", "query", "as_of", RequestParamSchema31, params.as_of, this._strictValidation);
        validateRequestParam("reportBillRun", "query", "horizon_days", RequestParamSchema38, params.horizon_days, this._strictValidation);
        const path = `/api/reports/bill-run`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "currency", params.currency, false);
        appendQueryParam(url, "partner_id", params.partner_id, false);
        appendQueryParam(url, "scope", params.scope, false);
        appendQueryParam(url, "as_of", params.as_of, false);
        appendQueryParam(url, "horizon_days", params.horizon_days, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(BillRunReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** billing-lineup */
    async reportBillingLineup(params = {}, options) {
        validateRequestParam("reportBillingLineup", "query", "currency", CurrencySchema, params.currency, this._strictValidation);
        validateRequestParam("reportBillingLineup", "query", "partner_id", RequestParamSchema1, params.partner_id, this._strictValidation);
        validateRequestParam("reportBillingLineup", "query", "scope", ReportScopeSchema, params.scope, this._strictValidation);
        validateRequestParam("reportBillingLineup", "query", "weeks", RequestParamSchema39, params.weeks, this._strictValidation);
        validateRequestParam("reportBillingLineup", "query", "from_date", RequestParamSchema31, params.from_date, this._strictValidation);
        validateRequestParam("reportBillingLineup", "query", "include_costs", RequestParamSchema27, params.include_costs, this._strictValidation);
        const path = `/api/reports/billing-lineup`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "currency", params.currency, false);
        appendQueryParam(url, "partner_id", params.partner_id, false);
        appendQueryParam(url, "scope", params.scope, false);
        appendQueryParam(url, "weeks", params.weeks, false);
        appendQueryParam(url, "from_date", params.from_date, false);
        appendQueryParam(url, "include_costs", params.include_costs, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(BillingLineupReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** calendar */
    async reportCalendar(params = {}, options) {
        validateRequestParam("reportCalendar", "query", "currency", CurrencySchema, params.currency, this._strictValidation);
        validateRequestParam("reportCalendar", "query", "partner_id", RequestParamSchema1, params.partner_id, this._strictValidation);
        validateRequestParam("reportCalendar", "query", "scope", ReportScopeSchema, params.scope, this._strictValidation);
        validateRequestParam("reportCalendar", "query", "from_date", RequestParamSchema31, params.from_date, this._strictValidation);
        validateRequestParam("reportCalendar", "query", "to_date", RequestParamSchema31, params.to_date, this._strictValidation);
        validateRequestParam("reportCalendar", "query", "event_kind", RequestParamSchema40, params.event_kind, this._strictValidation);
        validateRequestParam("reportCalendar", "query", "deal_id", RequestParamSchema1, params.deal_id, this._strictValidation);
        validateRequestParam("reportCalendar", "query", "unbilled_only", RequestParamSchema27, params.unbilled_only, this._strictValidation);
        const path = `/api/reports/calendar`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "currency", params.currency, false);
        appendQueryParam(url, "partner_id", params.partner_id, false);
        appendQueryParam(url, "scope", params.scope, false);
        appendQueryParam(url, "from_date", params.from_date, false);
        appendQueryParam(url, "to_date", params.to_date, false);
        appendQueryParam(url, "event_kind", params.event_kind, true);
        appendQueryParam(url, "deal_id", params.deal_id, false);
        appendQueryParam(url, "unbilled_only", params.unbilled_only, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(CalendarReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** closing pace */
    async reportClosingPace(params = {}, options) {
        validateRequestParam("reportClosingPace", "query", "months", RequestParamSchema41, params.months, this._strictValidation);
        const path = `/api/reports/closing-pace`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "months", params.months, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ClosingPaceSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** drift */
    async reportDrift(params = {}, options) {
        validateRequestParam("reportDrift", "query", "currency", CurrencySchema, params.currency, this._strictValidation);
        validateRequestParam("reportDrift", "query", "partner_id", RequestParamSchema1, params.partner_id, this._strictValidation);
        validateRequestParam("reportDrift", "query", "scope", ReportScopeSchema, params.scope, this._strictValidation);
        validateRequestParam("reportDrift", "query", "due_date_gte", RequestParamSchema31, params.due_date_gte, this._strictValidation);
        validateRequestParam("reportDrift", "query", "due_date_lte", RequestParamSchema31, params.due_date_lte, this._strictValidation);
        validateRequestParam("reportDrift", "query", "deal_id", RequestParamSchema1, params.deal_id, this._strictValidation);
        validateRequestParam("reportDrift", "query", "min_abs_variance_pct", RequestParamSchema42, params.min_abs_variance_pct, this._strictValidation);
        validateRequestParam("reportDrift", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("reportDrift", "query", "offset", RequestParamSchema9, params.offset, this._strictValidation);
        const path = `/api/reports/drift`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "currency", params.currency, false);
        appendQueryParam(url, "partner_id", params.partner_id, false);
        appendQueryParam(url, "scope", params.scope, false);
        appendQueryParam(url, "due_date_gte", params.due_date_gte, false);
        appendQueryParam(url, "due_date_lte", params.due_date_lte, false);
        appendQueryParam(url, "deal_id", params.deal_id, false);
        appendQueryParam(url, "min_abs_variance_pct", params.min_abs_variance_pct, false);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "offset", params.offset, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(DriftReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** implementation-fee */
    async reportImplementationFee(params = {}, options) {
        validateRequestParam("reportImplementationFee", "query", "currency", CurrencySchema, params.currency, this._strictValidation);
        validateRequestParam("reportImplementationFee", "query", "partner_id", RequestParamSchema1, params.partner_id, this._strictValidation);
        validateRequestParam("reportImplementationFee", "query", "scope", ReportScopeSchema, params.scope, this._strictValidation);
        validateRequestParam("reportImplementationFee", "query", "deal_id", RequestParamSchema1, params.deal_id, this._strictValidation);
        validateRequestParam("reportImplementationFee", "query", "state", RequestParamSchema16, params.state, this._strictValidation);
        validateRequestParam("reportImplementationFee", "query", "unresolved_only", RequestParamSchema27, params.unresolved_only, this._strictValidation);
        const path = `/api/reports/implementation-fee`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "currency", params.currency, false);
        appendQueryParam(url, "partner_id", params.partner_id, false);
        appendQueryParam(url, "scope", params.scope, false);
        appendQueryParam(url, "deal_id", params.deal_id, false);
        appendQueryParam(url, "state", params.state, true);
        appendQueryParam(url, "unresolved_only", params.unresolved_only, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ImplementationFeeReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Export the ledger as beancount */
    async reportLedger(params, options) {
        validateRequestParam("reportLedger", "query", "from", RequestParamSchema2, params.from, this._strictValidation);
        validateRequestParam("reportLedger", "query", "to", RequestParamSchema2, params.to, this._strictValidation);
        const path = `/api/reports/ledger`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "from", params.from, false);
        appendQueryParam(url, "to", params.to, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(LedgerReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** margin */
    async reportMargin(params, options) {
        validateRequestParam("reportMargin", "query", "period", RequestParamSchema2, params.period, this._strictValidation);
        validateRequestParam("reportMargin", "query", "partner_id", RequestParamSchema1, params.partner_id, this._strictValidation);
        validateRequestParam("reportMargin", "query", "scope", ReportScopeSchema, params.scope, this._strictValidation);
        validateRequestParam("reportMargin", "query", "currency", CurrencySchema, params.currency, this._strictValidation);
        const path = `/api/reports/margin`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "period", params.period, false);
        appendQueryParam(url, "partner_id", params.partner_id, false);
        appendQueryParam(url, "scope", params.scope, false);
        appendQueryParam(url, "currency", params.currency, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(MarginReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** margin trend */
    async reportMarginTrend(params = {}, options) {
        validateRequestParam("reportMarginTrend", "query", "from_month", RequestParamSchema2, params.from_month, this._strictValidation);
        validateRequestParam("reportMarginTrend", "query", "to_month", RequestParamSchema2, params.to_month, this._strictValidation);
        validateRequestParam("reportMarginTrend", "query", "partner_id", RequestParamSchema1, params.partner_id, this._strictValidation);
        validateRequestParam("reportMarginTrend", "query", "scope", ReportScopeSchema, params.scope, this._strictValidation);
        validateRequestParam("reportMarginTrend", "query", "currency", CurrencySchema, params.currency, this._strictValidation);
        const path = `/api/reports/margin-trend`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "from_month", params.from_month, false);
        appendQueryParam(url, "to_month", params.to_month, false);
        appendQueryParam(url, "partner_id", params.partner_id, false);
        appendQueryParam(url, "scope", params.scope, false);
        appendQueryParam(url, "currency", params.currency, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(MarginTrendReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** month-close */
    async reportMonthClose(params, options) {
        validateRequestParam("reportMonthClose", "query", "partner_id", RequestParamSchema1, params.partner_id, this._strictValidation);
        validateRequestParam("reportMonthClose", "query", "scope", ReportScopeSchema, params.scope, this._strictValidation);
        validateRequestParam("reportMonthClose", "query", "period", RequestParamSchema2, params.period, this._strictValidation);
        validateRequestParam("reportMonthClose", "query", "currency", CurrencySchema, params.currency, this._strictValidation);
        const path = `/api/reports/month-close`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "partner_id", params.partner_id, false);
        appendQueryParam(url, "scope", params.scope, false);
        appendQueryParam(url, "period", params.period, false);
        appendQueryParam(url, "currency", params.currency, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(MonthCloseReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** partner-rollup */
    async reportPartnerRollup(params = {}, options) {
        validateRequestParam("reportPartnerRollup", "query", "currency", CurrencySchema, params.currency, this._strictValidation);
        validateRequestParam("reportPartnerRollup", "query", "partner_id", RequestParamSchema1, params.partner_id, this._strictValidation);
        validateRequestParam("reportPartnerRollup", "query", "scope", ReportScopeSchema, params.scope, this._strictValidation);
        const path = `/api/reports/partner-rollup`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "currency", params.currency, false);
        appendQueryParam(url, "partner_id", params.partner_id, false);
        appendQueryParam(url, "scope", params.scope, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(PartnerRollupReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** pipeline */
    async reportPipeline(params = {}, options) {
        validateRequestParam("reportPipeline", "query", "currency", CurrencySchema, params.currency, this._strictValidation);
        validateRequestParam("reportPipeline", "query", "partner_id", RequestParamSchema1, params.partner_id, this._strictValidation);
        validateRequestParam("reportPipeline", "query", "scope", ReportScopeSchema, params.scope, this._strictValidation);
        validateRequestParam("reportPipeline", "query", "from_month", RequestParamSchema2, params.from_month, this._strictValidation);
        validateRequestParam("reportPipeline", "query", "to_month", RequestParamSchema2, params.to_month, this._strictValidation);
        validateRequestParam("reportPipeline", "query", "state", RequestParamSchema16, params.state, this._strictValidation);
        const path = `/api/reports/pipeline`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "currency", params.currency, false);
        appendQueryParam(url, "partner_id", params.partner_id, false);
        appendQueryParam(url, "scope", params.scope, false);
        appendQueryParam(url, "from_month", params.from_month, false);
        appendQueryParam(url, "to_month", params.to_month, false);
        appendQueryParam(url, "state", params.state, true);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(PipelineReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** projection */
    async reportProjection(params = {}, options) {
        validateRequestParam("reportProjection", "query", "currency", CurrencySchema, params.currency, this._strictValidation);
        validateRequestParam("reportProjection", "query", "partner_id", RequestParamSchema1, params.partner_id, this._strictValidation);
        validateRequestParam("reportProjection", "query", "scope", ReportScopeSchema, params.scope, this._strictValidation);
        validateRequestParam("reportProjection", "query", "from_month", RequestParamSchema2, params.from_month, this._strictValidation);
        validateRequestParam("reportProjection", "query", "to_month", RequestParamSchema2, params.to_month, this._strictValidation);
        validateRequestParam("reportProjection", "query", "go_lives_per_month", RequestParamSchema43, params.go_lives_per_month, this._strictValidation);
        validateRequestParam("reportProjection", "query", "monthly_growth_pct", RequestParamSchema44, params.monthly_growth_pct, this._strictValidation);
        validateRequestParam("reportProjection", "query", "margin_pct", RequestParamSchema45, params.margin_pct, this._strictValidation);
        validateRequestParam("reportProjection", "query", "assumed_split_pct", RequestParamSchema46, params.assumed_split_pct, this._strictValidation);
        validateRequestParam("reportProjection", "query", "implementation_lead_months", RequestParamSchema47, params.implementation_lead_months, this._strictValidation);
        validateRequestParam("reportProjection", "query", "implementation_kickoff_pct", RequestParamSchema46, params.implementation_kickoff_pct, this._strictValidation);
        validateRequestParam("reportProjection", "query", "include_costs", RequestParamSchema27, params.include_costs, this._strictValidation);
        const path = `/api/reports/projection`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "currency", params.currency, false);
        appendQueryParam(url, "partner_id", params.partner_id, false);
        appendQueryParam(url, "scope", params.scope, false);
        appendQueryParam(url, "from_month", params.from_month, false);
        appendQueryParam(url, "to_month", params.to_month, false);
        appendQueryParam(url, "go_lives_per_month", params.go_lives_per_month, false);
        appendQueryParam(url, "monthly_growth_pct", params.monthly_growth_pct, false);
        appendQueryParam(url, "margin_pct", params.margin_pct, false);
        appendQueryParam(url, "assumed_split_pct", params.assumed_split_pct, false);
        appendQueryParam(url, "implementation_lead_months", params.implementation_lead_months, false);
        appendQueryParam(url, "implementation_kickoff_pct", params.implementation_kickoff_pct, false);
        appendQueryParam(url, "include_costs", params.include_costs, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ProjectionReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** revenue-by-region */
    async reportRevenueByRegion(params = {}, options) {
        validateRequestParam("reportRevenueByRegion", "query", "currency", CurrencySchema, params.currency, this._strictValidation);
        validateRequestParam("reportRevenueByRegion", "query", "partner_id", RequestParamSchema1, params.partner_id, this._strictValidation);
        validateRequestParam("reportRevenueByRegion", "query", "scope", ReportScopeSchema, params.scope, this._strictValidation);
        validateRequestParam("reportRevenueByRegion", "query", "group_by", RevenueByRegionGroupBySchema, params.group_by, this._strictValidation);
        const path = `/api/reports/revenue-by-region`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "currency", params.currency, false);
        appendQueryParam(url, "partner_id", params.partner_id, false);
        appendQueryParam(url, "scope", params.scope, false);
        appendQueryParam(url, "group_by", params.group_by, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(RevenueByRegionReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** runway */
    async reportRunway(params = {}, options) {
        validateRequestParam("reportRunway", "query", "partner_id", RequestParamSchema1, params.partner_id, this._strictValidation);
        validateRequestParam("reportRunway", "query", "scope", ReportScopeSchema, params.scope, this._strictValidation);
        validateRequestParam("reportRunway", "query", "as_of", RequestParamSchema31, params.as_of, this._strictValidation);
        validateRequestParam("reportRunway", "query", "deal_id", RequestParamSchema1, params.deal_id, this._strictValidation);
        validateRequestParam("reportRunway", "query", "include_complete", RequestParamSchema27, params.include_complete, this._strictValidation);
        const path = `/api/reports/runway`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "partner_id", params.partner_id, false);
        appendQueryParam(url, "scope", params.scope, false);
        appendQueryParam(url, "as_of", params.as_of, false);
        appendQueryParam(url, "deal_id", params.deal_id, false);
        appendQueryParam(url, "include_complete", params.include_complete, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(RunwayReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** sales */
    async reportSales(params = {}, options) {
        validateRequestParam("reportSales", "query", "currency", CurrencySchema, params.currency, this._strictValidation);
        validateRequestParam("reportSales", "query", "partner_id", RequestParamSchema1, params.partner_id, this._strictValidation);
        validateRequestParam("reportSales", "query", "scope", ReportScopeSchema, params.scope, this._strictValidation);
        validateRequestParam("reportSales", "query", "from", RequestParamSchema31, params.from, this._strictValidation);
        validateRequestParam("reportSales", "query", "to", RequestParamSchema31, params.to, this._strictValidation);
        validateRequestParam("reportSales", "query", "bucket", SalesBucketSchema, params.bucket, this._strictValidation);
        validateRequestParam("reportSales", "query", "cold_days", RequestParamSchema48, params.cold_days, this._strictValidation);
        const path = `/api/reports/sales`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "currency", params.currency, false);
        appendQueryParam(url, "partner_id", params.partner_id, false);
        appendQueryParam(url, "scope", params.scope, false);
        appendQueryParam(url, "from", params.from, false);
        appendQueryParam(url, "to", params.to, false);
        appendQueryParam(url, "bucket", params.bucket, false);
        appendQueryParam(url, "cold_days", params.cold_days, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(SalesReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** trends */
    async reportTrends(params = {}, options) {
        validateRequestParam("reportTrends", "query", "currency", CurrencySchema, params.currency, this._strictValidation);
        validateRequestParam("reportTrends", "query", "partner_id", RequestParamSchema1, params.partner_id, this._strictValidation);
        validateRequestParam("reportTrends", "query", "scope", ReportScopeSchema, params.scope, this._strictValidation);
        validateRequestParam("reportTrends", "query", "from_month", RequestParamSchema2, params.from_month, this._strictValidation);
        validateRequestParam("reportTrends", "query", "to_month", RequestParamSchema2, params.to_month, this._strictValidation);
        const path = `/api/reports/trends`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "currency", params.currency, false);
        appendQueryParam(url, "partner_id", params.partner_id, false);
        appendQueryParam(url, "scope", params.scope, false);
        appendQueryParam(url, "from_month", params.from_month, false);
        appendQueryParam(url, "to_month", params.to_month, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(TrendsReportSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** What a month of usage cost, broken down */
    async reportUsageCost(params, options) {
        validateRequestParam("reportUsageCost", "query", "period", RequestParamSchema1, params.period, this._strictValidation);
        validateRequestParam("reportUsageCost", "query", "group_by", UsageCostGroupBySchema, params.group_by, this._strictValidation);
        validateRequestParam("reportUsageCost", "query", "tenant_slug", RequestParamSchema1, params.tenant_slug, this._strictValidation);
        validateRequestParam("reportUsageCost", "query", "deployment_slug", RequestParamSchema1, params.deployment_slug, this._strictValidation);
        validateRequestParam("reportUsageCost", "query", "limit", RequestParamSchema8, params.limit, this._strictValidation);
        validateRequestParam("reportUsageCost", "query", "sort", UsageCostSortSchema, params.sort, this._strictValidation);
        validateRequestParam("reportUsageCost", "query", "currency", CurrencySchema, params.currency, this._strictValidation);
        const path = `/api/reports/usage-cost`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "period", params.period, false);
        appendQueryParam(url, "group_by", params.group_by, false);
        appendQueryParam(url, "tenant_slug", params.tenant_slug, false);
        appendQueryParam(url, "deployment_slug", params.deployment_slug, false);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "sort", params.sort, false);
        appendQueryParam(url, "currency", params.currency, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(UsageCostResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 202: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(UsageCostPendingSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 202, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Usage cost month by month, one line per tenant, category, provider, model or deployment */
    async reportUsageTrend(params, options) {
        validateRequestParam("reportUsageTrend", "query", "period_from", RequestParamSchema2, params.period_from, this._strictValidation);
        validateRequestParam("reportUsageTrend", "query", "period_to", RequestParamSchema2, params.period_to, this._strictValidation);
        validateRequestParam("reportUsageTrend", "query", "deployment_slug", RequestParamSchema1, params.deployment_slug, this._strictValidation);
        validateRequestParam("reportUsageTrend", "query", "tenant_slug", RequestParamSchema49, params.tenant_slug, this._strictValidation);
        validateRequestParam("reportUsageTrend", "query", "group_by", UsageTrendGroupBySchema, params.group_by, this._strictValidation);
        validateRequestParam("reportUsageTrend", "query", "limit", RequestParamSchema50, params.limit, this._strictValidation);
        validateRequestParam("reportUsageTrend", "query", "currency", CurrencySchema, params.currency, this._strictValidation);
        const path = `/api/reports/usage-trend`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "period_from", params.period_from, false);
        appendQueryParam(url, "period_to", params.period_to, false);
        appendQueryParam(url, "deployment_slug", params.deployment_slug, false);
        appendQueryParam(url, "tenant_slug", params.tenant_slug, true);
        appendQueryParam(url, "group_by", params.group_by, false);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "currency", params.currency, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(UsageTrendResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Search notes */
    async searchNotes(params, options) {
        validateRequestParam("searchNotes", "query", "q", RequestParamSchema4, params.q, this._strictValidation);
        validateRequestParam("searchNotes", "query", "limit", RequestParamSchema5, params.limit, this._strictValidation);
        validateRequestParam("searchNotes", "query", "deal_id", RequestParamSchema6, params.deal_id, this._strictValidation);
        validateRequestParam("searchNotes", "query", "kind", RequestParamSchema6, params.kind, this._strictValidation);
        validateRequestParam("searchNotes", "query", "include_unfiled", RequestParamSchema27, params.include_unfiled, this._strictValidation);
        validateRequestParam("searchNotes", "query", "occurred_at_gte", RequestParamSchema1, params.occurred_at_gte, this._strictValidation);
        validateRequestParam("searchNotes", "query", "occurred_at_lte", RequestParamSchema1, params.occurred_at_lte, this._strictValidation);
        const path = `/api/notes/search`;
        const url = new URL(path, this.opts.baseUrl);
        appendQueryParam(url, "q", params.q, false);
        appendQueryParam(url, "limit", params.limit, false);
        appendQueryParam(url, "deal_id", params.deal_id, true);
        appendQueryParam(url, "kind", params.kind, true);
        appendQueryParam(url, "include_unfiled", params.include_unfiled, false);
        appendQueryParam(url, "occurred_at_gte", params.occurred_at_gte, false);
        appendQueryParam(url, "occurred_at_lte", params.occurred_at_lte, false);
        const headers = new Headers(this.opts.headers);
        mergeHeaders(headers, options?.headers);
        const init = { method: "GET", headers, signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(NoteSearchResultsSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Put a price in force, superseding the one before it */
    async setProviderRate(params, options) {
        validateRequestParam("setProviderRate", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/provider-rates/set`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(SetProviderRateResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Ask for a usage rollup refresh */
    async startUsageJob(params, options) {
        validateRequestParam("startUsageJob", "header", "Idempotency-Key", RequestParamSchema0, params["Idempotency-Key"], this._strictValidation);
        const path = `/api/reports/usage-jobs`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["Idempotency-Key"];
            if (v !== undefined && v !== null)
                headers.set("Idempotency-Key", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "POST", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 202: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(UsageJobSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 202, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Update a agreement-impl-fee-tiers record */
    async updateAgreementImplFeeTiers(params, options) {
        validateRequestParam("updateAgreementImplFeeTiers", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("updateAgreementImplFeeTiers", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/agreement-impl-fee-tiers/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "PATCH", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(AgreementImplFeeTiersItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            case 428: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 428, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Update a agreement-terms record */
    async updateAgreementTerms(params, options) {
        validateRequestParam("updateAgreementTerms", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("updateAgreementTerms", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/agreement-terms/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "PATCH", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(AgreementTermsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            case 428: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 428, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Update a agreements record */
    async updateAgreements(params, options) {
        validateRequestParam("updateAgreements", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("updateAgreements", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/agreements/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "PATCH", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(AgreementsDetailSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            case 428: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 428, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Update a billing-contacts record */
    async updateBillingContacts(params, options) {
        validateRequestParam("updateBillingContacts", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("updateBillingContacts", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/billing-contacts/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "PATCH", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(BillingContactsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            case 428: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 428, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Update a deals record */
    async updateDeals(params, options) {
        validateRequestParam("updateDeals", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("updateDeals", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/deals/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "PATCH", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(DealsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            case 428: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 428, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Update a fx-rates record */
    async updateFxRates(params, options) {
        validateRequestParam("updateFxRates", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("updateFxRates", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/fx-rates/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "PATCH", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(FxRatesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            case 428: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 428, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Update a invoice-lines record */
    async updateInvoiceLines(params, options) {
        validateRequestParam("updateInvoiceLines", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("updateInvoiceLines", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/invoice-lines/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "PATCH", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(InvoiceLinesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            case 428: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 428, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Update a invoices record */
    async updateInvoices(params, options) {
        validateRequestParam("updateInvoices", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("updateInvoices", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/invoices/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "PATCH", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(InvoicesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            case 428: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 428, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Update a note */
    async updateNotes(params, options) {
        validateRequestParam("updateNotes", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("updateNotes", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/notes/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "PATCH", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(NotesDetailSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            case 428: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 428, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Update a partners record */
    async updatePartners(params, options) {
        validateRequestParam("updatePartners", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("updatePartners", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/partners/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "PATCH", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(PartnersItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            case 428: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 428, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Update a prepaid-entitlement record */
    async updatePrepaidEntitlements(params, options) {
        validateRequestParam("updatePrepaidEntitlements", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("updatePrepaidEntitlements", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/prepaid-entitlements/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "PATCH", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(PrepaidEntitlementsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            case 428: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 428, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Change the projection assumptions */
    async updateProjectionSettings(params, options) {
        validateRequestParam("updateProjectionSettings", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/projection-settings`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "PATCH", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ProjectionSettingsSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            case 428: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 428, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Update a provider-rates record */
    async updateProviderRates(params, options) {
        validateRequestParam("updateProviderRates", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("updateProviderRates", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/provider-rates/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "PATCH", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ProviderRatesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            case 428: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 428, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Update a tenant-bindings record */
    async updateTenantBindings(params, options) {
        validateRequestParam("updateTenantBindings", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("updateTenantBindings", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/tenant-bindings/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "PATCH", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(TenantBindingsItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            case 428: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 428, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
    /** Update a term-line record */
    async updateTermLines(params, options) {
        validateRequestParam("updateTermLines", "path", "id", RequestParamSchema1, params.id, this._strictValidation);
        validateRequestParam("updateTermLines", "header", "If-Match", RequestParamSchema1, params["If-Match"], this._strictValidation);
        const path = `/api/term-lines/${encodeURIComponent(String(params.id))}`;
        const url = new URL(path, this.opts.baseUrl);
        const headers = new Headers(this.opts.headers);
        {
            const v = params["If-Match"];
            if (v !== undefined && v !== null)
                headers.set("If-Match", String(v));
        }
        mergeHeaders(headers, options?.headers);
        headers.set("content-type", "application/json");
        const init = { method: "PATCH", headers, body: JSON.stringify(params.body), signal: options?.signal };
        let res;
        try {
            res = await this._fetch(url, init);
        }
        catch (cause) {
            throw new ApiError({ kind: "network", cause });
        }
        switch (res.status) {
            case 200: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(TermLinesItemSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 200, body, headers: res.headers };
            }
            case 400: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 400, body, headers: res.headers };
            }
            case 401: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 401, body, headers: res.headers };
            }
            case 403: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 403, body, headers: res.headers };
            }
            case 404: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 404, body, headers: res.headers };
            }
            case 409: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 409, body, headers: res.headers };
            }
            case 422: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 422, body, headers: res.headers };
            }
            case 428: {
                assertJsonContentType(res);
                const raw = await res.text();
                const body = validateBody(ErrorResponseSchema, parseJsonBody(raw, res), res, this._strictValidation);
                return { status: 428, body, headers: res.headers };
            }
            default: {
                const raw = await res.text();
                throw new ApiError({ kind: "undeclared-status", status: res.status, statusText: res.statusText, headers: res.headers, body: raw });
            }
        }
    }
}
//# sourceMappingURL=client.js.map